/**!
 * Mineral UI
 * Copyright 2017 CA
 * License: Apache-2.0
 */
webpackJsonp([9],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyledComponent__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStyledComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNormalizedValue__ = __webpack_require__(200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__getNormalizedValue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getResponsiveStyles__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__getResponsiveStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pxToEm__ = __webpack_require__(194);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__pxToEm__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createColorRamp__ = __webpack_require__(193);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__createColorRamp__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createTheme__ = __webpack_require__(191);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__createTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createThemedComponent__ = __webpack_require__(432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__createThemedComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fontSizeBase__ = __webpack_require__(129);
/* unused harmony reexport fontSizeBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapComponentThemes__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__mapComponentThemes__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mineralTheme__ = __webpack_require__(190);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__mineralTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(113);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Markdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marksy_components__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_marksy_components___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_marksy_components__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_darken__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_darken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_darken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SiteHeading__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Paragraph__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SiteLink__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MarkdownTable__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getCodeBlockStyles__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_prism__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Label__ = __webpack_require__(211);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */














var REGEX_LABEL_DELIMITER = /\s*~\s*/;

var styles = {
  codeBlock: function codeBlock(_ref) {
    var theme = _ref.theme;
    return {
      marginBottom: theme.space_stack_xl
    };
  },
  image: {
    '@media(max-width: 60rem)': {
      width: '100%'
    }
  },
  label: function label(_ref2) {
    var theme = _ref2.theme;
    return {
      marginLeft: theme.space_inline_sm
    };
  },
  listItem: function listItem(_ref3) {
    var theme = _ref3.theme;
    return {
      marginBottom: theme.space_stack_sm
    };
  },
  root: function root(_ref4) {
    var _h, _h2;

    var theme = _ref4.theme;
    return {
      lineHeight: theme.lineHeight_prose,
      position: 'relative', // for baseline grid,

      '& p, & ol, & ul': {
        margin: parseFloat(theme.fontSize_prose) * theme.lineHeight_prose + 'em 0',
        maxWidth: theme.maxTextWidth,

        '&:first-child': {
          marginTop: 0
        }
      },

      '& h2': (_h = {
        fontSize: theme.SiteHeading_fontSize_2,
        margin: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(21), // to baseline
        theme.SiteHeading_fontSize_2) + ' 0'

      }, _defineProperty(_h, theme.bp_moreSpacious, {
        fontSize: theme.SiteHeading_fontSize_2_wide,
        margin: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(19), // to baseline
        theme.SiteHeading_fontSize_2_wide) + ' 0',
        maxWidth: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(theme.maxTextWidth, theme.SiteHeading_fontSize_2_wide)
      }), _defineProperty(_h, '& + p', {
        marginTop: 0
      }), _h),

      '& h3': (_h2 = {
        fontSize: theme.SiteHeading_fontSize_3,
        margin: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(21), // to baseline
        theme.SiteHeading_fontSize_3) + ' 0 ' + Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(21 - 12), // to mid-baseline
        theme.SiteHeading_fontSize_3)

      }, _defineProperty(_h2, theme.bp_moreSpacious, {
        fontSize: theme.SiteHeading_fontSize_3_wide,
        margin: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(19), // to baseline
        theme.SiteHeading_fontSize_3_wide) + ' 0 ' + Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(19 - 12), // to mid-baseline
        theme.SiteHeading_fontSize_3_wide),
        maxWidth: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(theme.maxTextWidth, theme.SiteHeading_fontSize_3_wide)
      }), _defineProperty(_h2, '& + p', {
        marginTop: 0
      }), _h2),

      '& * + h2': _defineProperty({
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(83), // to baseline
        theme.SiteHeading_fontSize_2)

      }, theme.bp_moreSpacious, {
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(101), // to baseline
        theme.SiteHeading_fontSize_2_wide)
      }),

      '& * + h3': _defineProperty({
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(65), // to baseline
        theme.SiteHeading_fontSize_3)

      }, theme.bp_moreSpacious, {
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(82), // to baseline
        theme.SiteHeading_fontSize_3_wide)
      }),

      '& h2 + h3': _defineProperty({
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(55), // to baseline
        theme.SiteHeading_fontSize_3)

      }, theme.bp_moreSpacious, {
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(55), // to baseline
        theme.SiteHeading_fontSize_3_wide)
      }),

      // Specificity silliness due to having to style markdown content off of the
      // container
      '& h2,& h3,& h4,& h5,& h6': {
        '& > a:link': {
          color: theme.color_caption,
          fontWeight: 'inherit'
        },
        '& > a:hover': {
          color: theme.SiteLink_color_hover || theme.color_text_primary_hover
        },
        '& > a:focus': {
          color: theme.SiteLink_color_focus || theme.color_text_primary_focus
        },
        // `:active` must be last, to follow LVHFA order:
        // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
        '& > a:active': {
          color: theme.SiteLink_color_active || theme.color_text_primary_active
        },

        '& code': {
          wordBreak: 'break-all'
        }
      },

      '& pre': _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_getCodeBlockStyles__["a" /* default */])(theme), {
        // to baseline
        margin: Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(31), theme.fontSize_ui) + ' 0\n        ' + Object(__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* pxToEm */])(42), theme.fontSize_ui)
      }),

      '& :not(pre) > code': {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba___default()(theme.color_text_primary, 0.15),
        color: __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_darken___default()(0.1, theme.color_text_primary),
        direction: 'ltr',
        fontFamily: theme.fontFamily_monospace,
        fontSize: '0.8em',
        fontWeight: '500',
        hyphens: 'none',
        padding: parseFloat(theme.space_inset_sm) / 2 + 'em',
        wordBreak: 'normal',
        wordSpacing: 'normal',
        wordWrap: 'normal'
      },

      '& > p > img': {
        maxWidth: '100%'
      }
    };
  }
};

var CodeBlock = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('div', styles.codeBlock);
var Image = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('img', styles.image);
var Label = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_11__Label__["a" /* default */], styles.label);
var LI = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('li', styles.listItem);
var Root = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('div', styles.root);

function replaceHeading(level, children, headingProps, anchors) {
  // Render the same props and children that were passed in, but prepend a
  // link to this title with the text '#'.
  return _jsx(__WEBPACK_IMPORTED_MODULE_5__SiteHeading__["a" /* default */], {
    anchor: anchors,
    level: level,
    id: headingProps.id
  }, void 0, children);
}

function ListItem(_ref5) {
  var children = _ref5.children;

  var newChildren = children.map(function (child) {
    if (child && child.split) {
      var _child$split = child.split(REGEX_LABEL_DELIMITER),
          _child$split2 = _slicedToArray(_child$split, 2),
          preLabelText = _child$split2[0],
          labelText = _child$split2[1];

      if (!labelText) {
        return child;
      }

      var labelVariant = 'done' === labelText ? 'success' : 'regular';

      return [preLabelText, _jsx(Label, {
        variant: labelVariant
      }, 1, labelText)];
    } else {
      return child;
    }
  });
  return _jsx(LI, {}, void 0, newChildren);
}

/**
 * Matches if:
 * (doesn't start with one or more dots &&
 *    (contains dot anywhere but the first character || starts with a hash)
 * )
 *
 * Should match:
 * http://non-routed-link.com,
 * http://non-routed-link.com#anchor
 * #non-routed-anchor
 *
 * Shouldn't match
 * routed-link
 * /routed-link
 * ../routed-link
 * routed-link#anchor
 * /routed-link#anchor
 * ../routed-link#anchor
 */

// eslint-disable-next-line no-useless-escape
var REGEX_IS_NON_ROUTED_LINK = /(?=^[^\.+])(?=[^\.]+\.|^#)/;

function isNormalLink(url) {
  return REGEX_IS_NON_ROUTED_LINK.test(url);
}

function Markdown(_ref6) {
  var _ref6$anchors = _ref6.anchors,
      anchors = _ref6$anchors === undefined ? true : _ref6$anchors,
      children = _ref6.children,
      className = _ref6.className,
      scope = _ref6.scope,
      restProps = _objectWithoutProperties(_ref6, ['anchors', 'children', 'className', 'scope']);

  var rootProps = _extends({
    className: className ? 'markdown ' + className : 'markdown'
  }, restProps);

  var compile = __WEBPACK_IMPORTED_MODULE_1_marksy_components___default()({
    createElement: __WEBPACK_IMPORTED_MODULE_0_react__["createElement"],
    elements: {
      a: function a(_ref7) {
        var href = _ref7.href,
            children = _ref7.children;

        var linkProps = isNormalLink(href) ? { href: href } : { to: href };
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7__SiteLink__["a" /* default */],
          linkProps,
          children
        );
      },
      code: function code(_ref8) {
        var _ref8$language = _ref8.language,
            language = _ref8$language === undefined ? 'jsx' : _ref8$language,
            code = _ref8.code,
            children = _ref8.children;

        return code ? _jsx(CodeBlock, {}, void 0, _jsx('pre', {
          className: 'prism-code language-' + language
        }, void 0, _jsx('code', {
          dangerouslySetInnerHTML: { __html: Object(__WEBPACK_IMPORTED_MODULE_10__utils_prism__["a" /* default */])(code, language) }
        }))) : _jsx('code', {}, void 0, children);
      },
      img: function img(_ref9) {
        var src = _ref9.src,
            alt = _ref9.alt;

        return _jsx(Image, {
          src: src,
          alt: alt
        });
      },
      h1: function h1(_ref10) {
        var children = _ref10.children;

        return replaceHeading(1, children, {}, anchors);
      },
      h2: function h2(_ref11) {
        var id = _ref11.id,
            children = _ref11.children;

        return replaceHeading(2, children, { id: id }, anchors);
      },
      h3: function h3(_ref12) {
        var id = _ref12.id,
            children = _ref12.children;

        return replaceHeading(3, children, { id: id }, anchors);
      },
      h4: function h4(_ref13) {
        var id = _ref13.id,
            children = _ref13.children;

        return replaceHeading(4, children, { id: id }, anchors);
      },
      h5: function h5(_ref14) {
        var id = _ref14.id,
            children = _ref14.children;

        return replaceHeading(5, children, { id: id }, anchors);
      },
      h6: function h6(_ref15) {
        var id = _ref15.id,
            children = _ref15.children;

        return replaceHeading(6, children, { id: id }, anchors);
      },
      p: function p(_ref16) {
        var children = _ref16.children;

        return _jsx(__WEBPACK_IMPORTED_MODULE_6__Paragraph__["a" /* default */], {
          variant: 'prose'
        }, void 0, children);
      },
      table: function table(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__MarkdownTable__["a" /* default */], props);
      },
      li: function li(props) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListItem, props);
      }
    },
    components: _extends({}, scope)
  });

  var compiled = compile(children, { smartypants: false });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    compiled.tree
  );
}

/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = Menu;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getItems", function() { return getItems; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(139);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var babelPluginFlowReactPropTypes_proptype_Item = __webpack_require__(52).babelPluginFlowReactPropTypes_proptype_Item || __webpack_require__(3).any;

var babelPluginFlowReactPropTypes_proptype_ItemGroup = {
  items: __webpack_require__(3).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Item === 'function' ? babelPluginFlowReactPropTypes_proptype_Item : __webpack_require__(3).shape(babelPluginFlowReactPropTypes_proptype_Item)).isRequired,
  title: typeof React$Node === 'function' ? __webpack_require__(3).instanceOf(React$Node) : __webpack_require__(3).any
};

var babelPluginFlowReactPropTypes_proptype_Items = __webpack_require__(3).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Item === 'function' ? babelPluginFlowReactPropTypes_proptype_Item : __webpack_require__(3).shape(babelPluginFlowReactPropTypes_proptype_Item));

var babelPluginFlowReactPropTypes_proptype_ItemGroups = __webpack_require__(3).arrayOf(__webpack_require__(3).shape({
  items: __webpack_require__(3).arrayOf(typeof babelPluginFlowReactPropTypes_proptype_Item === 'function' ? babelPluginFlowReactPropTypes_proptype_Item : __webpack_require__(3).shape(babelPluginFlowReactPropTypes_proptype_Item)).isRequired,
  title: typeof React$Node === 'function' ? __webpack_require__(3).instanceOf(React$Node) : __webpack_require__(3).any
}));

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', {}, {
  displayName: 'Menu',
  includeStyleReset: true
});

/**
 * A Menu presents a list of options representing actions or navigation.
 * Composed of [MenuItems](../menu-item), Menu is usually combined with [Popover](../popover) to create a [Dropdown](../dropdown).
 *
 * Menus are great for collecting actions in one place so your users don't need to scan the entire document to find a feature.
 */
function Menu(_ref) {
  var children = _ref.children,
      data = _ref.data,
      getItemProps = _ref.getItemProps,
      restProps = _objectWithoutProperties(_ref, ['children', 'data', 'getItemProps']);

  var rootProps = _extends({}, restProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    data ? renderFromData(data, getItemProps) : children
  );
}

var isGroupedData = function isGroupedData(data) {
  return data[0].hasOwnProperty('items');
};

var groupifyData = function groupifyData(data) {
  return isGroupedData(data) ? data : [{ items: data }];
};

var getItems = function getItems(data) {
  // $FlowFixMe https://github.com/facebook/flow/issues/5885
  var itemGroups = groupifyData(data);
  return itemGroups.reduce(function (acc, group) {
    return group.items && group.items.length ? acc.concat(group.items.filter(function (item) {
      return !item.divider;
    })) : acc;
  }, []);
};

function renderFromData(data, getItemProps) {
  // $FlowFixMe https://github.com/facebook/flow/issues/5885
  var itemGroups = groupifyData(data);
  return itemGroups.reduce(function (acc, group, groupIndex) {
    acc.groups.push(renderMenuGroup(group, groupIndex, getItemProps, acc));
    return acc;
  }, { groups: [], itemIndex: 0 }).groups;
}

function renderMenuGroup(group, groupIndex, getItemProps, acc) {
  return group.items && group.items.length ? _jsx(__WEBPACK_IMPORTED_MODULE_2__index__["b" /* MenuGroup */], {
    title: group.title
  }, groupIndex, group.items.map(function (item, itemIndex) {
    return renderMenuItem(item, itemIndex, getItemProps, acc);
  })) : null;
}

function renderMenuItem(item, itemIndex, getItemProps, acc) {
  if (item.divider) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_2__index__["a" /* MenuDivider */], {}, itemIndex);
  } else {
    var index = acc.itemIndex++; // Excludes MenuDividers

    var text = item.text,
        restItemProps = _objectWithoutProperties(item, ['text']);

    var itemProps = getItemProps ? getItemProps(_extends({}, restItemProps, {
      item: item
    }), { index: index, item: item }) : _extends({}, restItemProps, {
      item: item
    });

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_2__index__["c" /* MenuItem */],
      _extends({ key: itemIndex }, itemProps),
      text
    );
  }
}

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__palette__ = __webpack_require__(421);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__palette__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blue__ = __webpack_require__(114);
/* unused harmony reexport blue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(115);
/* unused harmony reexport common */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dusk__ = __webpack_require__(116);
/* unused harmony reexport dusk */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__gray__ = __webpack_require__(117);
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__green__ = __webpack_require__(118);
/* unused harmony reexport green */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__indigo__ = __webpack_require__(119);
/* unused harmony reexport indigo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lime__ = __webpack_require__(120);
/* unused harmony reexport lime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__magenta__ = __webpack_require__(121);
/* unused harmony reexport magenta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__orange__ = __webpack_require__(122);
/* unused harmony reexport orange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__purple__ = __webpack_require__(123);
/* unused harmony reexport purple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__red__ = __webpack_require__(124);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_11__red__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sky__ = __webpack_require__(125);
/* unused harmony reexport sky */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__slate__ = __webpack_require__(126);
/* unused harmony reexport slate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__teal__ = __webpack_require__(127);
/* unused harmony reexport teal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__yellow__ = __webpack_require__(128);
/* unused harmony reexport yellow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getColor__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_16__getColor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getReadableTextColor__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_17__getReadableTextColor__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





















/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Card;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Card_backgroundColor: baseTheme.color_white,
    Card_borderColor: baseTheme.color_gray_20,
    Card_borderRadius: baseTheme.borderRadius_1,
    Card_boxShadow: baseTheme.shadow_2,
    Card_boxShadow_focus: '0 0 0 2px ' + baseTheme.color_theme_100 + ', ' + baseTheme.shadow_1,

    CardRow_marginVertical: baseTheme.space_stack_md,
    CardRow_marginVerticalLast: baseTheme.space_stack_lg,
    CardRow_paddingHorizontal: baseTheme.space_inset_md

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', function (props) {
  var theme = componentTheme(props.theme);

  return {
    backgroundColor: theme.Card_backgroundColor,
    border: '1px solid ' + theme.Card_borderColor,
    borderRadius: theme.Card_borderRadius,
    boxShadow: theme.Card_boxShadow,
    cursor: props.onClick && 'pointer',
    paddingBottom: '0.01em', // Necessary to prevent margin collapse of last-child
    paddingTop: '0.01em', // Necessary to prevent margin collapse of first-child

    '&:focus, &[data-simulate-focus]': {
      boxShadow: theme.Card_boxShadow_focus
    }
  };
}, {
  displayName: 'Card',
  includeStyleReset: true
});

var onKeyDown = function onKeyDown(props, event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    props.onClick && props.onClick(event);
  }
};

/**
 * Cards group conceptually related content.
 * Cards represent a gateway to more detailed information in another app view.
 * Use Cards to provide detail about a feature in your app, or to represent data
 * with which your users can interact.
 */
function Card(props) {
  var rootProps = _extends({
    onKeyDown: props.onClick ? onKeyDown.bind(null, props) : undefined,
    role: props.onClick ? 'button' : undefined,
    tabIndex: props.onClick ? 0 : undefined
  }, props);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, rootProps);
}

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SiteLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_mineral_ui_icons_src_IconLaunch__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Link__ = __webpack_require__(224);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









// prettier-ignore
var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Link_borderColor_focus: baseTheme.SiteLink_borderColor_focus || baseTheme.borderColor_focus,
    Link_color: baseTheme.SiteLink_color || baseTheme.color_text_primary,
    Link_color_active: baseTheme.SiteLink_color_active || baseTheme.color_text_primary_active,
    Link_color_hover: baseTheme.SiteLink_color_hover || baseTheme.color_text_primary_hover,
    Link_color_focus: baseTheme.SiteLink_color_focus || baseTheme.color_text_primary_focus

  }, baseTheme);
};

var ThemedLink = Object(__WEBPACK_IMPORTED_MODULE_4__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_6__Link__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return _extends({}, componentTheme(theme));
});

var Root = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(ThemedLink, function (_ref2) {
  var href = _ref2.href,
      theme = _ref2.theme;

  var styles = {
    fontWeight: theme.fontWeight_semiBold,
    textDecoration: 'underline',
    textDecorationColor: __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.color_text_primary, 0.5),
    textDecorationSkip: 'ink',

    '&:focus': {
      textDecoration: 'none'
    }
  };

  if (href) {
    styles = _extends({}, styles, {

      '& > [role="img"]': {
        borderBottom: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.color_text_primary, 0.5),
        boxSizing: 'content-box',
        fill: 'currentColor',
        paddingLeft: theme.space_inline_xs,
        position: 'relative',
        top: 2
      },

      '&:hover > [role="img"]': {
        borderBottomColor: 'currentColor'
      },

      '&:focus > [role="img"]': {
        borderBottomColor: 'transparent'
      },

      // Hiding the external link icon when the link looks like a button
      '& > span ~ [role="img"]': {
        display: 'none'
      }
    });
  }

  return styles;
});

function SiteLink(_ref3) {
  var children = _ref3.children,
      element = _ref3.element,
      href = _ref3.href,
      to = _ref3.to,
      restProps = _objectWithoutProperties(_ref3, ['children', 'element', 'href', 'to']);

  var isExternal = href && !href.startsWith('#');

  var rootProps = _extends({
    element: to ? element || __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */] : element,
    href: href,
    target: isExternal ? '_blank' : undefined,
    to: to
  }, restProps);
  var iconProps = {
    size: 'medium'
  };

  delete rootProps.context; // Ignore context prop injected from Marksy.compile()

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children,
    isExternal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__packages_mineral_ui_icons_src_IconLaunch__["a" /* default */], iconProps)
  );
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(28);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  orange: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_50,
  // orange_active: darken(0.025, colors.orange_50),
  // orange_focus: colors.orange_50,
  // orange_hover: lighten(0.025, colors.orange_50),

  slate: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].slate_60,
  slate_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].slate_70,
  slate_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].slate_60,
  slate_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].slate_50,

  yellow: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_50,
  yellow_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_60,
  yellow_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_50,
  yellow_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_40,

  cranberry: '#d1454a',
  cranberry_active: '#ca3238',
  cranberry_focus: '#d1454a',
  cranberry_hover: '#d6595e',

  slateDarker: '#597a90',
  slateDarker_active: '#4f6d80',
  slateDarker_focus: '#597a90',
  slateDarker_hover: '#64879f',

  grape: '#9a5fad',
  grape_active: '#8d52a0',
  grape_focus: '#9a5fad',
  grape_hover: '#a570b6',

  jade: '#09866e',
  jade_active: '#076e5a',
  jade_focus: '#09866e',
  jade_hover: '#0b9e82',

  orangePunch: '#d44511',
  orangePunch_active: '#bc3d0f',
  orangePunch_focus: '#d44511',
  orangePunch_hover: '#ec4d13'
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Section__ = __webpack_require__(79);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var ThemedSection = Object(__WEBPACK_IMPORTED_MODULE_1__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_2__Section__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    SectionPaddingHorizontal: 0,
    SectionPaddingHorizontalWide: 0,
    SectionPaddingVertical: theme.baseline_3,
    SectionPaddingVerticalWide: theme.baseline_5
  };
});

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* createStyledComponent */])(ThemedSection, function (_ref2) {
  var theme = _ref2.theme;
  return {
    // Inner
    '& > div': {
      margin: 0,
      maxWidth: theme.maxContentWidth,
      paddingBottom: 0,
      paddingTop: 0,
      position: 'static'
    },

    // Targets DocSectionTitle inside any DocSection immediately following
    // another DocSection
    '& + & > div > h3': _defineProperty({
      marginTop: Object(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(41), // to baseline
      theme.SiteHeading_fontSize_3)

    }, theme.bp_moreSpacious, {
      marginTop: Object(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(58), // to baseline
      theme.SiteHeading_fontSize_3_wide)
    })
  };
}));

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SiteHeading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Heading__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SiteLink__ = __webpack_require__(36);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







// prettier-ignore
var siteComponentTheme = function siteComponentTheme(baseTheme) {
  return _extends({
    SiteHeading_fontFamily: baseTheme.fontFamily,
    SiteHeading_lineHeight_1: baseTheme.lineHeight,
    SiteHeading_lineHeight_2: baseTheme.lineHeight,
    SiteHeading_lineHeight_3: baseTheme.lineHeight,
    SiteHeading_lineHeight_4: baseTheme.lineHeight,
    SiteHeading_lineHeight_5: baseTheme.lineHeight,
    SiteHeading_lineHeight_6: baseTheme.lineHeight,

    Heading_color_1: baseTheme.SiteHeading_color_1 || baseTheme.color_text,
    Heading_color_2: baseTheme.SiteHeading_color_2 || baseTheme.color_gray_80,
    Heading_color_3: baseTheme.SiteHeading_color_3 || baseTheme.color_gray_80,
    Heading_color_4: baseTheme.SiteHeading_color_4 || baseTheme.color_gray_80,
    Heading_color_5: baseTheme.SiteHeading_color_5 || baseTheme.color_text,
    Heading_color_6: baseTheme.SiteHeading_color_6 || baseTheme.color_gray_80,
    Heading_fontSize_1: baseTheme.SiteHeading_fontSize_1 || baseTheme.fontSize_h1,
    Heading_fontSize_2: baseTheme.SiteHeading_fontSize_2 || baseTheme.fontSize_h2,
    Heading_fontSize_3: baseTheme.SiteHeading_fontSize_3 || baseTheme.fontSize_h3,
    Heading_fontSize_4: baseTheme.SiteHeading_fontSize_4 || baseTheme.fontSize_h4,
    Heading_fontSize_5: baseTheme.SiteHeading_fontSize_5 || baseTheme.fontSize_h5,
    Heading_fontSize_6: baseTheme.SiteHeading_fontSize_6 || baseTheme.fontSize_h6,
    Heading_fontWeight_1: baseTheme.SiteHeading_fontWeight_1 || baseTheme.fontWeight_extraBold,
    Heading_fontWeight_2: baseTheme.SiteHeading_fontWeight_2 || baseTheme.fontWeight_semiBold,
    Heading_fontWeight_3: baseTheme.SiteHeading_fontWeight_3 || baseTheme.fontWeight_semiBold,
    Heading_fontWeight_4: baseTheme.SiteHeading_fontWeight_4 || baseTheme.fontWeight_bold,
    Heading_fontWeight_5: baseTheme.SiteHeading_fontWeight_5 || baseTheme.fontWeight_bold,
    Heading_fontWeight_6: baseTheme.SiteHeading_fontWeight_6 || baseTheme.fontWeight_regular,
    Heading_marginMultiplier_1: baseTheme.SiteHeading_marginMultiplier_1 || 6,
    Heading_marginMultiplier_2: baseTheme.SiteHeading_marginMultiplier_2 || 5,
    Heading_marginMultiplier_3: baseTheme.SiteHeading_marginMultiplier_3 || 4,
    Heading_marginMultiplier_4: baseTheme.SiteHeading_marginMultiplier_4 || 3,
    Heading_marginMultiplier_5: baseTheme.SiteHeading_marginMultiplier_5 || 3,
    Heading_marginMultiplier_6: baseTheme.SiteHeading_marginMultiplier_6 || 3

  }, baseTheme);
};

var siteHeadingStyles = function siteHeadingStyles(_ref) {
  var level = _ref.level,
      theme = _ref.theme;
  return {
    fontFamily: theme.SiteHeading_fontFamily,
    lineHeight: theme['SiteHeading_lineHeight_' + level],

    '&:hover,&:focus': {
      '& > a': {
        visibility: 'visible'
      }
    }
  };
};

var SiteThemedHeading = Object(__WEBPACK_IMPORTED_MODULE_2__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_3__Heading__["a" /* default */], function (_ref2) {
  var theme = _ref2.theme;
  return _extends({}, siteComponentTheme(theme));
});

var SiteStyledHeading = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(SiteThemedHeading, siteHeadingStyles);

var Anchor = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__SiteLink__["a" /* default */], function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.color_caption,
    fontWeight: 'inherit',
    visibility: 'hidden'
  };
});

function SiteHeading(_ref4) {
  var _ref4$anchor = _ref4.anchor,
      anchor = _ref4$anchor === undefined ? true : _ref4$anchor,
      children = _ref4.children,
      id = _ref4.id,
      restProps = _objectWithoutProperties(_ref4, ['anchor', 'children', 'id']);

  var rootProps = _extends({
    id: id
  }, restProps);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    SiteStyledHeading,
    rootProps,
    children,
    ' ',
    anchor && id && _jsx(Anchor, {
      href: '#' + id
    }, void 0, '#')
  );
}

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentTheme", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["default"] = MenuItem;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamorous__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconDanger__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconSuccess__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconWarning__ = __webpack_require__(142);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var babelPluginFlowReactPropTypes_proptype_Item = {
  iconEnd: typeof React$Element === 'function' ? __webpack_require__(3).instanceOf(React$Element) : __webpack_require__(3).any,
  iconStart: typeof React$Element === 'function' ? __webpack_require__(3).instanceOf(React$Element) : __webpack_require__(3).any,
  disabled: __webpack_require__(3).bool,
  divider: __webpack_require__(3).bool,
  onClick: __webpack_require__(3).func,
  render: __webpack_require__(3).func,
  secondaryText: typeof React$Node === 'function' ? __webpack_require__(3).instanceOf(React$Node) : __webpack_require__(3).any,
  text: typeof React$Node === 'function' ? __webpack_require__(3).instanceOf(React$Node) : __webpack_require__(3).any,
  value: __webpack_require__(3).string,
  variant: __webpack_require__(3).oneOf(['danger', 'success', 'warning'])
};


// Some of these values (all of the margins & paddings and the content fontSize)
// come from Button (large)
var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuItem_backgroundColor_active: baseTheme.color_gray_20,
    MenuItem_backgroundColor_focus: baseTheme.color_gray_10,
    MenuItem_backgroundColor_hover: baseTheme.color_gray_10,
    MenuItem_backgroundColor_selected: baseTheme.color_theme_10,
    MenuItem_backgroundColor_selectedActive: baseTheme.color_theme_30,
    MenuItem_backgroundColor_selectedHover: baseTheme.color_theme_20,
    MenuItem_color_text: baseTheme.color_text,
    MenuItem_fontWeight: baseTheme.fontWeight_regular,
    MenuItem_fontWeight_selected: baseTheme.fontWeight_bold,
    MenuItem_paddingHorizontal: baseTheme.space_inset_md,
    MenuItem_paddingVertical: baseTheme.space_inset_sm,

    MenuItemContent_fontSize: baseTheme.fontSize_ui,

    MenuItemIcon_fill: baseTheme.color_theme_60,
    MenuItemIcon_margin: baseTheme.space_inset_sm,

    MenuItemSecondaryText_color_text: baseTheme.color_caption,
    MenuItemSecondaryText_fontSize: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(12)

  }, baseTheme);
};

// These styles are based off of Button, with significant changes
var styles = {
  content: function content(_ref) {
    var baseTheme = _ref.theme;

    var theme = componentTheme(baseTheme);

    var fontSize = theme.MenuItemContent_fontSize;
    var paddingBottom = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(4), fontSize);
    var paddingTop = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(3), fontSize);

    return {
      display: 'flex',
      flex: '1 1 auto',
      flexWrap: 'wrap',
      fontSize: fontSize,
      justifyContent: 'space-between',
      padding: paddingTop + ' 0 ' + paddingBottom,
      whiteSpace: 'normal',
      wordBreak: 'break-all'
    };
  },
  inner: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  menuItem: function menuItem(_ref2) {
    var disabled = _ref2.disabled,
        isHighlighted = _ref2.isHighlighted,
        baseTheme = _ref2.theme,
        variant = _ref2.variant;

    var theme = componentTheme(baseTheme);

    if (variant) {
      // prettier-ignore
      theme = _extends({}, theme, {
        MenuItem_backgroundColor_active: theme['backgroundColor_' + variant + '_activeMuted'],
        MenuItem_color_text: theme['color_text_' + variant]
      });
    }

    return {
      backgroundColor: isHighlighted && theme.MenuItem_backgroundColor_hover,
      color: disabled ? theme.color_text_disabled : theme.MenuItem_color_text,
      cursor: disabled ? 'default' : 'pointer',
      fontWeight: theme.MenuItem_fontWeight,
      padding: theme.MenuItem_paddingVertical + ' ' + theme.MenuItem_paddingHorizontal,

      '&:focus': {
        backgroundColor: !disabled && theme.MenuItem_backgroundColor_focus,
        outline: 0
      },

      '&:hover': {
        backgroundColor: !disabled && theme.MenuItem_backgroundColor_hover
      },

      '&:active': {
        backgroundColor: !disabled && theme.MenuItem_backgroundColor_active
      },

      '[aria-selected="true"]': {
        backgroundColor: isHighlighted ? theme.MenuItem_backgroundColor_selectedHover : theme.MenuItem_backgroundColor_selected,
        fontWeight: theme.MenuItem_fontWeight_selected,

        '&:active': {
          backgroundColor: !disabled && theme.MenuItem_backgroundColor_selectedActive
        }
      },

      '& [role="img"]': {
        boxSizing: 'content-box',
        display: 'block',
        fill: disabled || variant ? 'currentColor' : theme.MenuItemIcon_fill,
        flex: '0 0 auto',

        '&:first-child': {
          marginLeft: theme.direction === 'rtl' ? theme.MenuItemIcon_margin : null,
          marginRight: theme.direction === 'ltr' ? theme.MenuItemIcon_margin : null
        },

        '&:last-child': {
          marginLeft: theme.direction === 'ltr' ? theme.MenuItemIcon_margin : null,
          marginRight: theme.direction === 'rtl' ? theme.MenuItemIcon_margin : null
        }
      }
    };
  },
  secondaryText: function secondaryText(props) {
    var theme = componentTheme(props.theme);

    return {
      color: theme.MenuItemSecondaryText_color_text,
      fontSize: theme.MenuItemSecondaryText_fontSize,
      // The regular text fontSize is larger than that of the secondary text.
      // This magic number (optically) re-aligns both sets of text vertically.
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(3), theme.MenuItemSecondaryText_fontSize),
      wordBreak: 'break-word'
    };
  },
  text: function text(props) {
    var theme = componentTheme(props.theme);

    var margin = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["b" /* getNormalizedValue */])(theme.space_inline_sm, theme.MenuItemContent_fontSize);

    return {
      marginLeft: theme.direction === 'rtl' && margin,
      marginRight: theme.direction === 'ltr' && margin,
      wordBreak: 'break-word'
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('div', styles.menuItem, {
  displayName: 'MenuItem'
});

var CustomRoot = Object(__WEBPACK_IMPORTED_MODULE_1_glamorous__["c" /* withTheme */])(function (_ref3) {
  var item = _ref3.item,
      itemProps = _ref3.itemProps,
      render = _ref3.render,
      baseTheme = _ref3.theme;

  var theme = componentTheme(baseTheme);
  return render(item, itemProps, theme);
});

var Content = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('span', styles.content);
var Inner = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('span', styles.inner);
var SecondaryText = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('span', styles.secondaryText);
var Text = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('span', styles.text);

var onKeyDown = function onKeyDown(onClick, event) {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onClick && onClick(event);
  }
};

var variantIcons = {
  danger: _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconDanger__["a" /* default */], {
    size: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(24)
  }),
  success: _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_IconSuccess__["a" /* default */], {
    size: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(24)
  }),
  warning: _jsx(__WEBPACK_IMPORTED_MODULE_5__Icon_IconWarning__["a" /* default */], {
    size: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(24)
  })
};

var defaultRender = function defaultRender(_ref4) {
  var children = _ref4.children,
      disabled = _ref4.disabled,
      iconEnd = _ref4.iconEnd,
      iconStart = _ref4.iconStart,
      onClick = _ref4.onClick,
      secondaryText = _ref4.secondaryText,
      variant = _ref4.variant,
      tabIndex = _ref4.tabIndex,
      restProps = _objectWithoutProperties(_ref4, ['children', 'disabled', 'iconEnd', 'iconStart', 'onClick', 'secondaryText', 'variant', 'tabIndex']);

  var rootProps = _extends({
    disabled: disabled,
    onClick: disabled ? undefined : onClick,
    onKeyDown: onClick ? onKeyDown.bind(null, onClick) : undefined,
    tabIndex: disabled ? '-1' : tabIndex,
    variant: variant
  }, restProps);

  var startIcon = variant !== undefined && variant && variantIcons[variant];
  if (iconStart) {
    startIcon = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconStart, { size: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(24), key: 'iconStart' });
  }

  var endIcon = iconEnd && Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconEnd, { size: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(24), key: 'iconEnd' });

  // This structure is based on Button
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    _jsx(Inner, {}, void 0, startIcon, (children || secondaryText) && _jsx(Content, {}, void 0, _jsx(Text, {}, void 0, children), SecondaryText && _jsx(SecondaryText, {}, void 0, secondaryText)), endIcon)
  );
};

var customRender = function customRender(_ref5) {
  var render = _ref5.render,
      item = _ref5.item,
      restProps = _objectWithoutProperties(_ref5, ['render', 'item']);

  var customRootProps = {
    item: item,
    itemProps: _extends({
      onKeyDown: item && item.onClick ? onKeyDown.bind(null, item.onClick) : undefined,
      tabIndex: item && item.disabled && '-1'
    }, restProps),
    render: render
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomRoot, customRootProps);
};

/**
 * A MenuItem represents an option in a [Menu](../menu).
 * They can be used to trigger actions or navigate to a new location.
 * MenuItems provide context through optional variants, secondary text, or [Icons](../icon).
 *
 * A custom rendering hook is exposed to enable any extra functionality your app requires.
 */
function MenuItem(_ref6) {
  var _ref6$tabIndex = _ref6.tabIndex,
      tabIndex = _ref6$tabIndex === undefined ? 0 : _ref6$tabIndex,
      restProps = _objectWithoutProperties(_ref6, ['tabIndex']);

  var rootProps = _extends({
    tabIndex: tabIndex
  }, restProps);

  if (rootProps.render) {
    return customRender(rootProps);
  } else {
    return defaultRender(rootProps);
  }
}

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__generateId__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__generateId__["a"]; });
/* unused harmony reexport resetId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composeEventHandlers__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__composeEventHandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__composePropsWithGetter__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__composePropsWithGetter__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var styles = {
  root: function root(_ref) {
    var point = _ref.point;
    return {
      overflow: point ? 'hidden' : null
    };
  },
  inner: function inner(_ref2) {
    var angles = _ref2.angles,
        clipColor = _ref2.clipColor,
        point = _ref2.point,
        theme = _ref2.theme;

    var clipBottomEdge = angles[0] > 0;
    var paddingWithClip = parseFloat(theme.SectionPaddingVertical) + parseFloat(theme.baseline_2) + 'em';
    var paddingWithClipWide = parseFloat(theme.SectionPaddingVerticalWide) + parseFloat(theme.baseline_4) + 'em';
    var paddingBottom = point && clipBottomEdge ? paddingWithClip : theme.SectionPaddingVertical;
    var paddingBottomWide = point && clipBottomEdge ? paddingWithClipWide : theme.SectionPaddingVerticalWide;
    var paddingTop = point && !clipBottomEdge ? paddingWithClip : theme.SectionPaddingVertical;
    var paddingTopWide = point && !clipBottomEdge ? paddingWithClipWide : theme.SectionPaddingVerticalWide;

    var styles = [_defineProperty({
      margin: '0 auto',
      maxWidth: '80em',
      paddingBottom: paddingBottom,
      paddingLeft: theme.SectionPaddingHorizontal,
      paddingRight: theme.SectionPaddingHorizontal,
      paddingTop: paddingTop,
      position: 'relative'

    }, theme.bp_moreSpacious, {
      paddingBottom: paddingBottomWide,
      paddingLeft: theme.SectionPaddingHorizontalWide,
      paddingRight: theme.SectionPaddingHorizontalWide,
      paddingTop: paddingTopWide
    })];

    var pseudoStyles = {
      backgroundColor: clipColor,
      bottom: clipBottomEdge ? 0 : null,
      content: '""',
      height: '1em',
      position: 'absolute',
      top: !clipBottomEdge ? 0 : null
    };

    var transformProperties = 'translateY(\n      ' + (clipBottomEdge ? '1em' : '-1em') + ') scaleY(30)';

    var beforeWidth = typeof point === 'number' ? point + 'px' : point;
    var afterWidth = typeof point === 'number' ? '100% - ' + point + 'px' : '100% - ' + point;

    /*
     * The intersecting point of the two clipping shapes should be relative to
     * the width of the Inner, but the shapes themselves need to extend to the
     * viewport edge. Doing so requires:
     * [1] This calc finds the distance between the viewport edge and the
     *     Inner edge, then negates it to apply as a left/right offset
     * [2] This calc takes the distance from [1] and adds the proportional width
     *     of each clipping shape
     */

    var beforeStyles = {
      '&::before': _extends({}, pseudoStyles, {
        left: 'calc(-50vw + 50%)', // [1]
        transform: 'skewY(' + angles[0] + 'deg) ' + transformProperties,
        transformOrigin: (clipBottomEdge ? 'top' : 'bottom') + ' right',
        width: 'calc(50vw - 50% + ' + beforeWidth + ')' // [2]
      })
    };

    var afterStyles = {
      '&::after': _extends({}, pseudoStyles, {
        right: 'calc(-50vw + 50%)', // [1]
        transform: 'skewY(' + -1 * angles[1] + 'deg) ' + transformProperties,
        transformOrigin: (clipBottomEdge ? 'top' : 'bottom') + ' left',
        width: 'calc(50vw - 50% + ' + afterWidth + ')' // [2]
      })
    };

    if (point) {
      styles.push(beforeStyles, afterStyles);
    }

    return styles;
  }
};

var Inner = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.inner);

// Root node must be created outside of render, so that the entire DOM element
// is replaced only when the element prop is changed, otherwise it is updated in place
function createRootNode(props) {
  var _props$element = props.element,
      element = _props$element === undefined ? Section.defaultProps.element : _props$element;


  return Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(element, styles.root, {
    rootEl: element
  });
}

var Section = function (_Component) {
  _inherits(Section, _Component);

  function Section() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, Section);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = Section.__proto__ || Object.getPrototypeOf(Section)).call.apply(_ref4, [this].concat(args))), _this), _this.rootNode = createRootNode(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Section, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.props.element !== nextProps.element) {
        this.rootNode = createRootNode(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$angles = _props.angles,
          angles = _props$angles === undefined ? Section.defaultProps.angles : _props$angles,
          _props$clipColor = _props.clipColor,
          clipColor = _props$clipColor === undefined ? Section.defaultProps.clipColor : _props$clipColor,
          children = _props.children,
          point = _props.point,
          restProps = _objectWithoutProperties(_props, ['angles', 'clipColor', 'children', 'point']);

      var Root = this.rootNode;

      var rootProps = _extends({
        point: point
      }, restProps);

      var innerProps = {
        angles: angles,
        clipColor: clipColor,
        point: point
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Inner,
          innerProps,
          children
        )
      );
    }
  }]);

  return Section;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Section.defaultProps = {
  angles: [5, 5],
  clipColor: '#fff',
  element: 'section'
};
/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Card__ = __webpack_require__(29);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* createStyledComponent */])('div', function (props) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_1__Card__["a" /* componentTheme */])(props.theme);

  return {
    marginBottom: theme.CardRow_marginVertical,
    marginTop: theme.CardRow_marginVertical,
    paddingLeft: theme.CardRow_paddingHorizontal,
    paddingRight: theme.CardRow_paddingHorizontal
  };
}, {
  displayName: 'CardRow'
}));

/***/ }),
/* 81 */,
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SiteHeading__ = __webpack_require__(39);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1__SiteHeading__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(21 - 12), // to mid-baseline
    theme.SiteHeading_fontSize_3),
    paddingTop: Object(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(50), // to baseline
    theme.SiteHeading_fontSize_3)

  }, theme.bp_moreSpacious, {
    fontSize: theme.SiteHeading_fontSize_3_wide,
    margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(19 - 12), // to mid-baseline
    theme.SiteHeading_fontSize_3_wide),
    paddingTop: Object(__WEBPACK_IMPORTED_MODULE_0__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(55), // to baseline
    theme.SiteHeading_fontSize_3_wide)
  });
}).withProps({ level: 3 }));

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PopoverArrow__ = __webpack_require__(138);
/* unused harmony reexport PopoverArrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PopoverContent__ = __webpack_require__(218);
/* unused harmony reexport PopoverContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PopoverTrigger__ = __webpack_require__(137);
/* unused harmony reexport PopoverTrigger */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






/***/ }),
/* 84 */,
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconCheck;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z'
}));

/* eslint-disable prettier/prettier */
function IconCheck(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconCheck.category = 'navigation';

/***/ }),
/* 86 */,
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TableHeaderCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TableRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__siteColors__ = __webpack_require__(37);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var styles = {
  cell: function cell(_ref) {
    var theme = _ref.theme;
    return {
      padding: theme.space_inset_md + ' ' + theme.space_inset_sm,

      '&:first-child': {
        paddingLeft: 0
      },

      '&:last-child': {
        paddingRight: 0
      }
    };
  },
  headerCell: function headerCell(_ref2) {
    var theme = _ref2.theme,
        width = _ref2.width;
    return {
      borderBottom: '3px solid ' + __WEBPACK_IMPORTED_MODULE_0_polished_lib_color_rgba___default()(theme.borderColor, 0.3),
      color: __WEBPACK_IMPORTED_MODULE_2__siteColors__["a" /* default */].slateDarker,
      fontWeight: theme.fontWeight_bold,
      padding: '0 ' + theme.space_inset_sm + ' ' + theme.space_inset_sm,
      textAlign: 'left',
      width: width && width + 'rem',

      '&:first-child': {
        paddingLeft: 0
      },

      '&:last-child': {
        paddingRight: 0
      }
    };
  },
  row: function row(_ref3) {
    var theme = _ref3.theme;
    return {
      borderBottom: '1px solid ' + __WEBPACK_IMPORTED_MODULE_0_polished_lib_color_rgba___default()(theme.borderColor, 0.3)
    };
  },
  table: function table(_ref4) {
    var theme = _ref4.theme;
    return {
      borderCollapse: 'collapse',
      borderSpacing: 0,
      fontSize: theme.fontSize_ui,
      width: '100%'
    };
  }
};

var Table = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('table', styles.table);
var TableCell = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('td', styles.cell);
var TableHeaderCell = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('th', styles.headerCell);
var TableRow = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('tr', styles.row);

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThemeProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamorous__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mineralTheme__ = __webpack_require__(190);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * ThemeProvider provides a theme to the tree of components contained within.  See the [theming page](/theming) for more information.
 */
function ThemeProvider(_ref) {
  var children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === undefined ? __WEBPACK_IMPORTED_MODULE_2__mineralTheme__["a" /* default */] : _ref$theme;

  return _jsx(__WEBPACK_IMPORTED_MODULE_1_glamorous__["a" /* ThemeProvider */], {
    theme: theme
  }, void 0, children);
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  blue_10: '#e6eefc',
  blue_20: '#c2dbfc',
  blue_30: '#9dc2fa',
  blue_40: '#72a5f2',
  blue_50: '#4a89e8',
  blue_60: '#2e6fd9',
  blue_70: '#1f5dc2',
  blue_80: '#164ea8',
  blue_90: '#114091',
  blue_100: '#0f397d',

  a11y_text_light: [60, 70, 80, 90, 100]
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  black: '#1d1f24',
  white: '#fff'
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  dusk_10: '#eff1f8',
  dusk_20: '#d8dced',
  dusk_30: '#bdc4de',
  dusk_40: '#99a3c4',
  dusk_50: '#7680a6',
  dusk_60: '#596387',
  dusk_70: '#454e6e',
  dusk_80: '#373f59',
  dusk_90: '#2c3247',
  dusk_100: '#24293b',

  a11y_text_light: [60, 70, 80, 90, 100]
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  gray_10: '#f5f7fa',
  gray_20: '#ebeff5',
  gray_30: '#dde3ed',
  gray_40: '#c8d1e0',
  gray_50: '#afbacc',
  gray_60: '#8e99ab',
  gray_70: '#707a8a',
  gray_80: '#58606e',
  gray_90: '#434a54',
  gray_100: '#333840',

  a11y_text_light: [80, 90, 100]
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  green_10: '#e8fcf2',
  green_20: '#c0fadc',
  green_30: '#95f5c3',
  green_40: '#67eba7',
  green_50: '#40db8d',
  green_60: '#1fc06f',
  green_70: '#10a35a',
  green_80: '#0a8f4c',
  green_90: '#06783f',
  green_100: '#046132',

  a11y_text_light: [90, 100]
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  indigo_10: '#e3e3fa',
  indigo_20: '#cacafa',
  indigo_30: '#adadf7',
  indigo_40: '#8d8df2',
  indigo_50: '#6c6ceb',
  indigo_60: '#4c4ce0',
  indigo_70: '#3737d3',
  indigo_80: '#2c2abd',
  indigo_90: '#2621a6',
  indigo_100: '#201d8f',

  a11y_text_light: [60, 70, 80, 90, 100]
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  lime_10: '#f1fae6',
  lime_20: '#e7facf',
  lime_30: '#d2f7a8',
  lime_40: '#b5f07a',
  lime_50: '#9be650',
  lime_60: '#81d42f',
  lime_70: '#6cbf19',
  lime_80: '#5aa60d',
  lime_90: '#4a8c08',
  lime_100: '#3d7307',

  a11y_text_light: [100]
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  magenta_10: '#f7dae3',
  magenta_20: '#f7bacd',
  magenta_30: '#f590b0',
  magenta_40: '#f06591',
  magenta_50: '#e63e73',
  magenta_60: '#d92762',
  magenta_70: '#c91451',
  magenta_80: '#b30b43',
  magenta_90: '#a1083b',
  magenta_100: '#8d0633',

  a11y_text_light: [60, 70, 80, 90, 100]
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  orange_10: '#fce8e1',
  orange_20: '#fcd0c0',
  orange_30: '#fab69d',
  orange_40: '#f59776',
  orange_50: '#ed774c',
  orange_60: '#e05b2b',
  orange_70: '#cf4615',
  orange_80: '#bd3909',
  orange_90: '#a83207',
  orange_100: '#942c06',

  a11y_text_light: [70, 80, 90, 100]
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  purple_10: '#eedefa',
  purple_20: '#e1c5fa',
  purple_30: '#d5a7fa',
  purple_40: '#c588f7',
  purple_50: '#af64ed',
  purple_60: '#9545d8',
  purple_70: '#8136bf',
  purple_80: '#6d2aa3',
  purple_90: '#5f248f',
  purple_100: '#511f7a',

  a11y_text_light: [60, 70, 80, 90, 100]
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  red_10: '#fce3e3',
  red_20: '#fabebe',
  red_30: '#f79999',
  red_40: '#f27474',
  red_50: '#eb4d4d',
  red_60: '#db2929',
  red_70: '#c71818',
  red_80: '#ad0e0e',
  red_90: '#940909',
  red_100: '#7d0606',

  a11y_text_light: [60, 70, 80, 90, 100]
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  sky_10: '#e1f3fc',
  sky_20: '#c0e5fc',
  sky_30: '#9fd9fc',
  sky_40: '#79c7f7',
  sky_50: '#51b3f0',
  sky_60: '#2f9fe0',
  sky_70: '#1b8bcc',
  sky_80: '#0f75b0',
  sky_90: '#0a6091',
  sky_100: '#084d75',

  a11y_text_light: [80, 90, 100]
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  slate_10: '#ebf3f7',
  slate_20: '#d3e4ed',
  slate_30: '#b1cfde',
  slate_40: '#8fb6c9',
  slate_50: '#709cb3',
  slate_60: '#598296',
  slate_70: '#47697a',
  slate_80: '#3a5663',
  slate_90: '#2e444f',
  slate_100: '#253740',

  a11y_text_light: [70, 80, 90, 100]
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  teal_10: '#e6faf7',
  teal_20: '#bcf7ee',
  teal_30: '#8df0de',
  teal_40: '#5ee6cd',
  teal_50: '#34d1b7',
  teal_60: '#20baa3',
  teal_70: '#15a18e',
  teal_80: '#0f8c7c',
  teal_90: '#0c7567',
  teal_100: '#0a6358',

  a11y_text_light: [90, 100]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  yellow_10: '#fcf1dc',
  yellow_20: '#fce4b6',
  yellow_30: '#fad48e',
  yellow_40: '#f7c868',
  yellow_50: '#f0b241',
  yellow_60: '#e3a322',
  yellow_70: '#d19411',
  yellow_80: '#bd8308',
  yellow_90: '#a67305',
  yellow_100: '#916504',

  a11y_text_light: [100]
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Components are built on an 8px grid
/* harmony default export */ __webpack_exports__["a"] = (16);

/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Target"], {
  display: 'inline-block'
}, {
  displayName: 'PopoverTrigger'
});

var PopoverTrigger = function (_Component) {
  _inherits(PopoverTrigger, _Component);

  function PopoverTrigger() {
    _classCallCheck(this, PopoverTrigger);

    return _possibleConstructorReturn(this, (PopoverTrigger.__proto__ || Object.getPrototypeOf(PopoverTrigger)).apply(this, arguments));
  }

  _createClass(PopoverTrigger, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['children']);

      var rootProps = {
        component: 'span'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children), restProps)
      );
    }
  }]);

  return PopoverTrigger;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (PopoverTrigger);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = PopoverArrow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    PopoverArrow_backgroundColor: baseTheme.color_white,
    PopoverArrow_borderColor: baseTheme.color_gray_20
  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Arrow"], function (_ref) {
  var placement = _ref.placement,
      size = _ref.size,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);
  var arrowShadow = ', 0 3px 1px rgba(0, 0, 0, 0.3)';
  var horizontalOffset = '-' + (parseFloat(size) - 4) + 'px';
  var directionalStyles = void 0;
  var rotation = 0;

  switch (true) {
    case placement && placement.startsWith('top'):
      // Magic numbers to optically match theme.boxShadow_2
      arrowShadow = ', 0 4px 2px rgba(0, 0, 0, 0.3)';
      directionalStyles = {
        bottom: '-' + (parseFloat(size) - 2) + 'px',
        left: 'calc(50% - ' + size + ')',
        marginBottom: 0,
        marginTop: 0
      };
      break;
    case placement && placement.startsWith('bottom'):
      arrowShadow = '';
      directionalStyles = {
        top: '-' + (parseFloat(size) - 3) + 'px',
        left: 'calc(50% - ' + size + ')',
        marginBottom: 0,
        marginTop: 0
      };
      rotation = 180;
      break;
    case placement && placement.startsWith('left'):
      directionalStyles = {
        right: horizontalOffset,
        top: 'calc(50% - ' + size + ')',
        marginLeft: 0,
        marginRight: 0
      };
      rotation = -90;
      break;
    case placement && placement.startsWith('right'):
      directionalStyles = {
        left: horizontalOffset,
        top: 'calc(50% - ' + size + ')',
        marginLeft: 0,
        marginRight: 0
      };
      rotation = 90;
      break;
    default:
      directionalStyles = {
        display: 'none'
      };
  }

  return _extends({
    color: theme.PopoverArrow_backgroundColor,
    display: 'inline-block',
    fontSize: size,
    margin: size,
    position: 'absolute',
    textShadow: '0 2px 0 ' + theme.PopoverArrow_borderColor + arrowShadow,
    transform: 'rotate(' + rotation + 'deg) scaleX(2)'
  }, directionalStyles);
}, {
  displayName: 'PopoverArrow',
  rootEl: 'span'
});

/**
 * PopoverArrow component
 */
function PopoverArrow(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    _extends({}, props, { 'aria-hidden': true }),
    '\u25BC'
  );
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(27);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MenuDivider__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__MenuDivider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuGroup__ = __webpack_require__(252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__MenuGroup__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MenuGroupTitle__ = __webpack_require__(150);
/* unused harmony reexport MenuGroupTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MenuItem__ = __webpack_require__(52);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__MenuItem__["default"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDanger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.94 19.49h16.118a1 1 0 0 0 .866-1.498l-8.06-13.99a.996.996 0 0 0-1.732-.001L3.074 17.993a.998.998 0 0 0 .867 1.499zM12 17a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm1-3.503h-2v-5h2v5z'
}));

/* eslint-disable prettier/prettier */
function IconDanger(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconDanger.category = 'alert';

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSuccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9zm-4.247 8.445L6.5 12.698l3.838 3.838 7.198-7.198-1.253-1.254-5.945 5.945-2.585-2.585z'
}));

/* eslint-disable prettier/prettier */
function IconSuccess(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconSuccess.category = 'alert';

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWarning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.414 2.718l7.868 7.868c.78.78.78 2.047 0 2.828l-7.868 7.868c-.78.78-2.047.78-2.828 0l-7.868-7.868a2.001 2.001 0 0 1 0-2.828l7.868-7.868c.78-.78 2.047-.78 2.828 0zM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm1-3.958V8h-2v5.042h2z'
}));

/* eslint-disable prettier/prettier */
function IconWarning(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconWarning.category = 'alert';

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Callout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_desaturate__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_desaturate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_desaturate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var Root = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;
  return {
    backgroundColor: variant === 'danger' ? theme.backgroundColor_input_danger : __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba___default()(theme.color_text_primary, 0.1),
    borderLeft: '3px solid ' + (variant === 'danger' ? theme.color_text_danger : theme.color_text_primary),
    padding: theme.baseline_2,

    // These styles from Link & SiteLink. Necessary because you cannot use
    // markdown within this component if it itself is used within Markdown.
    '& a': {
      '&:link': {
        color: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.SiteLink_color),
        fontWeight: theme.fontWeight_semiBold,
        textDecoration: 'underline',
        textDecorationColor: __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_rgba___default()(theme.color_text_primary, 0.5)
      },
      '&:visited': {
        color: __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_desaturate___default()(0.2, theme.SiteLink_color)
      },
      '&:hover': {
        color: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.SiteLink_color_hover),
        textDecoration: 'underline'
      },
      '&:focus': {
        color: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.SiteLink_color_focus),
        outline: '1px solid ' + __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.SiteLink_borderColor_focus),
        outlineOffset: '2px'
      },
      // `:active` must be last, to follow LVHFA order:
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
      '&:active': {
        color: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.SiteLink_color_active)
      }
    },

    '& > :last-child': {
      marginBottom: 0
    }
  };
});
var Title = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('h4', function (_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return {
    color: variant === 'danger' ? __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.color_text_danger) : __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, theme.color_text_primary),
    fontSize: '1em',
    fontWeight: theme.fontWeight_semiBold,
    margin: '0 0 ' + theme.space_stack_sm
  };
});

function Callout(_ref3) {
  var children = _ref3.children,
      className = _ref3.className,
      _ref3$title = _ref3.title,
      title = _ref3$title === undefined ? '💡 Info' : _ref3$title,
      _ref3$variant = _ref3.variant,
      variant = _ref3$variant === undefined ? 'regular' : _ref3$variant;

  return _jsx(Root, {
    className: className,
    variant: variant
  }, void 0, title !== '' && _jsx(Title, {
    variant: variant
  }, void 0, title), children);
}

/***/ }),
/* 144 */,
/* 145 */,
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Heading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Heading_color_1: baseTheme.color_text,
    Heading_color_2: baseTheme.color_gray_80,
    Heading_color_3: baseTheme.color_gray_80,
    Heading_color_4: baseTheme.color_gray_80,
    Heading_color_5: baseTheme.color_text,
    Heading_color_6: baseTheme.color_gray_80,
    Heading_fontSize_1: baseTheme.fontSize_h1,
    Heading_fontSize_2: baseTheme.fontSize_h2,
    Heading_fontSize_3: baseTheme.fontSize_h3,
    Heading_fontSize_4: baseTheme.fontSize_h4,
    Heading_fontSize_5: baseTheme.fontSize_h5,
    Heading_fontSize_6: baseTheme.fontSize_h6,
    Heading_fontWeight_1: baseTheme.fontWeight_extraBold,
    Heading_fontWeight_2: baseTheme.fontWeight_semiBold,
    Heading_fontWeight_3: baseTheme.fontWeight_semiBold,
    Heading_fontWeight_4: baseTheme.fontWeight_bold,
    Heading_fontWeight_5: baseTheme.fontWeight_bold,
    Heading_fontWeight_6: baseTheme.fontWeight_regular,
    Heading_marginMultiplier_1: 6,
    Heading_marginMultiplier_2: 5,
    Heading_marginMultiplier_3: 4,
    Heading_marginMultiplier_4: 3,
    Heading_marginMultiplier_5: 3,
    Heading_marginMultiplier_6: 3

  }, baseTheme);
};

var headingStyles = function headingStyles(_ref) {
  var level = _ref.level,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    color: theme['Heading_color_' + level],
    fontSize: theme['Heading_fontSize_' + level],
    fontWeight: theme['Heading_fontWeight_' + level],
    margin: '0 0 ' + theme['Heading_marginMultiplier_' + level] * parseFloat(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.space_stack_sm, theme['Heading_fontSize_' + level])) + 'em'
  };
};

function Heading(_ref2) {
  var as = _ref2.as,
      children = _ref2.children,
      level = _ref2.level,
      restProps = _objectWithoutProperties(_ref2, ['as', 'children', 'level']);

  var rootProps = _extends({
    level: level
  }, restProps);
  var useAs = as ? as : 'h' + level;
  var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(useAs, headingStyles);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children
  );
}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconClose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z'
}));

/* eslint-disable prettier/prettier */
function IconClose(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconClose.category = 'navigation';

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Loadable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loading__ = __webpack_require__(479);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




function Loadable(options) {
  return __WEBPACK_IMPORTED_MODULE_0_react_loadable___default()(_extends({
    delay: 500,
    loading: __WEBPACK_IMPORTED_MODULE_1__Loading__["a" /* default */],
    timeout: 10000
  }, options));
}

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardBlock;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardRow__ = __webpack_require__(80);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardBlock_fontSize: baseTheme.fontSize_ui,
    CardBlock_lineHeight: baseTheme.lineHeight_prose

  }, baseTheme);
};

var styles = {
  inner: function inner(props) {
    var theme = componentTheme(props.theme);

    return {
      fontSize: theme.CardBlock_fontSize,
      lineHeight: theme.CardBlock_lineHeight
    };
  },
  root: function root(props) {
    var theme = Object(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* componentTheme */])(props.theme);

    return {
      '&:last-child': {
        marginBottom: theme.CardRow_marginVerticalLast
      }
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__CardRow__["a" /* default */], styles.root, {
  displayName: 'CardBlock'
});
var Inner = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.inner);

/**
 * CardBlock is used to normalize font sizes for content and to provide
 * consistent margins and padding.
 */
function CardBlock(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['children']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    restProps,
    _jsx(Inner, {}, void 0, children)
  );
}

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuGroupTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Menu_MenuItem__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuGroupTitle_fontSize: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(12),
    MenuGroupTitle_fontWeight: baseTheme.fontWeight_bold,
    MenuGroupTitle_paddingTop: baseTheme.space_stack_md,
    MenuGroupTitle_paddingBottom: baseTheme.space_stack_sm

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('h3', function (props) {
  var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_2__Menu_MenuItem__["componentTheme"])(props.theme));

  var paddingBottom = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.MenuGroupTitle_paddingBottom, theme.MenuGroupTitle_fontSize);

  var paddingTop = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.MenuGroupTitle_paddingTop, theme.MenuGroupTitle_fontSize);

  // We need to use MenuItem's padding, to match
  var paddingHorizontal = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.MenuItem_paddingHorizontal, theme.MenuGroupTitle_fontSize);

  return {
    fontSize: theme.MenuGroupTitle_fontSize,
    fontWeight: theme.MenuGroupTitle_fontWeight,
    margin: 0,
    padding: paddingTop + ' ' + paddingHorizontal + ' ' + paddingBottom
  };
}, {
  displayName: 'MenuGroupTitle'
});

/**
 * Menu group title component
 */
function MenuGroupTitle(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, props);
}

/***/ }),
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createTheme__ = __webpack_require__(191);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createTheme__["a" /* default */])());

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createColorRamp__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fontSizeBase__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__ = __webpack_require__(194);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var spacing_quarter = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(2);
var spacing_half = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(4);
var spacing_1x = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(8);
var spacing_2x = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(16);
var spacing_3x = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(24);
var spacing_4x = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(32);
var spacing_8x = Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(64);

var grays = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])('gray', 'color_gray', __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

function createTheme() {
  var baseColor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'blue';
  var overrides = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  /* Theme key naming convention:
   *
   *   [property]_[target]_[variant]_[state]
   *
   * E.g., A key for the border-color on focused "success" buttons and inputs
   * would look like the following.
   *
   *   borderColor_success_focus
   *
   * Only [property] is required. Irrelevant parts are skipped.
   */

  var primaries = Object(__WEBPACK_IMPORTED_MODULE_1__createColorRamp__["a" /* default */])(baseColor, 'color_theme', __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */]);

  // prettier-ignore
  return _extends({
    backgroundColor_disabled: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_20,
    backgroundColor_danger: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_60,
    backgroundColor_danger_muted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_20,
    backgroundColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_70,
    backgroundColor_danger_activeMuted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_30,
    backgroundColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_60,
    backgroundColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_50,
    backgroundColor_success: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_80,
    backgroundColor_success_muted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_20,
    backgroundColor_success_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_90,
    backgroundColor_success_activeMuted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_30,
    backgroundColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_80,
    backgroundColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_70,
    backgroundColor_warning: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_60,
    backgroundColor_warning_muted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_20,
    backgroundColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70,
    backgroundColor_warning_activeMuted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_30,
    backgroundColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_60,
    backgroundColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_50,

    backgroundColor_input: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].white,

    backgroundColor_link_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_30,

    borderColor: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_40,
    borderColor_active: primaries.color_theme_60,
    borderColor_focus: primaries.color_theme_60,
    borderColor_hover: primaries.color_theme_60,
    borderColor_danger: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_60,
    borderColor_danger_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_70,
    borderColor_danger_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_70,
    borderColor_danger_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_70,
    borderColor_danger_muted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_40,
    borderColor_success: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_70,
    borderColor_success_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_80,
    borderColor_success_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_80,
    borderColor_success_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_80,
    borderColor_success_muted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_40,
    borderColor_warning: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_60,
    borderColor_warning_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70,
    borderColor_warning_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70,
    borderColor_warning_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70,
    borderColor_warning_muted: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_40,

    borderRadius_1: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(3),

    breakpoint_narrow: 512,
    breakpoint_medium: 768,
    breakpoint_wide: 1024,

    color_black: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].black,

    color_caption: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_80

  }, grays, {

    color_placeholder: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_60

  }, primaries, {

    color_text: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_100,
    color_text_disabled: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].gray_50,
    color_text_danger: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_60,
    color_text_danger_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_70,
    color_text_danger_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_60,
    color_text_danger_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_50,
    color_text_ondanger: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].white,
    color_text_primary: primaries.color_theme_60,
    color_text_primary_active: primaries.color_theme_70,
    color_text_primary_focus: primaries.color_theme_60,
    color_text_primary_hover: primaries.color_theme_50,
    color_text_onprimary: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].white,
    color_text_success: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_90,
    color_text_success_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_100,
    color_text_success_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_90,
    color_text_success_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_80,
    color_text_onsuccess: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].white,
    color_text_warning: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70,
    color_text_warning_active: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_80,
    color_text_warning_focus: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70,
    color_text_warning_hover: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_60,
    color_text_onwarning: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].white,

    color_white: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].white,

    direction: 'ltr',

    fontFamily: 'Open Sans',
    fontFamily_system: '-apple-system, system-ui, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
    fontFamily_monospace: '"SF Mono", "Droid Sans Mono", "Source Code Pro", Monaco, Consolas, "Courier New", Courier, monospace',

    fontSize_base: __WEBPACK_IMPORTED_MODULE_2__fontSizeBase__["a" /* default */],
    fontSize_h1: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(34),
    fontSize_h2: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(28),
    fontSize_h3: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(22),
    fontSize_h4: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(18),
    fontSize_h5: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(14),
    fontSize_h6: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(14),
    fontSize_mouse: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(11),
    fontSize_prose: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(16),
    fontSize_ui: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(14),

    fontWeight_regular: 400,
    fontWeight_semiBold: 600,
    fontWeight_bold: 700,
    fontWeight_extraBold: 800,

    lineHeight: 1.25,
    lineHeight_prose: 1.5,

    shadow_1: '0 1px 2px 0 rgba(0,0,0,0.2), 0 2px 4px 0 rgba(0,0,0,0.2)',
    shadow_2: '0 2px 4px 0 rgba(0,0,0,0.2), 0 4px 8px 0 rgba(0,0,0,0.2)',
    shadow_3: '0 4px 8px 0 rgba(0,0,0,0.2), 0 8px 16px 0 rgba(0,0,0,0.2)',
    shadow_4: '0 8px 16px 0 rgba(0,0,0,0.2), 0 20px 16px -8px rgba(0,0,0,0.2)',
    shadow_5: '0 16px 24px 0 rgba(0,0,0,0.2), 0 32px 24px -16px rgba(0,0,0,0.2)',

    size_small: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(24),
    size_medium: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(32),
    size_large: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(40),
    size_jumbo: Object(__WEBPACK_IMPORTED_MODULE_3__styles_pxToEm__["a" /* default */])(52),

    space_inline_xxs: spacing_quarter,
    space_inline_xs: spacing_half,
    space_inline_sm: spacing_1x,
    space_inline_md: spacing_2x,
    space_inline_lg: spacing_3x,
    space_inline_xl: spacing_4x,
    space_inline_xxl: spacing_8x,

    space_inset_sm: spacing_1x,
    space_inset_md: spacing_2x,
    space_inset_lg: spacing_3x,

    space_stack_xxs: spacing_quarter,
    space_stack_xs: spacing_half,
    space_stack_sm: spacing_1x,
    space_stack_md: spacing_2x,
    space_stack_lg: spacing_3x,
    space_stack_xl: spacing_4x,
    space_stack_xxl: spacing_8x,

    zIndex_100: 100,
    zIndex_200: 200,
    zIndex_400: 400,
    zIndex_800: 800,
    zIndex_1600: 1600

  }, overrides);
}

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dusk__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__gray__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__green__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__indigo__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lime__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__magenta__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__orange__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__purple__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__red__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sky__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__slate__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__teal__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__yellow__ = __webpack_require__(128);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
















/* harmony default export */ __webpack_exports__["a"] = ({
  blue: __WEBPACK_IMPORTED_MODULE_0__blue__["a" /* default */],
  dusk: __WEBPACK_IMPORTED_MODULE_1__dusk__["a" /* default */],
  gray: __WEBPACK_IMPORTED_MODULE_2__gray__["a" /* default */],
  green: __WEBPACK_IMPORTED_MODULE_3__green__["a" /* default */],
  indigo: __WEBPACK_IMPORTED_MODULE_4__indigo__["a" /* default */],
  lime: __WEBPACK_IMPORTED_MODULE_5__lime__["a" /* default */],
  magenta: __WEBPACK_IMPORTED_MODULE_6__magenta__["a" /* default */],
  orange: __WEBPACK_IMPORTED_MODULE_7__orange__["a" /* default */],
  purple: __WEBPACK_IMPORTED_MODULE_8__purple__["a" /* default */],
  red: __WEBPACK_IMPORTED_MODULE_9__red__["a" /* default */],
  sky: __WEBPACK_IMPORTED_MODULE_10__sky__["a" /* default */],
  slate: __WEBPACK_IMPORTED_MODULE_11__slate__["a" /* default */],
  teal: __WEBPACK_IMPORTED_MODULE_12__teal__["a" /* default */],
  yellow: __WEBPACK_IMPORTED_MODULE_13__yellow__["a" /* default */]
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createColorRamp;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
  * Generates an object of colors with renamed keys from a color palette.
  * This is primarily used to translate plain color objects into theme variables.
  *
  * e.g.
  *    createColorRamp('blue', 'color_theme', color);
  *
  *    returns
  *      {
  *        color_theme_10: '#e6eefc',
  *        color_theme_20: '#c2dbfc',
  *        color_theme_30: '#9dc2fa',
  *        color_theme_40: '#72a5f2',
  *        color_theme_50: '#4a89e8',
  *        color_theme_60: '#2e6fd9',
  *        color_theme_70: '#1f5dc2',
  *        color_theme_80: '#164ea8',
  *        color_theme_90: '#114091',
  *        color_theme_100: '#0f397d
  *      }
  */
function createColorRamp(inKey, // The key of the color in the color palette, excluding the index
outKey, // The key of the color in the returned object, excluding the index
colors // The palette of colors
) {
  var REGEX_IN_KEY = new RegExp("^" + inKey);
  return Object.keys(colors).filter(function (key) {
    return REGEX_IN_KEY.test(key);
  }).reduce(function (acc, key) {
    var newKey = key.replace(REGEX_IN_KEY, outKey);
    acc[newKey] = colors[key];
    return acc;
  }, {});
}

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pxToEm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themes_fontSizeBase__ = __webpack_require__(129);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
  * Helper to convert a px value to ems, relative to the base font size
  */


function pxToEm(value) {
  return value / __WEBPACK_IMPORTED_MODULE_0__themes_fontSizeBase__["a" /* default */] + 'em';
}

/***/ }),
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNormalizedValue;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
  * Helper to normalize a theme variable (defined in ems) against the applied
  * fontSize (also defined in ems), so that the resulting value renders correctly
  */
function getNormalizedValue(value, base) {
  return parseFloat(value) / parseFloat(base) + "em";
}

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentDocExample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_mineral_ui_icons_src_IconArrowBack__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Callout__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ErrorBoundary__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SiteHeading__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SiteLink__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__LiveProvider__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Markdown__ = __webpack_require__(21);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











var styles = {
  backLink: function backLink(_ref) {
    var theme = _ref.theme;
    return _defineProperty({
      display: 'inline-block',
      margin: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(63) + ' 0 ' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(33) }, theme.bp_moreSpacious, {
      margin: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(85) + ' 0 ' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(43) // to baseline
    });
  },
  componentDocExample: function componentDocExample(_ref3) {
    var theme = _ref3.theme;
    return {
      '&:not(:first-child)': _defineProperty({
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(27) }, theme.bp_moreSpacious, {
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(33) // to baseline
      })
    };
  },
  description: function description(_ref4) {
    var theme = _ref4.theme;
    return {
      marginBottom: '' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(31), // to baseline

      // Specificity hack
      // Sometimes Page's intro styling needs undone
      '& > p[class][class]': {
        color: 'inherit',
        fontSize: theme.fontSize_prose,
        fontWeight: 'inherit',
        maxWidth: theme.maxTextWidth
      }
    };
  },
  title: function title(_ref5) {
    var _ref6;

    var theme = _ref5.theme;
    return _ref6 = {
      margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(21 - 12), // to mid-baseline
      theme.SiteHeading_fontSize_3),
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(68), // to baseline
      theme.SiteHeading_fontSize_3)

    }, _defineProperty(_ref6, theme.bp_moreSpacious, {
      fontSize: theme.SiteHeading_fontSize_3_wide,
      margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(19 - 12), // to mid-baseline
      theme.SiteHeading_fontSize_3_wide),
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(80), // to baseline
      theme.SiteHeading_fontSize_3_wide)
    }), _defineProperty(_ref6, '& > a:link', {
      color: 'inherit',
      fontWeight: 'inherit',
      textDecoration: 'none',

      '&:hover': {
        textDecoration: 'underline'
      }
    }), _ref6;
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.componentDocExample);
var Description = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_8__Markdown__["a" /* default */], styles.description);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__SiteHeading__["a" /* default */], styles.title).withProps({
  level: 3
});
var BackLink = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_6__SiteLink__["a" /* default */], styles.backLink);

var _ref8 = _jsx(__WEBPACK_IMPORTED_MODULE_2__packages_mineral_ui_icons_src_IconArrowBack__["a" /* default */], {
  color: 'currentColor',
  size: 'small'
});

function ComponentDocExample(_ref7) {
  var backgroundColor = _ref7.backgroundColor,
      chromeless = _ref7.chromeless,
      componentName = _ref7.componentName,
      description = _ref7.description,
      hideFromProd = _ref7.hideFromProd,
      hideSource = _ref7.hideSource,
      id = _ref7.id,
      scope = _ref7.scope,
      source = _ref7.source,
      standalone = _ref7.standalone,
      propsTitle = _ref7.title,
      restProps = _objectWithoutProperties(_ref7, ['backgroundColor', 'chromeless', 'componentName', 'description', 'hideFromProd', 'hideSource', 'id', 'scope', 'source', 'standalone', 'title']);

  var rootProps = _extends({}, restProps);
  var liveProviderProps = {
    backgroundColor: backgroundColor,
    hideSource: chromeless || hideSource,
    scope: scope,
    source: source
  };

  var liveCode = scope && source ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__LiveProvider__["a" /* default */], _extends({}, liveProviderProps, {
    chromeless: standalone && chromeless
  })) : null;

  var title = hideFromProd && typeof propsTitle === 'string' ? propsTitle + ' [Dev-only]' : propsTitle;

  return standalone && chromeless ? liveCode : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    standalone && _jsx(BackLink, {
      to: '../'
    }, void 0, _ref8, ' ', componentName),
    _jsx(Title, {
      id: !standalone ? id : undefined
    }, void 0, !standalone ? _jsx(__WEBPACK_IMPORTED_MODULE_6__SiteLink__["a" /* default */], {
      to: id
    }, void 0, title) : title),
    _jsx(Description, {
      scope: { Callout: __WEBPACK_IMPORTED_MODULE_3__Callout__["a" /* default */] }
    }, void 0, description || ''),
    _jsx(__WEBPACK_IMPORTED_MODULE_4__ErrorBoundary__["a" /* default */], {
      buttonLabel: 'Reload example'
    }, void 0, liveCode)
  );
}

/***/ }),
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCodeBlockStyles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_getNormalizedValue__ = __webpack_require__(200);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/**
 * Many of these styles, especially colors, are modified from atom-dark theme for `prism.js`:
 * https://raw.githubusercontent.com/PrismJS/prism-themes/master/themes/prism-atom-dark.css
 * Based on Atom's `atom-dark` theme: https://github.com/atom/atom-dark-syntax
 * @author Joe Gibson (@gibsjose)
 *
 *
 * The maxHeight is set equal to, roughly, 18 lines (the length of our Getting
 * Started usage source), then adding a bit to make it clear there's more beyond
 * the scroll
 */
function getCodeBlockStyles(theme) {
  return {
    background: theme.color_gray_100,
    color: theme.color_gray_20,
    direction: 'ltr',
    fontSize: theme.fontSize_ui,
    hyphens: 'none',
    lineHeight: theme.lineHeight_prose,
    margin: 0,
    maxHeight: Object(__WEBPACK_IMPORTED_MODULE_1__styles_getNormalizedValue__["a" /* default */])(parseFloat(theme.fontSize_ui) * theme.lineHeight_prose * (18 + 0.25) + 'em', theme.fontSize_ui),
    overflow: 'auto',
    padding: '1em 0.75em',
    tabSize: 2,
    textAlign: 'left',
    whiteSpace: 'pre',
    wordBreak: 'normal',
    wordSpacing: 'normal',
    wordWrap: 'normal',

    // Children of `pre` need their UA fontFamily style overridden
    '&, & *': {
      fontFamily: theme.fontFamily_monospace
    },

    '&::selection,& ::selection': {
      backgroundColor: 'rgba(255,255,255,0.15)'
    },

    '& .token.comment, & .token.prolog, & .token.doctype, & .token.cdata': {
      color: '#7c7c7c'
    },

    '& .token.punctuation': {
      color: '#c5c8c6'
    },

    '& .namespace': {
      opacity: 0.7
    },

    '& .token.property, & .token.keyword, & .token.tag': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_40 // deviation, originally "function"
    },

    '& .token.className': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_20,
      textDecoration: 'underline'
    },

    '& .token.boolean, & .token.constant': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_20
    },

    '& .token.symbol, & .token.deleted': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].red_60 // deviation
    },

    '& .token.number': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].magenta_40 // slight deviation
    },

    '& .token.selector, & .token.attr-name, & .token.string, & .token.char, & .token.builtin, & .token.inserted': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].sky_40 // deviation, originally "property, et al"
    },

    '& .token.variable': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].purple_30
    },

    '& .token.operator': {
      color: '#ededed'
    },

    '& .token.entity': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_20,
      cursor: 'help'
      // text-decoration: 'underline'
    },

    '& .token.url': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].sky_40 // slight deviation
    },

    '&.languageCss .token.string, &.style .token.string': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_30
    },

    '& .token.atrule, & .token.attrValue': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_30
    },

    '& .token.function': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].green_50 // deviation, originally "selector, et al"
    },

    '& .token.regex': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].yellow_50
    },

    '& .token.important': {
      color: __WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */].orange_70
    },

    '& .token.important, & .token.bold': {
      fontWeight: 'bold'
    },

    '& .token.italic': {
      fontStyle: 'italic'
    }
  };
}

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Label;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant;

  var backgroundColor = variant === 'regular' ? theme.color_theme_60 : theme['backgroundColor_' + variant];

  var color = variant === 'regular' ? theme.color_text_onprimary : theme['color_text_on' + variant];

  return {
    backgroundColor: backgroundColor,
    borderRadius: theme.borderRadius_1,
    bottom: '0.15em', // optical adjustment for middle vertical alignment
    color: color,
    fontSize: theme.fontSize_mouse,
    padding: theme.space_stack_xs + ' ' + theme.space_inset_sm,
    position: 'relative', // optical adjustment for middle vertical alignment
    textTransform: 'uppercase',
    whiteSpace: 'nowrap'
  };
});

function Label(_ref2) {
  var children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === undefined ? 'regular' : _ref2$variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'variant']);

  var rootProps = _extends({ variant: variant }, restProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children
  );
}

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Canvas;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', {
  bottom: 0,
  left: 'calc(-50vw + 50%)',
  position: 'absolute',
  right: 'calc(-50vw + 50%)',
  top: 0,
  zIndex: '-1'
});

var Triangles = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', {
  backgroundImage: 'url(/images/triangles.svg)',
  backgroundPosition: 'center center',
  backgroundSize: 'cover',
  bottom: 0,
  left: 0,
  mixBlendMode: 'hard-light',
  position: 'absolute',
  right: 0,
  top: 0
});

var _ref2 = _jsx(Triangles, {});

function Canvas(_ref) {
  var restProps = _objectWithoutProperties(_ref, []);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    restProps,
    _ref2
  );
}

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Footer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Markdown__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Section__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__siteColors__ = __webpack_require__(37);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var ThemedSection = Object(__WEBPACK_IMPORTED_MODULE_2__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_4__Section__["a" /* default */], {
  color_text: __WEBPACK_IMPORTED_MODULE_2__themes__["f" /* mineralTheme */].color_white,

  Heading_color_4: __WEBPACK_IMPORTED_MODULE_2__themes__["f" /* mineralTheme */].color_white,

  Link_color: __WEBPACK_IMPORTED_MODULE_5__siteColors__["a" /* default */].yellow,
  Link_color_active: __WEBPACK_IMPORTED_MODULE_5__siteColors__["a" /* default */].yellow_active,
  Link_color_focus: __WEBPACK_IMPORTED_MODULE_5__siteColors__["a" /* default */].yellow_focus,
  Link_color_hover: __WEBPACK_IMPORTED_MODULE_5__siteColors__["a" /* default */].yellow_hover
});

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(ThemedSection, function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: theme.color_black,
    color: theme.color_gray_40,

    '& ::selection': {
      backgroundColor: 'rgba(255,255,255,0.2)'
    },

    // Inner
    '& > div': {
      paddingBottom: 1, // To prevent margin collapse
      paddingTop: 1, // To prevent margin collapse

      // Markdown
      '& > div': _defineProperty({
        '& > p[class]': {
          fontSize: theme.fontSize_mouse,
          lineHeight: theme.lineHeight,
          margin: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.baseline_1, theme.fontSize_mouse) + ' 0'
        }

      }, theme.bp_home_navExpanded, {
        display: 'flex',

        '& > p:last-child': {
          marginLeft: 'auto'
        }
      })
    }
  };
}, {
  includeStyleReset: true
}).withProps({ element: 'footer' });

function Footer(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    props,
    _jsx(__WEBPACK_IMPORTED_MODULE_3__Markdown__["a" /* default */], {}, void 0, 'Copyright \xA9 2017 CA Technologies\n\nWe welcome feedback and contributions on [GitHub](https://github.com/mineral-ui/mineral-ui)')
  );
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Logo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



function Logo(_ref) {
  var fill = _ref.fill,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? 'Mineral' : _ref$title,
      restProps = _objectWithoutProperties(_ref, ['fill', 'title']);

  var fillColor = fill || 'currentColor';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 457.93 570.83'
    }, restProps),
    _jsx('title', {}, void 0, title),
    _jsx('path', {
      className: 'band-1 shape-1',
      fill: fillColor,
      d: 'M306.14,57.35L280.27,2.23A5.65,5.65,0,0,0,277.73.11c-0.85,0-1.7-.42-3,0.42L165.36,75.16l-1.27,1.27L0,382.56H112.36Z'
    }),
    _jsx('polygon', {
      className: 'band-1 shape-2',
      fill: fillColor,
      points: '100.07 403.76 2.97 403.76 55.97 477.97 93.71 414.79 100.07 403.76'
    }),
    _jsx('path', {
      className: 'band-2 shape-3',
      fill: fillColor,
      d: 'M380.76,217.2L317.16,80.67l-38.59,64.87L115.33,419,69.11,496.2l52.15,72.93a4.29,4.29,0,0,0,3,1.7H170L363,247.3Z'
    }),
    _jsx('polygon', {
      className: 'band-3 shape-4',
      fill: fillColor,
      points: '457.93 382.56 391.79 240.52 306.98 382.56 457.93 382.56'
    }),
    _jsx('path', {
      className: 'band-3 shape-5',
      fill: fillColor,
      d: 'M235.75,502.14l-41.13,68.69h137.8a2.84,2.84,0,0,0,3-1.7l118.3-165.36H293.84Z'
    })
  );
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loadable__ = __webpack_require__(148);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var sections = [{
  heading: 'Guidelines',
  pages: [{
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 531));
      }
    }),
    description: 'Mineral UI’s React component library helps you quickly build elegantly accessible apps. Use npm or yarn to install components and themes tested across modern browsers.',
    path: '/getting-started',
    title: 'Getting Started'
  }, {
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 532));
      }
    }),
    description: 'Make your apps beautiful and accessibile with Mineral UI color palettes and themes.',
    path: '/color',
    title: 'Color'
  }, {
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 533));
      }
    }),
    description: 'Mineral UI provides a simple set of typographic elements to easily apply structure to your interface.',
    path: '/typography',
    title: 'Typography'
  }]
}, {
  heading: 'What’s New',
  pages: [{
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 534));
      }
    }),
    description: 'Check back here anytime to see current component status information for Mineral UI. Check our GitHub for issues or to suggest a new feature!',
    path: '/component-status',
    title: 'Component Status'
  }, {
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 535));
      }
    }),
    description: 'Mineral UI is committed to stable and predictable releases. Learn more about our plans for the future.',
    path: '/roadmap',
    title: 'Roadmap'
  }]
}, {
  heading: 'Customization',
  pages: [{
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 536));
      }
    }),
    description: 'Mineral UI is built on a design system with styles ready to go out of the box. Learn the techniques for customizing styles in your application.',
    path: '/styling',
    title: 'Styling'
  }, {
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 537));
      }
    }),
    description: 'Theming is a core concept in Mineral UI. Mineral UI makes it simple to implement and maintain theming across your app.',
    path: '/theming',
    title: 'Theming'
  }, {
    component: Object(__WEBPACK_IMPORTED_MODULE_0__Loadable__["a" /* default */])({
      loader: function loader() {
        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 538));
      }
    }),
    description: 'Select from the main theme colors in the picker to see how components are affected. Mineral UI themes are composed of a main color ramp and the base gray ramp.',
    path: '/palette-demo',
    title: 'Palette Demo'
  }]
}];

/* harmony default export */ __webpack_exports__["a"] = (sections);

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RtlPopper__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PopoverArrow__ = __webpack_require__(138);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var arrowSize = '8px';

var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    PopoverContent_backgroundColor: baseTheme.color_white,
    PopoverContent_borderColor: baseTheme.color_gray_20,
    PopoverContent_borderRadius: baseTheme.borderRadius_1,
    PopoverContent_boxShadow: baseTheme.shadow_2,
    PopoverContent_color: baseTheme.color_text,
    PopoverContent_paddingVertical: baseTheme.space_inset_sm,
    PopoverContent_maxWidth: 'none',
    PopoverContent_zIndex: baseTheme.zIndex_100,

    PopoverContentBlock_marginVertical: baseTheme.space_stack_sm,
    PopoverContentBlock_paddingHorizontal: baseTheme.space_inset_md

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__RtlPopper__["a" /* default */], function (_ref) {
  var baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    backgroundColor: theme.PopoverContent_backgroundColor,
    border: '1px solid ' + theme.PopoverContent_borderColor,
    borderRadius: theme.PopoverContent_borderRadius,
    boxShadow: theme.PopoverContent_boxShadow,
    color: theme.PopoverContent_color,
    padding: theme.PopoverContent_paddingVertical + ' 0',
    maxWidth: theme.PopoverContent_maxWidth,
    zIndex: theme.PopoverContent_zIndex,

    '&[data-placement^="top"]': {
      marginBottom: arrowSize
    },
    '&[data-placement^="bottom"]': {
      marginTop: arrowSize
    },
    '&[data-placement^="left"]': {
      marginRight: arrowSize
    },
    '&[data-placement^="right"]': {
      marginLeft: arrowSize
    },
    '&[data-x-out-of-boundaries]': {
      visibility: 'hidden'
    }
  };
}, {
  displayName: 'PopoverContent',
  includeStyleReset: true
});

var cardOverrides = function cardOverrides(_ref2) {
  var baseTheme = _ref2.theme;

  var theme = componentTheme(baseTheme);
  return {
    CardRow_marginVertical: theme.PopoverContentBlock_marginVertical,
    CardRow_marginVerticalLast: theme.PopoverContentBlock_marginVertical,
    CardRow_paddingHorizontal: theme.PopoverContentBlock_paddingHorizontal
  };
};

var PopoverBlock = Object(__WEBPACK_IMPORTED_MODULE_2__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_3__Card__["b" /* CardBlock */], cardOverrides);
var PopoverTitle = Object(__WEBPACK_IMPORTED_MODULE_2__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_3__Card__["g" /* CardTitle */], cardOverrides);

/**
 * PopoverContent component
 */

var PopoverContent = function (_Component) {
  _inherits(PopoverContent, _Component);

  function PopoverContent() {
    _classCallCheck(this, PopoverContent);

    return _possibleConstructorReturn(this, (PopoverContent.__proto__ || Object.getPrototypeOf(PopoverContent)).apply(this, arguments));
  }

  _createClass(PopoverContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          hasArrow = _props.hasArrow,
          placement = _props.placement,
          subtitle = _props.subtitle,
          title = _props.title,
          restProps = _objectWithoutProperties(_props, ['children', 'hasArrow', 'placement', 'subtitle', 'title']);

      var rootProps = _extends({
        placement: placement
      }, restProps);
      var popoverArrowProps = {
        size: arrowSize,
        placement: placement
      };

      var _ref4 = _jsx(PopoverTitle, {
        subtitle: subtitle
      }, void 0, title);

      var _ref5 = _jsx(PopoverBlock, {}, void 0, children);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        function (_ref3) {
          var popperProps = _ref3.popperProps,
              restProps = _ref3.restProps;

          var wrapperProps = _extends({}, popperProps, restProps);
          popoverArrowProps.placement = wrapperProps['data-placement'];

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            wrapperProps,
            title && _ref4,
            _ref5,
            hasArrow && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__PopoverArrow__["b" /* default */], popoverArrowProps)
          );
        }
      );
    }
  }]);

  return PopoverContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["b"] = (PopoverContent);

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_glamorous__ = __webpack_require__(55);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var getRtlPlacement = function getRtlPlacement(placement) {
  var rtlPlacementMap = {
    end: 'start',
    start: 'end'
  };

  var _placement$split = placement.split('-'),
      _placement$split2 = _slicedToArray(_placement$split, 2),
      edge = _placement$split2[0],
      direction = _placement$split2[1];

  if (['bottom', 'top'].indexOf(edge) !== -1) {
    return placement.replace(direction, rtlPlacementMap[direction]);
  }

  return placement;
};

/**
 * Wrapper around react-popper's Popper to respect RTL in placement
 */
function RtlPopper(_ref) {
  var placement = _ref.placement,
      theme = _ref.theme,
      restProps = _objectWithoutProperties(_ref, ['placement', 'theme']);

  var rootProps = _extends({
    placement: placement && theme.direction === 'rtl' ? getRtlPlacement(placement) : placement
  }, restProps);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_popper__["Popper"], rootProps);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_glamorous__["c" /* withTheme */])(RtlPopper));

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Menu__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popover_RtlPopper__ = __webpack_require__(219);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    DropdownContent_backgroundColor: baseTheme.color_white,
    DropdownContent_borderColor: baseTheme.color_gray_20,
    DropdownContent_borderRadius: baseTheme.borderRadius_1,
    DropdownContent_boxShadow: baseTheme.shadow_2,
    DropdownContent_margin: '5px',
    DropdownContent_zIndex: baseTheme.zIndex_100
  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_4__Popover_RtlPopper__["a" /* default */], function (_ref) {
  var baseTheme = _ref.theme,
      wide = _ref.wide;

  var theme = componentTheme(baseTheme);

  return {
    backgroundColor: theme.DropdownContent_backgroundColor,
    border: '1px solid ' + theme.DropdownContent_borderColor,
    borderRadius: theme.DropdownContent_borderRadius,
    boxShadow: theme.DropdownContent_boxShadow,
    maxHeight: Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(368),
    overflowY: 'auto',
    userSelect: 'none',
    width: wide ? Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(344) : Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(224),
    zIndex: theme.DropdownContent_zIndex,

    '&[data-placement^="top"]': {
      marginBottom: theme.DropdownContent_margin
    },
    '&[data-placement^="bottom"]': {
      marginTop: theme.DropdownContent_margin
    },
    '&[data-placement^="left"]': {
      marginRight: theme.DropdownContent_margin
    },
    '&[data-placement^="right"]': {
      marginLeft: theme.DropdownContent_margin
    },
    '&[data-x-out-of-boundaries]': {
      visibility: 'hidden'
    }
  };
}, {
  displayName: 'DropdownContent',
  includeStyleReset: true,
  filterProps: ['wide']
});

/**
 * DropdownContent component
 */

var DropdownContent = function (_Component) {
  _inherits(DropdownContent, _Component);

  function DropdownContent() {
    _classCallCheck(this, DropdownContent);

    return _possibleConstructorReturn(this, (DropdownContent.__proto__ || Object.getPrototypeOf(DropdownContent)).apply(this, arguments));
  }

  _createClass(DropdownContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          getItemProps = _props.getItemProps,
          getMenuProps = _props.getMenuProps,
          id = _props.id,
          placement = _props.placement,
          wide = _props.wide,
          restProps = _objectWithoutProperties(_props, ['data', 'getItemProps', 'getMenuProps', 'id', 'placement', 'wide']);

      var rootProps = _extends({
        id: id,
        placement: placement,
        wide: wide
      }, restProps);

      var menuProps = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* composePropsWithGetter */])({
        // Props set by this component
        id: id + '-menu',
        data: data,
        getItemProps: getItemProps
      },
      // Custom prop getter can override all values
      getMenuProps);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        function (_ref2) {
          var popperProps = _ref2.popperProps,
              restProps = _ref2.restProps;

          var wrapperProps = _extends({}, popperProps, restProps);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            wrapperProps,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Menu__["d" /* default */], menuProps)
          );
        }
      );
    }
  }]);

  return DropdownContent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["b"] = (DropdownContent);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "heroTheme", function() { return heroTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_darken__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_darken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_polished_lib_color_darken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_mineral_ui_icons_src_IconChevronRight__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__packages_mineral_ui_icons_src_IconFavorite__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Canvas__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Footer__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Logo__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Section__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__SiteButton__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__SiteLink__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Markdown__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__siteColors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Header__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ThemePlayground__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__content_accessibility_md__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__content_accessibility_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__content_accessibility_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__content_dropInComponents_md__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__content_dropInComponents_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__content_dropInComponents_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__content_getStarted_md__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__content_getStarted_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__content_getStarted_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__content_guidelines_md__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__content_guidelines_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__content_guidelines_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__content_intro_md__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__content_intro_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__content_intro_md__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__content_themePlayground_md__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__content_themePlayground_md___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__content_themePlayground_md__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






























var floatingMineralsSvg = __webpack_require__(515);

var pageMeta = {
  canonicalLink: 'https://mineral-ui.com',
  description: 'Use Mineral UI’s React component library to quickly build elegantly accessible apps. Created by CA Technologies.',
  title: 'Mineral UI'
};

var latestPost = {
  title: 'Deleting 2000 Lines of JavaScript with SVG',
  url: 'https://medium.com/@coldpour/deleting-2000-lines-of-javascript-with-svg-424b89c6e466'
};

var playgroundThemes = [_extends({ name: 'Magenta' }, Object(__WEBPACK_IMPORTED_MODULE_9__themes__["c" /* createTheme */])('magenta', { fontFamily: null })), _extends({ name: 'Purple' }, Object(__WEBPACK_IMPORTED_MODULE_9__themes__["c" /* createTheme */])('purple', { fontFamily: null })), _extends({ name: 'Indigo' }, Object(__WEBPACK_IMPORTED_MODULE_9__themes__["c" /* createTheme */])('indigo', { fontFamily: null }))];

var homeTheme = {
  color_text_primary: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch,

  SiteButton_backgroundColor_primary: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch,
  SiteButton_backgroundColor_primary_active: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_active,
  SiteButton_backgroundColor_primary_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_focus,
  SiteButton_backgroundColor_primary_hover: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_hover,

  SiteHeading_color_3: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_focus,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_hover
};
var heroTheme = {
  color_text: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,

  SiteButton_color_text: __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_darken___default()(0.04, __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].slateDarker),

  SiteHeading_color_2: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].gray_10,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white
};
var gettingStartedTheme = {
  color_text: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,
  color_text_primary: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow,

  SiteButton_backgroundColor_primary: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow,
  SiteButton_backgroundColor_primary_active: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow_active,
  SiteButton_backgroundColor_primary_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow_focus,
  SiteButton_backgroundColor_primary_hover: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow_hover,

  SiteButton_color_text: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].gray_100,
  SiteButton_color_text_primary: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].gray_100,

  SiteHeading_color_3: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,
  SiteHeading_color_4: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].yellow_hover
};
var buttonTheme = {
  Button_fontWeight: __WEBPACK_IMPORTED_MODULE_9__themes__["f" /* mineralTheme */].fontWeight_regular,
  Button_height_jumbo: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(36),
  Button_paddingHorizontal: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(12), // For a total of 24
  ButtonContent_fontSize: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(18)
};
var CTALinkTheme = {
  Link_borderColor_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_focus,
  Link_color: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch,
  Link_color_active: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_active,
  Link_color_hover: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_hover,
  Link_color_focus: __WEBPACK_IMPORTED_MODULE_20__siteColors__["a" /* default */].orangePunch_focus
};

var styles = {
  blogLink: function blogLink(_ref) {
    var theme = _ref.theme;
    return {
      alignItems: 'center',
      backgroundColor: 'rgba(0,0,0,0.3)',
      borderRadius: theme.borderRadius_1,
      display: 'inline-flex',
      fontFamily: theme.fontFamily_headline,
      fontWeight: theme.fontWeight_regular,
      marginBottom: theme.baseline_6,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em\n      ' + theme.space_inset_sm,
      textDecoration: 'none',

      '&:hover,&:focus': {
        backgroundColor: 'rgba(0,0,0,0.1)',
        textDecoration: 'none'
      },

      '&::before': {
        backgroundColor: theme.color_text_primary,
        borderRadius: theme.borderRadius_1,
        content: 'New',
        fontSize: '0.8em',
        fontWeight: theme.fontWeight_bold,
        marginRight: theme.space_inline_sm,
        padding: '\n      ' + parseFloat(theme.space_inset_sm) / 4 + 'em\n      ' + parseFloat(theme.space_inset_sm) / 2 + 'em\n      ',
        textTransform: 'uppercase'
      },

      '& > [role="img"]': {
        display: 'none'
      }
    };
  },
  button: function button(_ref2) {
    var theme = _ref2.theme;
    return {
      fontFamily: theme.fontFamily_headline,

      '&:focus': {
        outline: 0
      }
    };
  },
  buttons: function buttons(_ref3) {
    var theme = _ref3.theme;
    return {
      marginTop: theme.baseline_2,

      '& > * + *': {
        marginLeft: theme.space_inline_lg
      }
    };
  },
  CTALink: function CTALink(_ref4) {
    var theme = _ref4.theme;
    return {
      alignItems: 'center',
      display: 'inline-flex',
      fontFamily: theme.fontFamily_headline,
      fontWeight: theme.SiteHeading_fontWeight_4,

      '& > svg': {
        flex: '0 0 auto'
      }
    };
  },
  feature: function feature(_ref5) {
    var theme = _ref5.theme;
    return _defineProperty({
      textAlign: 'center',

      '& + &': {
        marginTop: theme.baseline_6
      }

    }, theme.bp_home_navExpanded, {
      flex: '0 0 ' + 5 / 12 * 100 + '%',
      textAlign: 'left',

      '& + &': {
        marginTop: 0
      }
    });
  },
  featureImg: function featureImg(_ref7) {
    var circleFill = _ref7.circleFill,
        theme = _ref7.theme;
    return {
      backgroundColor: circleFill,
      borderRadius: theme.baseline_5,
      height: theme.baseline_5,
      marginBottom: parseFloat(theme.baseline_1) - 0.3 + 'em', // Optical adjustment
      padding: theme.baseline_1,
      width: theme.baseline_5
    };
  },
  featureSection: function featureSection(_ref8) {
    var theme = _ref8.theme;
    return {
      // Inner
      '& > div': _defineProperty({}, theme.bp_home_navExpanded, {
        display: 'flex',
        justifyContent: 'space-between'
      })
    };
  },
  floatingMinerals: function floatingMinerals(_ref9) {
    var _ref10;

    var theme = _ref9.theme;
    return _ref10 = {
      height: 150,
      margin: '0 auto ' + theme.baseline_2,
      width: 300

    }, _defineProperty(_ref10, theme.bp_home_bigH3, {
      margin: '0 auto ' + theme.baseline_3
    }), _defineProperty(_ref10, theme.bp_home_guidelinesMultiColumn, {
      height: 300,
      flex: '0 0 300px',
      order: 2,
      margin: 0
    }), _defineProperty(_ref10, '& .pile', _defineProperty({
      display: 'none'

    }, theme.bp_home_guidelinesMultiColumn, {
      display: 'block'
    })), _ref10;
  },
  getStarted: function getStarted(_ref11) {
    var _li;

    var theme = _ref11.theme;
    return {
      // Specificity hack
      '& > h3[id]': _defineProperty({
        margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(theme.baseline_6, theme.SiteHeading_fontSize_3_wide),
        textAlign: 'center',
        textShadow: theme.textShadow

      }, theme.bp_home_smallH3AndDown, {
        margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(theme.baseline_6, theme.SiteHeading_fontSize_3)
      }),

      '& > ol': {
        counterReset: 'getStarted',
        listStyle: 'none',
        margin: 0,
        padding: 0
      },

      '& li': (_li = {
        counterIncrement: 'getStarted',
        paddingTop: 2.5 + parseFloat(theme.baseline_1) + 'em',
        position: 'relative'

      }, _defineProperty(_li, theme.bp_home_getStartedLeftAlign, {
        paddingTop: 0
      }), _defineProperty(_li, '& + li', {
        marginTop: theme.baseline_6
      }), _defineProperty(_li, '&::before', _defineProperty({
        backgroundColor: theme.color_text_primary,
        borderRadius: '0.75em',
        content: 'counter(getStarted)',
        color: theme.color_gray_100,
        fontSize: '1.5em',
        fontWeight: theme.fontWeight_extraBold,
        height: '1.5em',
        left: '50%',
        position: 'absolute',
        textAlign: 'center',
        top: 0,
        transform: 'translateX(-50%)',
        width: '1.5em'

      }, theme.bp_home_getStartedLeftAlign, {
        fontSize: '1em',
        height: '1.5em',
        left: 'auto',
        right: 'calc(100% + ' + theme.space_inline_md + ')',
        top: '0.05em', // Optical adjustment
        transform: 'none',
        width: '1.5em'
      })), _defineProperty(_li, '& strong', {
        lineHeight: theme.lineHeight_prose,
        fontWeight: theme.SiteHeading_fontWeight_4,
        textShadow: theme.textShadow
      }), _li),

      '& :not(pre) > code': {
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        color: theme.color_text
      },

      // Specificity hack
      '& pre[class]': {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        maxHeight: 'none'
      }
    };
  },
  getStartedBackgrounds: function getStartedBackgrounds(_ref12) {
    var theme = _ref12.theme;
    return {
      '& > :nth-child(2)': {
        background: 'linear-gradient(\n        rgba(0,0,0,0.4),\n        ' + theme.color_gray_100 + ' 75%\n      )'
      }
    };
  },
  getStartedContent: function getStartedContent(_ref13) {
    var _ref14;

    var theme = _ref13.theme;
    return _ref14 = {
      margin: '0 auto',
      maxWidth: 'min-content',
      textAlign: 'center'

    }, _defineProperty(_ref14, theme.bp_home_getStartedLeftAlign, {
      textAlign: 'left'
    }), _defineProperty(_ref14, theme.bp_home_guidelinesMultiColumn, {
      width: '70%'
    }), _defineProperty(_ref14, '& > svg', {
      display: 'block',
      margin: '0 auto ' + theme.baseline_2,
      width: '52px'
    }), _ref14;
  },
  getStartedSection: function getStartedSection(_ref15) {
    var theme = _ref15.theme;
    return {
      position: 'relative',

      '& ::selection': {
        backgroundColor: 'rgba(255,255,255,0.2)'
      },

      // Inner
      '& > div': _defineProperty({}, theme.bp_moreSpacious, {
        paddingTop: theme.baseline_7 // Optical adjustment
      })
    };
  },
  guidelines: function guidelines(_ref16) {
    var _ref17;

    var theme = _ref16.theme;
    return _ref17 = {
      textAlign: 'center'

    }, _defineProperty(_ref17, theme.bp_home_guidelinesMultiColumn, {
      flex: '1 1 auto',
      marginLeft: 1 / 12 * 100 + '%',
      marginRight: 1 / 12 * 100 + '%',
      order: 1,
      textAlign: 'right'
    }), _defineProperty(_ref17, '& > p', {
      '@media(min-width: 66.5em)': {
        marginLeft: '3em'
      },

      '@media(min-width: 69.5em)': {
        marginLeft: '4.5em'
      },

      '@media(min-width: 74em)': {
        marginLeft: '6em'
      },

      '@media(min-width: 76em)': {
        marginLeft: '6.5em'
      }
    }), _ref17;
  },
  guidelinesSection: function guidelinesSection(_ref18) {
    var theme = _ref18.theme;
    return {
      // Inner
      '& > div': _defineProperty({}, theme.bp_home_guidelinesMultiColumn, {
        alignItems: 'center',
        display: 'flex'
      }),

      // Guidelines
      '& > div > :last-child': _defineProperty({}, theme.bp_home_betweenMoreSpaciousAndGuidelinesMultiColumn, {
        margin: '0 ' + 1 / 12 * 100 + '%'
      })
    };
  },
  hero: {
    '& ::selection': {
      backgroundColor: 'rgba(255,255,255,0.2)'
    },

    // Inner
    '& > div': {
      paddingTop: 0
    }
  },
  heroCanvas: function heroCanvas(_ref19) {
    var theme = _ref19.theme;
    return _defineProperty({
      backgroundColor: 'hsl(199,35%,31%)'

    }, theme.bp_home_navCollapsedAndDown, {
      backgroundColor: 'hsl(199,35%,26%)',
      bottom: '-14.5em' // Matches change in Header margin due to open menu
    });
  },
  home: function home(_ref21) {
    var theme = _ref21.theme;
    return {
      '& ::selection': {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba___default()(theme.color_text_primary, 0.2)
      }
    };
  },
  intro: function intro(_ref22) {
    var _h, _p;

    var theme = _ref22.theme;
    return {
      // [1] All of these numbers are dependent on width of h2 content
      '& h2': (_h = {
        fontSize: theme.SiteHeading_fontSize_1,
        margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(20), // to baseline
        theme.SiteHeading_fontSize_1),
        textShadow: theme.textShadow

      }, _defineProperty(_h, theme.bp_moreSpacious, {
        fontSize: theme.SiteHeading_fontSize_1_wide,
        lineHeight: 1.24, // to baseline
        margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(17), // to baseline
        theme.SiteHeading_fontSize_1_wide),
        maxWidth: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(444), // [1]
        theme.SiteHeading_fontSize_1_wide)
      }), _defineProperty(_h, '@media(min-width: 60em)', {
        maxWidth: 'none'
      }), _h),

      '& > p': (_p = {
        textShadow: theme.textShadow

      }, _defineProperty(_p, theme.bp_home_navExpanded, {
        maxWidth: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(396) // [1]
      }), _defineProperty(_p, '@media(min-width: 60em)', {
        '&[class]': {
          maxWidth: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(484) // [1]
        }
      }), _p),

      // Intro Buttons
      '& + div': _defineProperty({
        marginTop: theme.baseline_4

      }, theme.bp_moreSpacious, {
        marginTop: theme.baseline_6
      })
    };
  },
  markdown: function markdown(_ref23) {
    var theme = _ref23.theme;
    return {
      '& h3': _defineProperty({
        fontSize: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(24),
        margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(9), // to baseline
        theme.SiteHeading_fontSize_2)

      }, theme.bp_home_bigH3, {
        fontSize: Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(32), // Dependent on length of Guidelines heading (wrapping)
        margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_8__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_8__styles__["d" /* pxToEm */])(18), theme.SiteHeading_fontSize_2_wide)
      }),

      '& p': {
        margin: '0 0 ' + theme.baseline_2
      }
    };
  },
  playgroundCanvas: function playgroundCanvas(_ref24) {
    var index = _ref24.index;
    return {
      background: 'linear-gradient(\n      ' + playgroundThemes[index].color_theme_40 + ',\n      ' + __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate___default()(0.5, playgroundThemes[index].color_theme_10) + '\n    )',
      transform: 'scaleX(-1)'
    };
  },
  playgroundSection: function playgroundSection(_ref25) {
    var index = _ref25.index,
        theme = _ref25.theme;
    return {
      position: 'relative',

      '&::before': {
        background: 'linear-gradient(\n        ' + __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate___default()(0.2, playgroundThemes[index].color_theme_60) + ',\n        ' + __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba___default()(__WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate___default()(0.2, playgroundThemes[index].color_theme_60), 0.25) + '\n      )',
        bottom: 0,
        content: '""',
        left: 0,
        position: 'absolute',
        right: 0,
        top: 0
      },

      // Inner
      '& > div': _defineProperty({
        paddingTop: theme.baseline_3

      }, theme.bp_moreSpacious, {
        paddingTop: theme.baseline_6
      }),

      // Playground
      '& > div > :last-child': _defineProperty({}, theme.bp_home_guidelinesMultiColumn, {
        margin: '0 ' + 1 / 12 * 100 + '%'
      })
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('div', styles.home, {
  includeStyleReset: true
});
// Markdown must come before all of the other Markdown-based components
var Markdown = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_19__Markdown__["a" /* default */], styles.markdown).withProps({
  anchors: false
});
// SiteButton must come before LinkButton
var SiteButton = Object(__WEBPACK_IMPORTED_MODULE_9__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_17__SiteButton__["a" /* default */], buttonTheme);
var BlogLink = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_18__SiteLink__["a" /* default */], styles.blogLink);
var Button = Object(__WEBPACK_IMPORTED_MODULE_9__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */], buttonTheme);
var Buttons = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('div', styles.buttons);
var ThemedCTALink = Object(__WEBPACK_IMPORTED_MODULE_9__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_18__SiteLink__["a" /* default */], CTALinkTheme);
var CTALink = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(ThemedCTALink, styles.CTALink);
var Feature = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('div', styles.feature);
var FeatureImg = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('img', styles.featureImg).withProps({
  alt: ''
});
var FloatingMinerals = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('div', styles.floatingMinerals);
var FeatureSection = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_16__Section__["a" /* default */], styles.featureSection);
var GetStarted = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(Markdown, styles.getStarted);
var GetStartedBackgrounds = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('div', styles.getStartedBackgrounds);
var GetStartedContent = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])('div', styles.getStartedContent, {
  includeStyleReset: true
});
var GetStartedSection = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_16__Section__["a" /* default */], styles.getStartedSection);
var Guidelines = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(Markdown, styles.guidelines);
var GuidelinesSection = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_16__Section__["a" /* default */], styles.guidelinesSection);
var Hero = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_16__Section__["a" /* default */], styles.hero).withProps({
  element: 'header'
});
var HeroCanvas = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_13__Canvas__["a" /* default */], styles.heroCanvas);
var Intro = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(Markdown, styles.intro);
var LinkButton = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(SiteButton, styles.button).withProps({
  element: __WEBPACK_IMPORTED_MODULE_18__SiteLink__["a" /* default */],
  size: 'jumbo',
  type: null
});
var PlaygroundCanvas = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_13__Canvas__["a" /* default */], styles.playgroundCanvas);
var PlaygroundSection = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_16__Section__["a" /* default */], styles.playgroundSection);

var _ref26 = _jsx(GetStartedBackgrounds, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_13__Canvas__["a" /* default */], {}), _jsx(__WEBPACK_IMPORTED_MODULE_13__Canvas__["a" /* default */], {
  triangles: false
}));

var GetStartedBackground = function GetStartedBackground() {
  return _ref26;
};

var _ref28 = _jsx(HeroCanvas, {});

var _ref29 = _jsx(__WEBPACK_IMPORTED_MODULE_21__Header__["a" /* default */], {
  latestPost: latestPost
});

var _ref30 = _jsx(Intro, {}, void 0, __WEBPACK_IMPORTED_MODULE_27__content_intro_md___default.a);

var _ref31 = _jsx(LinkButton, {
  to: '/getting-started',
  primary: true
}, void 0, 'Get Started');

var _ref32 = _jsx(LinkButton, {
  href: 'https://github.com/mineral-ui/mineral-ui'
}, void 0, 'View on GitHub');

var _ref34 = _jsx(__WEBPACK_IMPORTED_MODULE_12__packages_mineral_ui_icons_src_IconFavorite__["a" /* default */], {});

var _ref35 = _jsx(FeatureSection, {}, void 0, _jsx(Feature, {}, void 0, _jsx(FeatureImg, {
  circleFill: '#efdaf4',
  src: '/images/rocks/accessibility.svg'
}), _jsx(Markdown, {}, void 0, __WEBPACK_IMPORTED_MODULE_23__content_accessibility_md___default.a)), _jsx(Feature, {}, void 0, _jsx(FeatureImg, {
  circleFill: '#d6ebdf',
  src: '/images/rocks/dropInReady.svg'
}), _jsx(Markdown, {}, void 0, __WEBPACK_IMPORTED_MODULE_24__content_dropInComponents_md___default.a)));

var _ref37 = _jsx(__WEBPACK_IMPORTED_MODULE_15__Logo__["a" /* default */], {});

var _ref38 = _jsx(LinkButton, {
  to: '/getting-started',
  primary: true
}, void 0, 'Read the full documentation');

var _ref39 = _jsx(LinkButton, {
  href: 'https://github.com/mineral-ui/mineral-ui'
}, void 0, 'View on GitHub');

var _ref40 = _jsx(__WEBPACK_IMPORTED_MODULE_9__themes__["a" /* ThemeProvider */], {
  theme: gettingStartedTheme
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_14__Footer__["a" /* default */], {}));

var Home = function (_Component) {
  _inherits(Home, _Component);

  function Home() {
    var _ref27;

    var _temp, _this, _ret;

    _classCallCheck(this, Home);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref27 = Home.__proto__ || Object.getPrototypeOf(Home)).call.apply(_ref27, [this].concat(args))), _this), _this.state = {
      themeIndex: 0
    }, _this.rotateThemes = function (index, isClick) {
      if (__WEBPACK_IMPORTED_MODULE_3_exenv__["canUseDOM"]) {
        if (isClick) {
          global.clearTimeout(_this.rotateThemeTimer);
          _this.rotateThemeTimer = undefined;
        }
        var newIndex = index < playgroundThemes.length - 1 ? index + 1 : 0;
        _this.rotateThemeTimer = global.setTimeout(function () {
          _this.setThemeIndex(newIndex);
        }, 12000);
      }
    }, _this.setThemeIndex = function (index, isClick) {
      if (_this._isMounted) {
        _this.setState({ themeIndex: index }, function () {
          _this.rotateThemes(index, isClick);
        });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Home, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.rotateThemes(this.state.themeIndex);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var themeIndex = this.state.themeIndex;

      var _ref33 = _jsx(PlaygroundCanvas, {
        index: themeIndex
      });

      var _ref36 = _jsx(GetStartedBackground, {
        index: themeIndex
      });

      return _jsx(__WEBPACK_IMPORTED_MODULE_9__themes__["a" /* ThemeProvider */], {
        theme: homeTheme
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
        query: '(min-width: 39em)'
      }, void 0, function (navExpanded) {
        return _jsx(Root, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {}, void 0, _jsx('link', {
          rel: 'canonical',
          href: pageMeta.canonicalLink
        }), _jsx('meta', {
          name: 'description',
          content: pageMeta.description
        }), _jsx('title', {}, void 0, pageMeta.title)), _jsx(__WEBPACK_IMPORTED_MODULE_9__themes__["a" /* ThemeProvider */], {
          theme: heroTheme
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
          query: '(min-width: 48em)'
        }, void 0, function (moreSpacious) {
          /*
           * [1] These values are dependent on the width of the first
           *     Hero Button
           */
          var heroPoint = 1;
          if (navExpanded) {
            heroPoint = '12.25em'; // [1]
          }
          if (moreSpacious) {
            heroPoint = '16.75em'; // [1]
          }

          return _jsx(Hero, {
            angles: navExpanded ? [7, 8] : [5, 5],
            point: heroPoint
          }, void 0, _ref28, _ref29, latestPost && navExpanded && _jsx(BlogLink, {
            href: latestPost.url
          }, void 0, latestPost.title), _ref30, _jsx(Buttons, {}, void 0, _ref31, navExpanded && _ref32));
        })), _jsx(GuidelinesSection, {
          angles: [5, 5],
          clipColor: __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_desaturate___default()(0.2, playgroundThemes[themeIndex].color_theme_60),
          point: navExpanded ? '75%' : '99.999%'
        }, void 0, _jsx(FloatingMinerals, {
          dangerouslySetInnerHTML: { __html: floatingMineralsSvg }
        }), _jsx(Guidelines, {
          scope: { CTALink: CTALink, IconChevronRight: __WEBPACK_IMPORTED_MODULE_11__packages_mineral_ui_icons_src_IconChevronRight__["a" /* default */] }
        }, void 0, __WEBPACK_IMPORTED_MODULE_26__content_guidelines_md___default.a)), _jsx(PlaygroundSection, {
          angles: [5, 3],
          index: themeIndex,
          point: navExpanded ? '25%' : 1
        }, void 0, _ref33, _jsx(__WEBPACK_IMPORTED_MODULE_22__ThemePlayground__["a" /* default */], {
          index: themeIndex,
          setIndex: function setIndex(index) {
            _this2.setThemeIndex(index, true);
          },
          themes: playgroundThemes
        }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
          query: '(min-width: 23em)'
        }, void 0, function (navExpanded) {
          var PlaygroundButton = Object(__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* createStyledComponent */])(Button, _extends({}, styles.button, {
            fontFamily: 'inherit'
          })).withProps({
            element: __WEBPACK_IMPORTED_MODULE_18__SiteLink__["a" /* default */],
            iconStart: navExpanded ? _ref34 : undefined,
            primary: true,
            size: 'jumbo',
            type: null
          });

          return _jsx(Markdown, {
            anchors: false,
            scope: {
              Link: __WEBPACK_IMPORTED_MODULE_18__SiteLink__["a" /* default */],
              PlaygroundButton: PlaygroundButton
            }
          }, void 0, __WEBPACK_IMPORTED_MODULE_28__content_themePlayground_md___default.a);
        }))), _ref35, _jsx(GetStartedSection, {
          angles: [-5, -5],
          clipColor: __WEBPACK_IMPORTED_MODULE_7__colors__["a" /* default */].white,
          point: '50%'
        }, void 0, _ref36, _jsx(__WEBPACK_IMPORTED_MODULE_9__themes__["a" /* ThemeProvider */], {
          theme: gettingStartedTheme
        }, void 0, _jsx(GetStartedContent, {}, void 0, _ref37, _jsx(GetStarted, {
          scope: { Logo: __WEBPACK_IMPORTED_MODULE_15__Logo__["a" /* default */] }
        }, void 0, __WEBPACK_IMPORTED_MODULE_25__content_getStarted_md___default.a), _jsx(Buttons, {}, void 0, _ref38, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
          query: '(min-width: 43em)',
          render: function render() {
            return _ref39;
          }
        }))))), _ref40);
      }));
    }
  }]);

  return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (Home);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(29);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__Card__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CardActions__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__CardActions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CardBlock__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__CardBlock__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CardDivider__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__CardDivider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardFooter__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__CardFooter__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardImage__ = __webpack_require__(488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__CardImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardStatus__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__CardStatus__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardTitle__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__CardTitle__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardTitleMenu__ = __webpack_require__(492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__CardTitleMenu__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DropdownContent__ = __webpack_require__(220);
/* unused harmony reexport DropdownContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popover_PopoverTrigger__ = __webpack_require__(137);
/* unused harmony reexport DropdownTrigger */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Link__["b"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Paragraph;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Paragraph_color: baseTheme.color_text,
    Paragraph_fontSize_mouse: baseTheme.fontSize_mouse,
    Paragraph_fontSize_prose: baseTheme.fontSize_prose,
    Paragraph_fontSize_ui: baseTheme.fontSize_ui,

    Paragraph_lineHeight_normal: baseTheme.lineHeight,
    Paragraph_lineHeight_prose: baseTheme.lineHeight_prose

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('p', function (_ref) {
  var variant = _ref.variant,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    color: theme.Paragraph_color,
    fontSize: theme['Paragraph_fontSize_' + variant],
    lineHeight: variant === 'prose' ? theme.Paragraph_lineHeight_prose : theme.Paragraph_lineHeight_normal
  };
});

function Paragraph(_ref2) {
  var children = _ref2.children,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === undefined ? 'ui' : _ref2$variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'variant']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    _extends({ variant: variant }, restProps),
    children
  );
}

/***/ }),
/* 226 */,
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconAssignment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z'
}));

/* eslint-disable prettier/prettier */
function IconAssignment(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconAssignment.category = 'action';

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSlowMotionVideo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69A7.941 7.941 0 0 1 11 4.07zM5.69 7.1L4.26 5.68A9.949 9.949 0 0 0 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43A7.868 7.868 0 0 1 4.07 13zm1.61 6.74A9.981 9.981 0 0 0 11 21.95v-2.02a7.941 7.941 0 0 1-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z'
}));

/* eslint-disable prettier/prettier */
function IconSlowMotionVideo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconSlowMotionVideo.category = 'av';

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z'
}));

/* eslint-disable prettier/prettier */
function IconMenu(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconMenu.category = 'navigation';

/***/ }),
/* 230 */,
/* 231 */,
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(20);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





// prettier-ignore
var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Button_backgroundColor: baseTheme.SiteButton_backgroundColor || baseTheme.color_gray_20,
    Button_backgroundColor_active: baseTheme.SiteButton_backgroundColor_active || baseTheme.color_gray_30,
    Button_backgroundColor_focus: baseTheme.SiteButton_backgroundColor_focus || baseTheme.color_gray_20,
    Button_backgroundColor_hover: baseTheme.SiteButton_backgroundColor_hover || baseTheme.color_gray_10,
    Button_backgroundColor_minimal_active: baseTheme.SiteButton_backgroundColor_minimal_active || baseTheme.color_gray_20,
    Button_backgroundColor_minimal_hover: baseTheme.SiteButton_backgroundColor_minimal_hover || baseTheme.color_gray_10,
    Button_backgroundColor_primary: baseTheme.SiteButton_backgroundColor_primary || baseTheme.color_theme_60,
    Button_backgroundColor_primary_active: baseTheme.SiteButton_backgroundColor_primary_active || baseTheme.color_theme_70,
    Button_backgroundColor_primary_focus: baseTheme.SiteButton_backgroundColor_primary_focus || baseTheme.color_theme_60,
    Button_backgroundColor_primary_hover: baseTheme.SiteButton_backgroundColor_primary_hover || baseTheme.color_theme_50,
    Button_borderColor: baseTheme.SiteButton_borderColor || baseTheme.borderColor,
    Button_borderColor_focus: baseTheme.SiteButton_borderColor_focus || baseTheme.color_white,
    Button_borderRadius: baseTheme.SiteButton_borderRadius || baseTheme.borderRadius_1,
    Button_borderWidth: baseTheme.SiteButton_borderWidth || 1, // px
    Button_boxShadow_focus: baseTheme.SiteButton_boxShadow_focus || '0 0 0 1px ' + baseTheme.borderColor_focus,
    Button_color_text: baseTheme.SiteButton_color_text || baseTheme.color_gray_100,
    Button_color_text_minimal: baseTheme.SiteButton_color_text_minimal || baseTheme.color_text_primary,
    Button_color_text_primary: baseTheme.SiteButton_color_text_primary || baseTheme.color_text_onprimary,
    Button_fontWeight: baseTheme.SiteButton_fontWeight || baseTheme.fontWeight_semiBold,
    Button_paddingHorizontal: baseTheme.SiteButton_paddingHorizontal || baseTheme.space_inset_sm,
    Button_paddingIconOnly_small: baseTheme.SiteButton_paddingIconOnly_small || Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(3),
    Button_paddingIconOnly_medium: baseTheme.SiteButton_paddingIconOnly_medium || Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(7),
    Button_paddingIconOnly_large: baseTheme.SiteButton_paddingIconOnly_large || Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(7),
    Button_paddingIconOnly_jumbo: baseTheme.SiteButton_paddingIconOnly_jumbo || Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(13),
    Button_height_small: baseTheme.SiteButton_height_small || baseTheme.size_small,
    Button_height_medium: baseTheme.SiteButton_height_medium || baseTheme.size_medium,
    Button_height_large: baseTheme.SiteButton_height_large || baseTheme.size_large,
    Button_height_jumbo: baseTheme.SiteButton_height_jumbo || baseTheme.size_jumbo,

    ButtonContent_fontSize: baseTheme.SiteButtonContent_fontSize || baseTheme.fontSize_ui,
    ButtonContent_fontSize_small: baseTheme.SiteButtonContent_fontSize_small || Object(__WEBPACK_IMPORTED_MODULE_0__styles__["d" /* pxToEm */])(12),

    ButtonIcon_margin: baseTheme.SiteButtonIcon_margin || baseTheme.space_inset_sm

  }, baseTheme);
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return _extends({}, componentTheme(theme));
}));

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scroll_into_view_if_needed__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popover__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DropdownContent__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemMatcher__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Menu_Menu__ = __webpack_require__(27);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var babelPluginFlowReactPropTypes_proptype_ItemGroups = __webpack_require__(27).babelPluginFlowReactPropTypes_proptype_ItemGroups || __webpack_require__(3).any;

var babelPluginFlowReactPropTypes_proptype_Items = __webpack_require__(27).babelPluginFlowReactPropTypes_proptype_Items || __webpack_require__(3).any;

var babelPluginFlowReactPropTypes_proptype_Item = __webpack_require__(52).babelPluginFlowReactPropTypes_proptype_Item || __webpack_require__(3).any;

var componentTheme = function componentTheme(baseTheme) {
  return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_5__DropdownContent__["a" /* componentTheme */])(baseTheme), baseTheme);
};

/**
 * Dropdown presents a list of actions after a user interacts with a trigger.
 */

var Dropdown = function (_Component) {
  _inherits(Dropdown, _Component);

  function Dropdown() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dropdown);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      highlightedIndex: _this.props.defaultHighlightedIndex,
      isOpen: Boolean(_this.props.defaultIsOpen)
    }, _this.id = _this.props.id || 'dropdown-' + Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* generateId */])(), _this.getContentId = function () {
      return _this.id + '-content';
    }, _this.getMenuId = function () {
      return _this.id + '-menu';
    }, _this.getMenuItemId = function (index) {
      return _this.id + '-item-' + index;
    }, _this.getTriggerProps = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var contentId = _this.getContentId();
      var isOpen = _this.getControllableValue('isOpen');

      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* composePropsWithGetter */])(_extends({}, props, {

        // Props set by this component
        'aria-activedescendant': isOpen ? _this.getHighlightedItemId() || _this.getMenuId() : undefined,
        'aria-describedby': contentId,
        'aria-haspopup': true,
        'aria-owns': contentId,
        onKeyDown: _this.onTriggerKeyDown,
        onKeyUp: function onKeyUp(event) {
          // Prevent Firefox from triggering Popover's onClick handler when
          // space key is used to activate trigger.
          // See: https://bugzilla.mozilla.org/show_bug.cgi?id=501496
          event.key === ' ' && event.preventDefault();
        }
      }),
      // Custom prop getter can override all values
      _this.props.getTriggerProps);
    }, _this.getMenuProps = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* composePropsWithGetter */])(_extends({}, props, {

        // Props set by this component
        id: _this.getMenuId(),
        role: 'menu'
      }),
      // Custom prop getter can override all values
      _this.props.getMenuProps);
    }, _this.getItemProps = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var scope = arguments[1];
      var index = scope.index,
          item = scope.item;

      var highlightedIndex = _this.getControllableValue('highlightedIndex');

      return Object(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* composePropsWithGetter */])(_extends({}, props, {

        // Props set by this component
        'aria-disabled': props.disabled,
        id: _this.getMenuItemId(index),
        isHighlighted: highlightedIndex === index,
        onClick: _this.onItemClick.bind(null, item),
        role: 'menuitem',
        tabIndex: null // Unset tabIndex because we use arrow keys to navigate instead
      }),
      // Custom prop getter can override all values
      _this.props.getItemProps, scope);
    }, _this.getItems = function () {
      return Object(__WEBPACK_IMPORTED_MODULE_7__Menu_Menu__["getItems"])(_this.props.data);
    }, _this.getItemIndex = function (item) {
      return _this.getItems().indexOf(item);
    }, _this.getHighlightedItemId = function () {
      var highlightedIndex = _this.getControllableValue('highlightedIndex');
      return highlightedIndex !== undefined && highlightedIndex !== null ? _this.getMenuItemId(highlightedIndex) : undefined;
    }, _this.hasHighlightedIndex = function () {
      return _this.getControllableValue('highlightedIndex') != undefined;
    }, _this.onTriggerKeyDown = function (event) {
      var key = event.key;

      var isOpen = _this.getControllableValue('isOpen');

      if (key === 'ArrowUp') {
        event.preventDefault();
        _this.highlightPreviousItem();
        !isOpen && _this.open(event);
      } else if (key === 'ArrowDown') {
        event.preventDefault();
        _this.highlightNextItem();
        !isOpen && _this.open(event);
      } else if (key === 'Home' && isOpen) {
        event.preventDefault();
        _this.highlightItemAtIndex(0);
      } else if (key === 'End' && isOpen) {
        event.preventDefault();
        _this.highlightItemAtIndex(_this.getItems().length - 1);
      } else if (key === 'Enter' || key === ' ') {
        event.preventDefault();
        isOpen ? _this.hasHighlightedIndex() ? _this.clickHighlightedItem() : _this.close(event) : _this.open(event);
      } else if (isOpen) {
        _this.highlightItemMatchingKey(key);
      }
    }, _this.findItemMatchingKey = function (key) {
      _this.itemMatcher = _this.itemMatcher || new __WEBPACK_IMPORTED_MODULE_6__ItemMatcher__["a" /* default */]();
      return _this.itemMatcher.findMatchingItem(_this.getItems(), _this.getControllableValue('highlightedIndex'), key);
    }, _this.highlightItemMatchingKey = function (key) {
      var matchingItem = _this.findItemMatchingKey(key);
      matchingItem && _this.highlightItemAtIndex(_this.getItemIndex(matchingItem));
    }, _this.highlightItemAtIndex = function (index) {
      if (!_this.isControlled('highlightedIndex')) {
        _this.setState({ highlightedIndex: index }, _this.scrollHighlightedItemIntoViewIfNeeded);
      }
    }, _this.highlightNextItem = function () {
      if (!_this.isControlled('highlightedIndex')) {
        _this.setState(function (prevState) {
          return {
            highlightedIndex: prevState.highlightedIndex === null || prevState.highlightedIndex === undefined || prevState.highlightedIndex === _this.getItems().length - 1 ? 0 : prevState.highlightedIndex + 1
          };
        }, _this.scrollHighlightedItemIntoViewIfNeeded);
      }
    }, _this.highlightPreviousItem = function () {
      if (!_this.isControlled('highlightedIndex')) {
        _this.setState(function (prevState) {
          return {
            highlightedIndex: !prevState.highlightedIndex ? _this.getItems().length - 1 : prevState.highlightedIndex - 1
          };
        }, _this.scrollHighlightedItemIntoViewIfNeeded);
      }
    }, _this.scrollHighlightedItemIntoViewIfNeeded = function () {
      var highlightedItemNode = global.document.getElementById(_this.getHighlightedItemId());
      var boundary = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this); // eslint-disable-line react/no-find-dom-node

      if (highlightedItemNode && boundary) {
        Object(__WEBPACK_IMPORTED_MODULE_2_scroll_into_view_if_needed__["a" /* default */])(highlightedItemNode, { boundary: boundary });
      }
    }, _this.clickHighlightedItem = function () {
      var highlightedItemNode = global.document.getElementById(_this.getHighlightedItemId());
      highlightedItemNode && highlightedItemNode.click();
    }, _this.open = function (event) {
      if (_this.isControlled('isOpen')) {
        _this.openActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: true };
        }, function () {
          _this.openActions(event);
        });
      }
    }, _this.openActions = function (event) {
      _this.scrollHighlightedItemIntoViewIfNeeded();
      _this.props.onOpen && _this.props.onOpen(event);
    }, _this.close = function (event) {
      if (!_this.isControlled('highlightedIndex')) {
        _this.setState({ highlightedIndex: null });
      }

      if (_this.isControlled('isOpen')) {
        _this.closeActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: false };
        }, function () {
          _this.closeActions(event);
        });
      }
    }, _this.closeActions = function (event) {
      _this.props.onClose && _this.props.onClose(event);
    }, _this.onItemClick = function (item, event) {
      var onClick = item.onClick;


      onClick && onClick(event);
      _this.close(event);
      _this.focusTrigger();
    }, _this.focusTrigger = function () {
      var node = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.dropdownTrigger); // eslint-disable-line react/no-find-dom-node
      if (node && node.firstChild && node.firstChild instanceof HTMLElement) {
        node.firstChild.focus();
      }
    }, _this.isControlled = function (prop) {
      return _this.props.hasOwnProperty(prop);
    }, _this.getControllableValue = function (key) {
      return _this.isControlled(key) ? _this.props[key] : _this.state[key];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dropdown, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          data = _props.data,
          modifiers = _props.modifiers,
          placement = _props.placement,
          wide = _props.wide,
          restProps = _objectWithoutProperties(_props, ['children', 'data', 'modifiers', 'placement', 'wide']);

      var isOpen = this.getControllableValue('isOpen');

      var dropdownContentProps = {
        data: data,
        id: this.getContentId(),
        getItemProps: this.getItemProps,
        getMenuProps: this.getMenuProps,
        modifiers: modifiers,
        placement: placement,
        wide: wide
      };

      var rootProps = _extends({
        id: this.id
      }, restProps, {
        content: __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DropdownContent__["b" /* default */], dropdownContentProps),
        getTriggerProps: this.getTriggerProps,
        isOpen: isOpen,
        onClose: this.close,
        onOpen: this.open,
        triggerRef: function triggerRef(node) {
          _this2.dropdownTrigger = node;
        },
        wrapContent: false
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_4__Popover__["a" /* default */],
        rootProps,
        children
      );
    }
  }]);

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Dropdown.defaultProps = {
  placement: 'bottom-start'
};
/* harmony default export */ __webpack_exports__["b"] = (Dropdown);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_popper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_popper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EventListener__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Portal__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PopoverTrigger__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PopoverContent__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopoverArrow__ = __webpack_require__(138);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












var componentTheme = function componentTheme(baseTheme) {
  return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_9__PopoverArrow__["a" /* componentTheme */])(baseTheme), Object(__WEBPACK_IMPORTED_MODULE_8__PopoverContent__["a" /* componentTheme */])(baseTheme), baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2_react_popper__["Manager"], {
  display: 'inline-block'
}, {
  displayName: 'Popover',
  includeStyleReset: true,
  forwardProps: ['tag'],
  rootEl: 'span'
});

/**
 * Popovers float over page content and hold supporting information or user controls.
 */

var Popover = function (_Component) {
  _inherits(Popover, _Component);

  function Popover() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Popover);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isOpen: Boolean(_this.props.defaultIsOpen)
    }, _this.id = _this.props.id || 'popover-' + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* generateId */])(), _this.renderPopoverContent = function () {
      var _this$props = _this.props,
          content = _this$props.content,
          usePortal = _this$props.usePortal,
          wrapContent = _this$props.wrapContent;

      var popoverContent = void 0;

      if (wrapContent) {
        popoverContent = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8__PopoverContent__["b" /* default */],
          _this.getContentProps(),
          content
        );
      } else {
        popoverContent = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(content, {
          ref: function ref(node) {
            _this.popoverContent = node;
          }
        });
      }

      if (usePortal) {
        popoverContent = _jsx(__WEBPACK_IMPORTED_MODULE_6__Portal__["a" /* default */], {}, void 0, popoverContent);
      }

      return popoverContent;
    }, _this.getContentId = function () {
      return _this.id + '-content';
    }, _this.getTriggerProps = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var contentId = _this.getContentId();
      var isOpen = _this.getControllableValue('isOpen');
      var _this$props2 = _this.props,
          children = _this$props2.children,
          disabled = _this$props2.disabled,
          getTriggerProps = _this$props2.getTriggerProps,
          triggerRef = _this$props2.triggerRef;

      var child = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(children);

      return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* composePropsWithGetter */])(_extends({}, props, {

        // Props set by this component
        'aria-describedby': contentId,
        'aria-disabled': disabled,
        'aria-expanded': isOpen,
        'aria-owns': contentId,
        children: child,
        disabled: child.props.disabled !== undefined ? child.props.disabled : disabled,
        onBlur: _this.onBlur,
        onClick: !disabled ? Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* composeEventHandlers */])(child.props.onClick, _this.toggleOpenState) : undefined,
        ref: function ref(node) {
          _this.popoverTrigger = node;
          triggerRef && triggerRef(node);
        },
        role: 'button'
      }),
      // Custom prop getter can override all values
      getTriggerProps);
    }, _this.getContentProps = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var contentId = _this.getContentId();
      var _this$props3 = _this.props,
          getContentProps = _this$props3.getContentProps,
          hasArrow = _this$props3.hasArrow,
          modifiers = _this$props3.modifiers,
          placement = _this$props3.placement,
          subtitle = _this$props3.subtitle,
          title = _this$props3.title;


      return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* composePropsWithGetter */])(_extends({}, props, {

        // Props set by this component
        hasArrow: hasArrow,
        id: contentId,
        modifiers: modifiers,
        onBlur: _this.onBlur,
        placement: placement,
        ref: function ref(node) {
          _this.popoverContent = node;
        },
        subtitle: subtitle,
        tabIndex: 0,
        title: title
      }),
      // Custom prop getter can override all values
      getContentProps);
    }, _this.onBlur = function (event) {
      var isOpen = _this.getControllableValue('isOpen');
      if (isOpen && _this.isEventOutsideComponent(event)) {
        _this.close(event);
      }
    }, _this.close = function (event) {
      if (_this.isControlled('isOpen')) {
        _this.closeActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: false };
        }, function () {
          _this.closeActions(event);
        });
      }
    }, _this.closeActions = function (event) {
      var _this$props4 = _this.props,
          focusTriggerOnClose = _this$props4.focusTriggerOnClose,
          onClose = _this$props4.onClose;

      onClose && onClose(event);
      var isOpen = _this.getControllableValue('isOpen');
      !isOpen && focusTriggerOnClose && _this.focusTrigger();
    }, _this.focusTrigger = function () {
      var node = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.popoverTrigger); // eslint-disable-line react/no-find-dom-node
      if (node && node.firstChild && node.firstChild instanceof HTMLElement) {
        node.firstChild.focus();
      }
    }, _this.handleDocumentClick = function (event) {
      if (_this.isEventOutsideComponent(event)) {
        _this.close(event);
      }
    }, _this.handleDocumentKeydown = function (event) {
      if (event.key === 'Escape') {
        _this.close(event);
      }
    }, _this.isEventOutsideComponent = function (event) {
      /* eslint-disable react/no-find-dom-node */
      var usePortal = _this.props.usePortal;

      var node = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this);
      var popoverContentNode = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(_this.popoverContent);
      var target = event.type === 'blur' && event.relatedTarget ? event.relatedTarget : event.target;

      if (usePortal) {
        return node && node instanceof HTMLElement && target && target instanceof HTMLElement && !node.contains(target) && popoverContentNode && popoverContentNode instanceof HTMLElement && !popoverContentNode.contains(target);
      } else {
        return node && node instanceof HTMLElement && target && target instanceof HTMLElement && !node.contains(target);
      }
    }, _this.open = function (event) {
      if (_this.isControlled('isOpen')) {
        _this.openActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: true };
        }, function () {
          _this.openActions(event);
        });
      }
    }, _this.openActions = function (event) {
      _this.focusTrigger();
      _this.props.onOpen && _this.props.onOpen(event);
    }, _this.toggleOpenState = function (event) {
      var isOpen = _this.getControllableValue('isOpen');
      if (isOpen) {
        _this.close(event);
      } else {
        _this.open(event);
      }
    }, _this.isControlled = function (prop) {
      return _this.props.hasOwnProperty(prop);
    }, _this.getControllableValue = function (key) {
      return _this.isControlled(key) ? _this.props[key] : _this.state[key];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Popover, [{
    key: 'render',
    value: function render() {
      var restProps = _objectWithoutProperties(this.props, []);

      var isOpen = this.getControllableValue('isOpen');

      var rootProps = _extends({}, restProps, {
        tag: 'span'
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__PopoverTrigger__["a" /* default */], this.getTriggerProps()),
        isOpen && this.renderPopoverContent(),
        isOpen && _jsx(__WEBPACK_IMPORTED_MODULE_5__EventListener__["a" /* default */], {
          listeners: [{
            target: 'document',
            event: 'click',
            handler: this.handleDocumentClick,
            options: true
          }, {
            target: 'document',
            event: 'keydown',
            handler: this.handleDocumentKeydown,
            options: true
          }]
        })
      );
    }
  }]);

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Popover.defaultProps = {
  focusTriggerOnClose: true,
  hasArrow: true,
  placement: 'bottom',
  wrapContent: true
};
/* harmony default export */ __webpack_exports__["b"] = (Popover);

/***/ }),
/* 235 */,
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createKeyMap;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createKeyMap(arr, key) {
  return arr.reduce(function (acc, item) {
    acc[item[key]] = item;
    return acc;
  }, {});
}

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowBack;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z'
}));

/* eslint-disable prettier/prettier */
function IconArrowBack(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconArrowBack.category = 'navigation';

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(69);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Icon_fill: baseTheme.color_gray_60,
    Icon_size_small: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(12),
    Icon_size_medium: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(16),
    Icon_size_large: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(20)
  }, baseTheme);
};

var iconStyles = function iconStyles(_ref) {
  var color = _ref.color,
      rtl = _ref.rtl,
      size = _ref.size,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  return {
    fill: color || theme.Icon_fill,
    fontSize: theme.fontSize_base,
    height: theme['Icon_size_' + size] || size,
    transform: theme.direction === 'rtl' && rtl && 'scaleX(-1)',
    width: theme['Icon_size_' + size] || size
  };
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('svg', iconStyles, { rootEl: 'svg' });

/**
 * Icons use graphical symbols to represent an object or concept in your UI.
 * They can be used to aid comprehension of core actions in your app, and to provide feedback for user input.
 *
 * The Icon component allows you to use your own SVG to easily create an icon.
 *
 * In addition to the generic Icon component, Mineral UI provides a large number of
 * pre-built Icon components, available separately in the [mineral-ui-icons](https://www.npmjs.com/package/mineral-ui-icons) package.
 */

var Icon = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, Icon);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = Icon.__proto__ || Object.getPrototypeOf(Icon)).call.apply(_ref2, [this].concat(args))), _this), _this.id = 'icon-' + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* generateId */])(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Icon, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          title = _props.title,
          children = _props.children,
          restProps = _objectWithoutProperties(_props, ['title', 'children']);

      var titleElementId = 'icon-title-' + this.id;
      var rootProps = _extends({
        'aria-hidden': title ? null : true,
        'aria-labelledby': title && titleElementId,
        role: 'img',
        viewBox: '0 0 24 24'
      }, restProps);

      var titleProps = {
        id: titleElementId
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        title && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'title',
          titleProps,
          title
        ),
        children
      );
    }
  }]);

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Icon.displayName = 'Icon';
Icon.defaultProps = {
  size: 'medium'
};
/* harmony default export */ __webpack_exports__["b"] = (Icon);

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Button_backgroundColor: baseTheme.color_gray_20,
    Button_backgroundColor_active: baseTheme.color_gray_30,
    Button_backgroundColor_focus: baseTheme.color_gray_20,
    Button_backgroundColor_hover: baseTheme.color_gray_10,
    Button_backgroundColor_minimal_active: baseTheme.color_gray_20,
    Button_backgroundColor_minimal_hover: baseTheme.color_gray_10,
    Button_backgroundColor_primary: baseTheme.color_theme_60,
    Button_backgroundColor_primary_active: baseTheme.color_theme_70,
    Button_backgroundColor_primary_focus: baseTheme.color_theme_60,
    Button_backgroundColor_primary_hover: baseTheme.color_theme_50,
    Button_borderColor: baseTheme.borderColor,
    Button_borderColor_focus: baseTheme.color_white,
    Button_borderRadius: baseTheme.borderRadius_1,
    Button_borderWidth: 1, // px
    Button_boxShadow_focus: '0 0 0 1px ' + baseTheme.borderColor_focus,
    Button_color_text: baseTheme.color_gray_100,
    Button_color_text_minimal: baseTheme.color_text_primary,
    Button_color_text_primary: baseTheme.color_text_onprimary,
    Button_fontWeight: baseTheme.fontWeight_semiBold,
    Button_paddingHorizontal: baseTheme.space_inset_sm,
    Button_paddingIconOnly_small: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(3),
    Button_paddingIconOnly_medium: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(7),
    Button_paddingIconOnly_large: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(7),
    Button_paddingIconOnly_jumbo: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(13),
    Button_height_small: baseTheme.size_small,
    Button_height_medium: baseTheme.size_medium,
    Button_height_large: baseTheme.size_large,
    Button_height_jumbo: baseTheme.size_jumbo,

    ButtonContent_fontSize: baseTheme.fontSize_ui,
    ButtonContent_fontSize_small: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(12),

    ButtonIcon_margin: baseTheme.space_inset_sm

  }, baseTheme);
};

function chooseColor(_ref, theme) {
  var disabled = _ref.disabled,
      primary = _ref.primary,
      minimal = _ref.minimal;

  if (disabled) {
    return theme.color_text_disabled;
  } else if (primary) {
    return theme.Button_color_text_primary;
  } else if (minimal) {
    return theme.Button_color_text_minimal;
  } else {
    return theme.Button_color_text;
  }
}

var styles = {
  button: function button(props) {
    var theme = componentTheme(props.theme);
    var circular = props.circular,
        disabled = props.disabled,
        fullWidth = props.fullWidth,
        minimal = props.minimal,
        primary = props.primary,
        size = props.size,
        text = props.text,
        variant = props.variant;


    if (variant !== 'regular') {
      // prettier-ignore
      theme = _extends({}, theme, {
        Button_backgroundColor_primary: theme['backgroundColor_' + variant],
        Button_backgroundColor_primary_active: theme['backgroundColor_' + variant + '_active'],
        Button_backgroundColor_primary_focus: theme['backgroundColor_' + variant + '_focus'],
        Button_backgroundColor_primary_hover: theme['backgroundColor_' + variant + '_hover'],
        Button_boxShadow_focus: '0 0 0 1px ' + theme['borderColor_' + variant + '_focus'],
        Button_color_text: theme['color_text_' + variant],
        Button_color_text_minimal: theme['color_text_' + variant],
        Button_color_text_primary: theme['color_text_on' + variant]
      });
    }

    var color = chooseColor(props, theme);
    return {
      backgroundColor: function () {
        if (disabled && !minimal) {
          return theme.color_gray_30;
        } else if (primary) {
          return theme.Button_backgroundColor_primary;
        } else if (minimal) {
          return 'transparent';
        } else {
          return theme.Button_backgroundColor;
        }
      }(),
      borderColor: disabled || primary || minimal ? 'transparent' : theme.Button_borderColor,
      borderRadius: circular ? parseFloat(theme['Button_height_' + size]) / 2 + 'em' : theme.Button_borderRadius,
      borderStyle: 'solid',
      borderWidth: theme.Button_borderWidth + 'px',
      color: color,
      cursor: disabled ? 'default' : 'pointer',
      display: 'inline-block',
      fontWeight: theme.Button_fontWeight,
      height: theme['Button_height_' + size],
      // if the user puts in a small icon in a large button
      // we want to force the button to be round/square
      // (really just pertinent on icon-only buttons)
      minWidth: theme['Button_height_' + size],
      padding: text === undefined ? theme['Button_paddingIconOnly_' + size] : '0 ' + theme.Button_paddingHorizontal,
      textDecoration: 'none',
      verticalAlign: 'middle',
      width: fullWidth && '100%',
      '&:focus': {
        backgroundColor: function () {
          if (primary) {
            return theme.Button_backgroundColor_primary_focus;
          } else if (minimal) {
            return theme.Button_backgroundColor_minimal_focus;
          } else {
            return theme.Button_backgroundColor_focus;
          }
        }(),
        borderColor: theme.Button_borderColor_focus,
        boxShadow: theme.Button_boxShadow_focus,
        color: color,
        textDecoration: 'none'
      },
      '&:hover': {
        backgroundColor: function () {
          if (!disabled) {
            if (primary) {
              return theme.Button_backgroundColor_primary_hover;
            } else if (minimal) {
              return theme.Button_backgroundColor_minimal_hover;
            } else {
              return theme.Button_backgroundColor_hover;
            }
          }
        }(),
        color: color,
        textDecoration: 'none'
      },
      // `:active` must be last, to follow LVHFA order:
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
      '&:active': {
        backgroundColor: function () {
          if (!disabled) {
            if (primary) {
              return theme.Button_backgroundColor_primary_active;
            } else if (minimal) {
              return theme.Button_backgroundColor_minimal_active;
            } else {
              return theme.Button_backgroundColor_active;
            }
          }
        }(),
        color: color
      },
      '&::-moz-focus-inner': { border: 0 },

      '& [role="img"]': {
        boxSizing: 'content-box',
        fill: disabled || primary || minimal || variant !== 'regular' ? 'currentColor' : theme.Button_backgroundColor_primary,
        display: 'block',

        '&:first-child': {
          marginLeft: theme.direction === 'rtl' ? theme.ButtonIcon_margin : null,
          marginRight: theme.direction === 'ltr' ? theme.ButtonIcon_margin : null
        },

        '&:last-child': {
          marginLeft: theme.direction === 'ltr' ? theme.ButtonIcon_margin : null,
          marginRight: theme.direction === 'rtl' ? theme.ButtonIcon_margin : null
        },

        '&:only-child': {
          margin: 0
        }
      }
    };
  },
  content: function content(props) {
    var theme = componentTheme(props.theme);
    var size = props.size;


    var paddings = void 0;

    var fontSize = size === 'small' ? theme.ButtonContent_fontSize_small : theme.ButtonContent_fontSize;

    if (size === undefined || size === 'large' || size === 'jumbo') {
      var padding = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.Button_paddingHorizontal, fontSize);
      paddings = {
        '&:first-child': {
          paddingLeft: theme.direction === 'ltr' ? padding : null,
          paddingRight: theme.direction === 'rtl' ? padding : null
        },

        '&:last-child': {
          paddingLeft: theme.direction === 'rtl' ? padding : null,
          paddingRight: theme.direction === 'ltr' ? padding : null
        }
      };
    }

    return _extends({
      display: 'inline-block',
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    }, {

      display: 'block',
      fontSize: fontSize,
      lineHeight: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme['Button_height_' + size], fontSize)
    }, paddings);
  },
  inner: {
    alignItems: 'center',
    display: 'inline-flex',
    justifyContent: 'center',
    maxHeight: '100%',
    width: '100%'
  }
};

var iconSize = {
  small: 'medium',
  medium: 'medium',
  large: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(24),
  jumbo: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(24)
};

var Content = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.content);
var Inner = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.inner);

function isTypeButton(type) {
  return ['button', 'submit', 'reset'].indexOf(type) !== -1;
}

function filterProps(_ref2) {
  var element = _ref2.element,
      type = _ref2.type;

  // When element is a component, e.g. ReactRouterLink,
  // these are not filtered automatically by rootEl
  var invalidComponentProps = ['primary', 'text', 'variant'];
  var invalidLinkProps = element === 'a' && isTypeButton(type) ? ['type'] : [];
  return Array.prototype.concat(invalidComponentProps, invalidLinkProps);
}

// Button's root node must be created outside of render, so that the entire DOM
// element is replaced only when the element prop is changed, otherwise it is
// updated in place
function createRootNode(props) {
  var _props$element = props.element,
      element = _props$element === undefined ? Button.defaultProps.element : _props$element;


  return Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(element, styles.button, {
    filterProps: filterProps(props),
    includeStyleReset: true,
    rootEl: element
  });
}

/**
 * The Button component represents a clickable button.
 * Buttons draw attention to actions that can be performed in your app.
 * Buttons are used to trigger any sort of event.
 */

var Button = function (_Component) {
  _inherits(Button, _Component);

  function Button() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Button.__proto__ || Object.getPrototypeOf(Button)).call.apply(_ref3, [this].concat(args))), _this), _this.rootNode = createRootNode(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Button, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps) {
      if (this.props.element !== nextProps.element) {
        this.rootNode = createRootNode(nextProps);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          iconStart = _props.iconStart,
          iconEnd = _props.iconEnd,
          _props$size = _props.size,
          size = _props$size === undefined ? Button.defaultProps.size : _props$size,
          _props$type = _props.type,
          type = _props$type === undefined ? Button.defaultProps.type : _props$type,
          _props$variant = _props.variant,
          variant = _props$variant === undefined ? Button.defaultProps.variant : _props$variant,
          restProps = _objectWithoutProperties(_props, ['children', 'iconStart', 'iconEnd', 'size', 'type', 'variant']);

      var rootProps = _extends({
        size: size,
        text: children,
        type: type,
        variant: variant
      }, restProps);

      var Root = this.rootNode;

      var startIcon = iconStart ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconStart, { size: iconSize[size], key: 'iconStart' }) : null;
      var endIcon = iconEnd ? Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(iconEnd, { size: iconSize[size], key: 'iconEnd' }) : null;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        _jsx(Inner, {}, void 0, startIcon, children && _jsx(Content, {
          size: size
        }, void 0, children), endIcon)
      );
    }
  }]);

  return Button;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Button.defaultProps = {
  element: 'button',
  size: 'large',
  type: 'button',
  variant: 'regular'
};
/* harmony default export */ __webpack_exports__["b"] = (Button);

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconLaunch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z'
}));

/* eslint-disable prettier/prettier */
function IconLaunch(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconLaunch.category = 'action';

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = Link;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    Link_borderColor_focus: baseTheme.borderColor_focus,
    Link_color: baseTheme.color_text_primary,
    Link_color_active: baseTheme.color_text_primary_active,
    Link_color_hover: baseTheme.color_text_primary_hover,
    Link_color_focus: baseTheme.color_text_primary_focus

  }, baseTheme);
};

var linkStyles = function linkStyles(_ref) {
  var variant = _ref.variant,
      baseTheme = _ref.theme;

  var theme = componentTheme(baseTheme);

  if (variant !== 'regular') {
    // prettier-ignore
    theme = _extends({}, theme, {
      Link_borderColor_focus: baseTheme['borderColor_' + variant + '_focus'],
      Link_color: baseTheme['color_text_' + variant],
      Link_color_hover: baseTheme['color_text_' + variant + '_hover'],
      Link_color_focus: baseTheme['color_text_' + variant + '_focus'],
      Link_color_active: baseTheme['color_text_' + variant + '_active']
    });
  }

  return {
    color: theme.Link_color,
    textDecoration: 'none',

    '&:hover': {
      color: theme.Link_color_hover,
      textDecoration: 'underline'
    },
    '&:focus': {
      color: theme.Link_color_focus,
      outline: '1px solid ' + theme.Link_borderColor_focus,
      outlineOffset: '2px'
    },
    // `:active` must be last, to follow LVHFA order:
    // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
    '&:active': {
      color: theme.Link_color_active
    }
  };
};

/**
 * The Link component creates a hyperlink to external pages, files, anchors on the same page, or another URL.
 */
function Link(_ref2) {
  var children = _ref2.children,
      _ref2$element = _ref2.element,
      element = _ref2$element === undefined ? 'a' : _ref2$element,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === undefined ? 'regular' : _ref2$variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'element', 'variant']);

  var rootProps = _extends({
    variant: variant
  }, restProps);
  var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(element, linkStyles, {
    displayName: 'Link',
    filterProps: ['variant']
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    children
  );
}

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWarning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.414 2.718l7.868 7.868c.78.78.78 2.047 0 2.828l-7.868 7.868c-.78.78-2.047.78-2.828 0l-7.868-7.868a2.001 2.001 0 0 1 0-2.828l7.868-7.868c.78-.78 2.047-.78 2.828 0zM12 17a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm1-3.958V8h-2v5.042h2z'
}));

/* eslint-disable prettier/prettier */
function IconWarning(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconWarning.category = 'alert';

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VariableTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Table__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_colorable__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_colorable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_colorable__);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    margin: theme.space_stack_xl + ' 0 0',
    overflowX: 'auto'
  };
});
var Name = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', function (_ref2) {
  var theme = _ref2.theme;
  return {
    fontWeight: theme.fontWeight_semiBold
  };
});
var Value = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', function (_ref3) {
  var color = _ref3.color,
      theme = _ref3.theme;

  if (color) {
    return {
      border: color === '#fff' ? '1px solid ' + theme.color_gray_50 : 'none',
      backgroundColor: color,
      borderRadius: theme.borderRadius_1,
      color: a11yColor(color),
      display: 'inline-block',
      fontFamily: theme.fontFamily_monospace,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em ' + theme.space_inset_sm
    };
  } else {
    return {
      fontFamily: theme.fontFamily_monospace
    };
  }
});

var a11yColor = function a11yColor(color) {
  var a11y = __WEBPACK_IMPORTED_MODULE_3_colorable___default()({
    main: color,
    white: '#fff',
    black: '#000',
    compact: true
  });

  var whiteContrast = a11y[0].combinations[0].contrast;
  var blackContrast = a11y[0].combinations[1].contrast;

  return whiteContrast > blackContrast ? 'white' : 'black';
};

var getTableRows = function getTableRows(theme, value, valueColor, baseTheme) {
  return Object.keys(theme).map(function (variable) {
    if (variable !== theme[variable]) {
      return _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["d" /* TableRow */], {}, variable, _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["b" /* TableCell */], {}, void 0, _jsx(Name, {}, void 0, variable)), _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["b" /* TableCell */], {}, void 0, _jsx(Value, {
        color: valueColor(theme, variable, baseTheme)
      }, void 0, value(theme, variable, baseTheme))));
    }
  });
};

var _ref5 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["c" /* TableHeaderCell */], {
  scope: 'col'
}, void 0, 'Variable'), _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["c" /* TableHeaderCell */], {
  scope: 'col'
}, void 0, 'Value')));

function VariableTable(_ref4) {
  var baseTheme = _ref4.baseTheme,
      theme = _ref4.theme,
      value = _ref4.value,
      valueColor = _ref4.valueColor;

  return _jsx(Root, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2__Table__["a" /* Table */], {}, void 0, _ref5, _jsx('tbody', {}, void 0, getTableRows(theme, value, valueColor, baseTheme))));
}

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Intro;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Markdown__ = __webpack_require__(21);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Markdown = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Markdown__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    '& > p': _defineProperty({
      color: theme.color_gray_70,
      fontSize: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(20),
      fontWeight: '300',
      maxWidth: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.maxTextWidth, Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(20)),

      '& a > [role="img"]': {
        borderBottomWidth: 2,
        top: 4
      }

    }, theme.bp_moreSpacious, {
      fontSize: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(24),
      maxWidth: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.maxTextWidth, Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(24))
    })
  };
});

function Intro(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Markdown, props);
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardActions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Card__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CardBlock__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardRow__ = __webpack_require__(80);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardActionsAction_spaceInline: baseTheme.space_inline_sm

  }, baseTheme);
};

var styles = {
  action: function action(props) {
    var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_4__CardBlock__["a" /* componentTheme */])(props.theme));
    var rtl = theme.direction === 'rtl';
    var fontSize = theme.CardBlock_fontSize;
    var actionsGap = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.CardActionsAction_spaceInline, fontSize);

    return {
      alignItems: 'center',
      display: 'flex',
      flex: '0 0 auto',
      fontSize: fontSize,
      marginBottom: actionsGap,
      marginLeft: rtl ? null : actionsGap,
      marginRight: rtl ? actionsGap : null
    };
  },
  root: function root(props) {
    var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_3__Card__["a" /* componentTheme */])(props.theme));

    return {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
      // We subtract `theme.CardActionsAction_spaceInline` because of the marginBottom on Action.
      marginBottom: parseFloat(theme.CardRow_marginVertical) - parseFloat(theme.CardActionsAction_spaceInline) + 'em'
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__CardRow__["a" /* default */], styles.root, {
  displayName: 'CardActions'
});
var Action = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.action);

/**
 * The CardActions component allows you to lay out actions inside your [Card](../card).
 */
function CardActions(_ref) {
  var children = _ref.children,
      restProps = _objectWithoutProperties(_ref, ['children']);

  var actions = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (child, index) {
    if (child.type === __WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */]) {
      child = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, { size: 'medium' });
    }
    return _jsx(Action, {}, index, child);
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    restProps,
    actions
  );
}

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardDivider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(29);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardDivider_borderColor: baseTheme.borderColor,
    CardDivider_borderWidth: '1px'

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', function (props) {
  var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* componentTheme */])(props.theme));

  return {
    backgroundColor: theme.CardDivider_borderColor,
    height: theme.CardDivider_borderWidth,
    margin: theme.CardRow_marginVertical + ' 0'
  };
}, {
  displayName: 'CardDivider'
});

/**
 * CardDividers separate content in [Card](../card) to establish hierarchy.
 *
 * Too many dividers will add unnecessary weight to your Card.
 */
function CardDivider(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, _extends({}, props, { role: 'separator' }));
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconExpandLess__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_IconExpandMore__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Card__ = __webpack_require__(29);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardFooter_backgroundColor: baseTheme.color_gray_20,
    CardFooter_borderColor: baseTheme.color_gray_40,

    CardFooterRow_marginVertical: baseTheme.space_stack_sm,
    CardFooterRow_marginVerticalLast: baseTheme.space_stack_md,

    CardFooterTitle_color: baseTheme.color_text,
    CardFooterTitle_fontSize: baseTheme.fontSize_h5,
    CardFooterTitle_fontWeight: baseTheme.fontWeight_bold

  }, baseTheme);
};

/*
 * CardFooter can have children like CardBlock and CardActions. When those
 * components are used directly inside Card they have a specific top/bottom
 * margin, but when they're used within CardFooter, they have a different
 * top/bottom margin. This technique accomplishes that without writing a bunch
 * of descendant selectors.
 */
var footerTheme = function footerTheme(_ref) {
  var theme = _ref.theme;
  return {
    CardRow_marginVertical: componentTheme(theme).CardFooterRow_marginVertical,
    CardRow_marginVerticalLast: componentTheme(theme).CardFooterRow_marginVerticalLast
  };
};

var styles = {
  root: function root(_ref2) {
    var variant = _ref2.variant,
        baseTheme = _ref2.theme;

    var theme = _extends({}, componentTheme(baseTheme), Object(__WEBPACK_IMPORTED_MODULE_6__Card__["a" /* componentTheme */])(baseTheme));

    if (variant) {
      theme = _extends({}, theme, {
        CardFooter_backgroundColor: theme['backgroundColor_' + variant + '_muted'],
        CardFooter_borderColor: theme['borderColor_' + variant + '_muted']
      });
    }

    // [1] Making the footer overlap the Card border. The `calc` bit accounts
    //     for the paddingBottom on Card to prevent margin collapse.
    return {
      backgroundColor: theme.CardFooter_backgroundColor,
      border: '1px solid ' + theme.CardFooter_borderColor,
      borderRadius: '0 0 ' + theme.Card_borderRadius + ' ' + theme.Card_borderRadius,
      margin: '0 -1px calc(-1px - 0.01em) -1px', // [1]
      paddingBottom: '0.01em', // Necessary to prevent margin collapse of last-child
      paddingTop: '0.01em' // Necessary to prevent margin collapse of first-child
    };
  },
  title: function title(props) {
    var theme = _extends({}, componentTheme(props.theme), Object(__WEBPACK_IMPORTED_MODULE_6__Card__["a" /* componentTheme */])(props.theme));
    return {
      alignItems: 'flex-start',
      display: 'flex',
      marginBottom: theme.CardFooterRow_marginVertical,
      marginTop: theme.CardFooterRow_marginVertical,
      paddingLeft: theme.CardRow_paddingHorizontal,
      paddingRight: theme.CardRow_paddingHorizontal
    };
  },
  titleContent: function titleContent(props) {
    var theme = componentTheme(props.theme);

    return {
      color: theme.CardFooterTitle_color,
      flex: '1 1 auto',
      fontSize: theme.CardFooterTitle_fontSize,
      fontWeight: theme.CardFooterTitle_fontWeight,
      margin: 0
    };
  },
  /*
   * A large Button, even with zero'd padding, is still a bit too large in this
   * context. These styles allow the Button to shrink, but the Icon remains the
   * same size.
   */
  toggleButton: function toggleButton(_ref3) {
    var theme = _ref3.theme;
    return {
      flex: '0 0 auto',
      height: 'auto',
      minWidth: 0,
      overflow: 'hidden',
      padding: 0,
      transform: 'translateY(-' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(1) + ')', // Optical alignment

      // Inner
      '& > span': {
        display: 'block',
        margin: '-' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(4)
      },

      '& [role="img"]': {
        fill: theme.color_text
      }
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.root, {
  displayName: 'CardFooter'
});
/*
 * We shouldn't just create a themed 'div', because it won't be able to apply
 * the provided theme to itself, which breaks the expectation of
 * createThemedComponent. So, we theme a simple functional component that
 * returns a 'div' instead.
 */
var Content = Object(__WEBPACK_IMPORTED_MODULE_2__themes__["d" /* createThemedComponent */])(function (props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', props);
}, footerTheme);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.title);
var TitleContent = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('h4', styles.titleContent);
var ToggleButton = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], styles.toggleButton);

/**
 * CardFooter is used to append a visually distinct section to [Card](../card).
 */

var CardFooter = function (_Component) {
  _inherits(CardFooter, _Component);

  function CardFooter() {
    var _ref4;

    var _temp, _this, _ret;

    _classCallCheck(this, CardFooter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref4 = CardFooter.__proto__ || Object.getPrototypeOf(CardFooter)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      isOpen: !_this.props.expandable || Boolean(_this.props.defaultIsOpen)
    }, _this.close = function (event) {
      if (_this.isControlled('isOpen')) {
        _this.closeActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: false };
        }, function () {
          _this.closeActions(event);
        });
      }
    }, _this.closeActions = function (event) {
      _this.props.onClose && _this.props.onClose(event);
    }, _this.open = function (event) {
      if (_this.isControlled('isOpen')) {
        _this.openActions(event);
      } else {
        _this.setState(function () {
          return { isOpen: true };
        }, function () {
          _this.openActions(event);
        });
      }
    }, _this.openActions = function (event) {
      _this.props.onOpen && _this.props.onOpen(event);
    }, _this.toggleOpenState = function (event) {
      var isOpen = _this.getControllableValue('isOpen');
      if (isOpen) {
        _this.close(event);
      } else {
        _this.open(event);
      }
    }, _this.isControlled = function (prop) {
      return _this.props.hasOwnProperty(prop);
    }, _this.getControllableValue = function (key) {
      return _this.isControlled(key) ? _this.props[key] : _this.state[key];
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CardFooter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          expandable = _props.expandable,
          title = _props.title,
          _props$triggerTitle = _props.triggerTitle,
          triggerTitle = _props$triggerTitle === undefined ? CardFooter.defaultProps.triggerTitle : _props$triggerTitle,
          restProps = _objectWithoutProperties(_props, ['children', 'expandable', 'title', 'triggerTitle']);

      var isOpen = Boolean(this.getControllableValue('isOpen'));

      var ExpandCollapseIcon = isOpen ? __WEBPACK_IMPORTED_MODULE_4__Icon_IconExpandLess__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__Icon_IconExpandMore__["a" /* default */];

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        restProps,
        title && _jsx(Title, {}, void 0, _jsx(TitleContent, {}, void 0, title), expandable && _jsx(ToggleButton, {
          onClick: this.toggleOpenState,
          minimal: true,
          iconStart: _jsx(ExpandCollapseIcon, {
            title: triggerTitle(isOpen)
          })
        })),
        isOpen && children && _jsx(Content, {}, void 0, children)
      );
    }
  }]);

  return CardFooter;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

CardFooter.defaultProps = {
  triggerTitle: function triggerTitle(isOpen) {
    return isOpen ? 'Collapse contents' : 'Expand contents';
  }
};
/* harmony default export */ __webpack_exports__["b"] = (CardFooter);

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconDangerSimple__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconSuccessSimple__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconWarningSimple__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardRow__ = __webpack_require__(80);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardStatus_fontSize: baseTheme.fontSize_ui,
    CardStatus_fontWeight: baseTheme.fontWeight_regular,

    CardStatusIcon_margin: baseTheme.space_inline_sm,
    CardStatusIcon_size: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(12)

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__CardRow__["a" /* default */], function (_ref) {
  var baseTheme = _ref.theme,
      variant = _ref.variant;

  var theme = componentTheme(baseTheme);
  var rtl = theme.direction === 'rtl';

  return {
    alignItems: 'center',
    color: theme['color_text_' + variant],
    display: 'flex',
    fontSize: theme.CardStatus_fontSize,
    fontWeight: theme.CardStatus_fontWeight,

    '& > [role="img"]': {
      fill: 'currentcolor',
      height: theme.CardStatusIcon_size,
      marginRight: rtl ? null : theme.CardStatusIcon_margin,
      marginLeft: rtl ? theme.CardStatusIcon_margin : null,
      width: theme.CardStatusIcon_size
    }
  };
}, {
  displayName: 'CardStatus'
});

var statusIcons = {
  danger: _jsx(__WEBPACK_IMPORTED_MODULE_2__Icon_IconDangerSimple__["a" /* default */], {}),
  success: _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconSuccessSimple__["a" /* default */], {}),
  warning: _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_IconWarningSimple__["a" /* default */], {})
};

/**
 * CardStatus provides a standard way of displaying a [Card's](../card) current status.
 */
function CardStatus(_ref2) {
  var children = _ref2.children,
      variant = _ref2.variant,
      restProps = _objectWithoutProperties(_ref2, ['children', 'variant']);

  var rootProps = _extends({
    variant: variant
  }, restProps);
  var icon = statusIcons[variant];

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    icon,
    children
  );
}

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = CardTitle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icon_IconDanger__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icon_IconSuccess__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconWarning__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CardRow__ = __webpack_require__(80);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    CardTitle_color: baseTheme.color_gray_80,
    CardTitle_fontSize: baseTheme.fontSize_h4,
    CardTitle_fontWeight: baseTheme.fontWeight_bold,

    CardTitleAvatar_margin: baseTheme.space_inline_sm,
    CardTitleAvatarSize: baseTheme.size_small,
    CardTitleAvatarSize_large: baseTheme.size_large,

    CardTitleIcon_margin: baseTheme.space_inline_sm,

    CardTitleSecondaryText_fontSize: baseTheme.fontSize_mouse,
    CardTitleSecondaryText_fontWeight: baseTheme.fontWeight_regular,

    CardSubtitle_color: baseTheme.color_gray_80,
    CardSubtitle_fontSize: baseTheme.fontSize_mouse,
    CardSubtitle_fontWeight: baseTheme.fontWeight_regular,
    CardSubtitle_marginTop: baseTheme.space_stack_sm

  }, baseTheme);
};

var styles = {
  avatar: function avatar(_ref) {
    var subtitle = _ref.subtitle,
        baseTheme = _ref.theme;

    var theme = componentTheme(baseTheme);
    var rtl = theme.direction === 'rtl';
    var width = subtitle ? theme.CardTitleAvatarSize_large : theme.CardTitleAvatarSize;

    return {
      flex: '0 0 auto',
      marginLeft: rtl ? theme.CardTitleAvatar_margin : null,
      marginRight: rtl ? null : theme.CardTitleAvatar_margin,
      width: width,

      '&[class] > *': {
        height: 'auto',
        width: '100%'
      }
    };
  },
  inner: {
    flex: '1 1 auto'
  },
  secondaryText: function secondaryText(props) {
    var theme = componentTheme(props.theme);
    var fontSize = theme.CardTitleSecondaryText_fontSize;

    return _extends({
      flex: '0 0 auto',
      fontSize: fontSize,
      fontWeight: theme.CardTitleSecondaryText_fontWeight,
      transform: 'translateY(' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(5), fontSize) + ')' }, {
      display: 'inline-block',
      maxWidth: '33%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      wordWrap: 'normal'
    });
  },
  root: {
    display: 'flex'
  },
  subtitle: function subtitle(_ref2) {
    var avatar = _ref2.avatar,
        baseTheme = _ref2.theme;

    var theme = componentTheme(baseTheme);
    var fontSize = theme.CardSubtitle_fontSize;

    return {
      color: theme.CardSubtitle_color,
      fontSize: fontSize,
      fontWeight: theme.CardSubtitle_fontWeight,
      margin: 0,
      marginTop: avatar ? null : Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.CardSubtitle_marginTop, fontSize)
    };
  },
  title: function title(_ref3) {
    var baseTheme = _ref3.theme,
        variant = _ref3.variant;

    var theme = componentTheme(baseTheme);
    var rtl = theme.direction === 'rtl';

    return {
      alignItems: 'flex-start',
      display: 'flex',

      '& > [role="img"]': {
        fill: variant ? theme['color_text_' + variant] : null,
        marginLeft: rtl ? theme.CardTitleIcon_margin : null,
        marginRight: rtl ? null : theme.CardTitleIcon_margin,
        position: 'relative',
        top: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(4) // optical alignment
      }
    };
  },
  titleContent: function titleContent(_ref4) {
    var actions = _ref4.actions,
        baseTheme = _ref4.theme;

    var theme = componentTheme(baseTheme);
    var rtl = theme.direction === 'rtl';
    var fontSize = theme.CardTitle_fontSize;
    var actionsMargin = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(theme.CardTitleIcon_margin, fontSize);

    return {
      color: theme.CardTitle_color,
      flex: '1 1 auto',
      fontSize: fontSize,
      fontWeight: theme.CardTitle_fontWeight,
      margin: 0,
      marginLeft: actions && rtl ? actionsMargin : null,
      marginRight: actions && !rtl ? actionsMargin : null
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__CardRow__["a" /* default */], styles.root, {
  displayName: 'CardTitle'
});
var Avatar = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.avatar);
var Inner = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.inner);
var SecondaryText = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.secondaryText);
var Subtitle = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('h4', styles.subtitle);
var Title = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.title);
var TitleContent = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('h3', styles.titleContent);

var variantIcons = {
  danger: _jsx(__WEBPACK_IMPORTED_MODULE_2__Icon_IconDanger__["a" /* default */], {
    size: 'medium'
  }),
  success: _jsx(__WEBPACK_IMPORTED_MODULE_3__Icon_IconSuccess__["a" /* default */], {
    size: 'medium'
  }),
  warning: _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_IconWarning__["a" /* default */], {
    size: 'medium'
  })
};

/**
 * CardTitle displays a Card title and an optional subtitle.
 * You can put CardTitle in any order in relation to other root components of
 * [Card](../card).
 */
function CardTitle(_ref5) {
  var actions = _ref5.actions,
      avatar = _ref5.avatar,
      children = _ref5.children,
      secondaryText = _ref5.secondaryText,
      subtitle = _ref5.subtitle,
      variant = _ref5.variant,
      restProps = _objectWithoutProperties(_ref5, ['actions', 'avatar', 'children', 'secondaryText', 'subtitle', 'variant']);

  var rootProps = _extends({}, restProps);

  var secondaryComponent = actions ? __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(actions, function (action, index) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(action, { key: index });
  }) : secondaryText ? _jsx(SecondaryText, {}, void 0, secondaryText) : null;

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    avatar && _jsx(Avatar, {
      subtitle: subtitle
    }, void 0, avatar),
    _jsx(Inner, {}, void 0, _jsx(Title, {
      variant: variant
    }, void 0, variant && variantIcons[variant], _jsx(TitleContent, {
      actions: actions
    }, void 0, children), secondaryComponent), subtitle && _jsx(Subtitle, {
      avatar: avatar
    }, void 0, subtitle))
  );
}

/***/ }),
/* 250 */,
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuDivider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuDivider_borderColor: baseTheme.borderColor,
    MenuDivider_borderWidth: '1px',
    MenuDivider_margin: baseTheme.space_stack_sm

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', function (props) {
  var theme = componentTheme(props.theme);

  return {
    backgroundColor: theme.MenuDivider_borderColor,
    height: theme.MenuDivider_borderWidth,
    margin: theme.MenuDivider_margin + ' 0'
  };
}, {
  displayName: 'MenuDivider'
});

/**
 * MenuDividers separate [MenuItems](../menu-item) and [MenuGroups](../menu-group) to establish hierarchy in a [Menu](../menu) with several options.
 *
 * MenuDividers are not merely design elements to visually separate options.
 * Rather, the are a way to logically group choices.
 * Too many dividers will add unnecessary weight to your Menu.
 */
function MenuDivider(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, _extends({}, props, { role: 'separator' }));
}

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return componentTheme; });
/* harmony export (immutable) */ __webpack_exports__["b"] = MenuGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MenuGroupTitle__ = __webpack_require__(150);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var componentTheme = function componentTheme(baseTheme) {
  return _extends({
    MenuGroup_margin: baseTheme.space_stack_sm

  }, baseTheme);
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', function (props) {
  var theme = componentTheme(props.theme);

  return {
    margin: theme.MenuGroup_margin + ' 0',
    '&:first-child,& + &': {
      marginTop: 0
    },

    '&:last-child': {
      marginBottom: 0
    }
  };
}, {
  displayName: 'MenuGroup'
});

/**
 * MenuGroups assemble [MenuItems](../menu-item) and can display a title.
 * Grouping Menu options provides context clues to users about related actions.
 * An optional title can be added to reinforce the intent of the grouping.
 */
function MenuGroup(_ref) {
  var children = _ref.children,
      title = _ref.title,
      restProps = _objectWithoutProperties(_ref, ['children', 'title']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    restProps,
    title && _jsx(__WEBPACK_IMPORTED_MODULE_2__MenuGroupTitle__["b" /* default */], {}, void 0, title),
    children
  );
}

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var babelPluginFlowReactPropTypes_proptype_Item = __webpack_require__(52).babelPluginFlowReactPropTypes_proptype_Item || __webpack_require__(3).any; /**
                                                                                                                                                         * Copyright 2017 CA
                                                                                                                                                         *
                                                                                                                                                         * Licensed under the Apache License, Version 2.0 (the "License");
                                                                                                                                                         * you may not use this file except in compliance with the License.
                                                                                                                                                         * You may obtain a copy of the License at
                                                                                                                                                         *
                                                                                                                                                         *    http://www.apache.org/licenses/LICENSE-2.0
                                                                                                                                                         *
                                                                                                                                                         * Unless required by applicable law or agreed to in writing, software
                                                                                                                                                         * distributed under the License is distributed on an "AS IS" BASIS,
                                                                                                                                                         * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
                                                                                                                                                         * See the License for the specific language governing permissions and
                                                                                                                                                         * limitations under the License.
                                                                                                                                                         */

var babelPluginFlowReactPropTypes_proptype_Items = __webpack_require__(27).babelPluginFlowReactPropTypes_proptype_Items || __webpack_require__(3).any;

var ItemMatcher = function ItemMatcher() {
  var _this = this;

  _classCallCheck(this, ItemMatcher);

  this.keys = '';

  this.findMatchingItem = function (items, highlightedIndex, key) {
    if (!_this.isMatchableCharacter(key)) {
      return;
    }

    _this.searchIndex = highlightedIndex === undefined ? 0 : highlightedIndex + 1;

    _this.keys += key;
    _this.resetKeysAfterDelay();

    var match = _this.findMatchingItemInRange(items, _this.searchIndex, items.length) || _this.findMatchingItemInRange(items, 0, _this.searchIndex);

    return match;
  };

  this.findMatchingItemInRange = function (items, start, end) {
    var keys = _this.keys.toLowerCase();
    for (var index = start; index < end; index++) {
      var text = items[index].text;

      if (text && typeof text === 'string' && text.toLowerCase().indexOf(keys) === 0) {
        return items[index];
      }
    }
  };

  this.resetKeysAfterDelay = function () {
    if (_this.keysTimer) {
      global.clearTimeout(_this.keysTimer);
      _this.keysTimer = null;
    }

    _this.keysTimer = global.setTimeout(function () {
      _this.keys = '';
      _this.keysTimer = null;
    }, 500);
  };

  this.isMatchableCharacter = function (key) {
    return key.length === 1 && /\S/.test(key);
  };
}

// Exclude standalone modifier keys, but allow use as combinator
// e.g. Reject standalone ALT key, but ALT+m which creates µ is okay
;

/* harmony default export */ __webpack_exports__["a"] = (ItemMatcher);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconChevronRight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z'
}));

/* eslint-disable prettier/prettier */
function IconChevronRight(props) {
  var iconProps = _extends({
    rtl: true
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconChevronRight.category = 'navigation';

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconFavorite;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z'
}));

/* eslint-disable prettier/prettier */
function IconFavorite(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconFavorite.category = 'action';

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconArrowDropDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M7 10l5 5 5-5z'
}));

/* eslint-disable prettier/prettier */
function IconArrowDropDown(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconArrowDropDown.category = 'navigation';

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_Icon__ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z'
}));

/* eslint-disable prettier/prettier */
function IconInfo(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1__src_Icon__["a" /* default */],
    iconProps,
    _ref
  );
}

IconInfo.category = 'action';

/***/ }),
/* 258 */,
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_react_dom__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_react_router_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_glamor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__themes_ThemeProvider__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__app_App__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__app_demos_routes__ = __webpack_require__(525);























































































var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









__webpack_require__(526);

// Enable Glamor simulate helper
Object(__WEBPACK_IMPORTED_MODULE_89_glamor__["simulations"])(true);

Object(__WEBPACK_IMPORTED_MODULE_87_react_dom__["render"])(_jsx(__WEBPACK_IMPORTED_MODULE_88_react_router_dom__["a" /* BrowserRouter */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_90__themes_ThemeProvider__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_91__app_App__["a" /* default */], {
  demoRoutes: __WEBPACK_IMPORTED_MODULE_92__app_demos_routes__["a" /* default */]
}))), global.document.getElementById('app'));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__blue__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dusk__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__gray__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__green__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indigo__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lime__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__magenta__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__orange__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__purple__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__red__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__sky__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__slate__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__teal__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__yellow__ = __webpack_require__(128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


















/* harmony default export */ __webpack_exports__["a"] = (_extends({}, __WEBPACK_IMPORTED_MODULE_0__blue__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__dusk__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__gray__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__green__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__indigo__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__lime__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__magenta__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__orange__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__purple__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__red__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__sky__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__slate__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__teal__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__yellow__["a" /* default */]));

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyedColors__ = __webpack_require__(192);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/* harmony default export */ __webpack_exports__["a"] = (function (key, level) {
  return __WEBPACK_IMPORTED_MODULE_0__keyedColors__["a" /* default */][key] ? __WEBPACK_IMPORTED_MODULE_0__keyedColors__["a" /* default */][key][key + '_' + level] : undefined;
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__keyedColors__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(115);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/* harmony default export */ __webpack_exports__["a"] = (function (key, level) {
  if (__WEBPACK_IMPORTED_MODULE_0__keyedColors__["a" /* default */][key]) {
    return __WEBPACK_IMPORTED_MODULE_0__keyedColors__["a" /* default */][key].a11y_text_light.indexOf(level) != -1 ? __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].white : __WEBPACK_IMPORTED_MODULE_1__common__["a" /* default */].black;
  }
  return undefined;
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BaselineGrid__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__siteColors__ = __webpack_require__(37);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












var siteTheme = {
  baseline_1: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12),
  baseline_2: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 2),
  baseline_3: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 3),
  baseline_4: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 4),
  baseline_5: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 5),
  baseline_6: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 6),
  baseline_7: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 7),
  baseline_8: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 8),
  baseline_9: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 9),
  baseline_10: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 10),

  bp_moreSpacious: '@media(min-width: 48em)',

  bp_home_smallH3AndDown: '@media(max-width: 28.999em)',
  bp_home_bigH3: '@media(min-width: 29em)',
  bp_home_navCollapsedAndDown: '@media(max-width: 38.999em)',
  bp_home_navExpanded: '@media(min-width: 39em)',
  bp_home_getStartedLeftAlign: '@media(min-width: 43em)',
  bp_home_betweenMoreSpaciousAndGuidelinesMultiColumn: '@media(min-width: 48em) and (max-width: 60.999em)',
  bp_home_guidelinesMultiColumn: '@media(min-width: 61em)',

  bp_interior_bestPracticesMultiColumn: '@media(min-width: 61em)',

  maxContentWidth: '70em',
  maxTextWidth: '50em',
  navLink_color_active_narrow: __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default()(0.12, __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade),
  sidebarWidth: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(200), // 180 + 20 for scrollbar
  textShadow: '2px 2px 2px rgba(0,0,0,0.2)',

  borderColor: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].slate,
  borderColor_focus: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade,
  color_text: __WEBPACK_IMPORTED_MODULE_6__themes__["f" /* mineralTheme */].color_gray_80,
  color_text_primary: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade,
  fontFamily: null,
  fontFamily_headline: 'franklin-gothic-urw, ' + __WEBPACK_IMPORTED_MODULE_6__themes__["f" /* mineralTheme */].fontFamily_system,

  SectionPaddingHorizontal: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(30),
  SectionPaddingHorizontalWide: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(100),
  SectionPaddingVertical: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 6), // theme.baseline_6
  SectionPaddingVerticalWide: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(12 * 10), // theme.baseline_10

  SiteButton_backgroundColor_hover: __WEBPACK_IMPORTED_MODULE_6__themes__["f" /* mineralTheme */].color_white,
  SiteButton_backgroundColor_primary: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade,
  SiteButton_backgroundColor_primary_active: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_active,
  SiteButton_backgroundColor_primary_focus: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_focus,
  SiteButton_backgroundColor_primary_hover: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_hover,

  SiteHeading_color_2: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].slateDarker,
  SiteHeading_color_3: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade,
  SiteHeading_color_4: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].slateDarker,
  SiteHeading_fontFamily: 'franklin-gothic-urw, ' + __WEBPACK_IMPORTED_MODULE_6__themes__["f" /* mineralTheme */].fontFamily_system,
  SiteHeading_fontSize_1: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(40),
  SiteHeading_fontSize_1_wide: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(48),
  SiteHeading_fontSize_2: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(33),
  SiteHeading_fontSize_2_wide: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(40),
  SiteHeading_fontSize_3: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(23),
  SiteHeading_fontSize_3_wide: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(28),
  SiteHeading_fontSize_4: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(18),
  SiteHeading_fontSize_4_wide: Object(__WEBPACK_IMPORTED_MODULE_5__styles__["d" /* pxToEm */])(22),
  SiteHeading_fontWeight_1: '300',
  SiteHeading_fontWeight_2: '300',
  SiteHeading_fontWeight_3: '300',
  SiteHeading_fontWeight_4: '500',
  SiteHeading_lineHeight_1: '1.1',
  SiteHeading_lineHeight_2: '1.2',
  SiteHeading_lineHeight_3: '1.5',
  SiteHeading_lineHeight_4: '1.5',

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_focus,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_9__siteColors__["a" /* default */].jade_hover
};

var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_7__BaselineGrid__["a" /* default */], {});

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    if (true) {
      // Analytics tracking of push state page views
      props.history.listen(function (location, action) {
        if (__WEBPACK_IMPORTED_MODULE_3_exenv__["canUseDOM"] && action === 'PUSH') {
          global.window.gtag('config', "UA-107538931-1", {
            page_path: location.pathname
          });
        }
      });
    }
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (__WEBPACK_IMPORTED_MODULE_3_exenv__["canUseDOM"] && this.props.location !== prevProps.location) {
        global.window.scrollTo(0, 0);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var demoRoutes = this.props.demoRoutes;

      var _ref = _jsx(__WEBPACK_IMPORTED_MODULE_8__Router__["a" /* default */], {
        demoRoutes: demoRoutes
      });

      return _jsx(__WEBPACK_IMPORTED_MODULE_6__themes__["a" /* ThemeProvider */], {
        theme: siteTheme
      }, void 0, _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* Switch */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */], {
        exact: true,
        strict: true,
        path: '/:url*',
        render: function render(props) {
          return _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */], {
            to: props.location.pathname + '/'
          });
        }
      }), _jsx(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */], {
        render: function render() {
          return _ref;
        }
      })), _ref2));
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(App));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStyledComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_glamorous__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__componentStyleReset__ = __webpack_require__(430);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




function createStyledComponent(element, styles) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var includeStyleReset = options.includeStyleReset,
      restOptions = _objectWithoutProperties(options, ['includeStyleReset']);

  var outStyles = void 0;

  if (includeStyleReset) {
    outStyles = function outStyles(props, context) {
      var componentStyles = typeof styles === 'function' ? styles(props, context) : styles;

      return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_1__componentStyleReset__["a" /* default */])(props), componentStyles);
    };
  } else {
    outStyles = styles;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_glamorous__["b" /* default */])(element, restOptions)(outStyles);
}

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var theme = _ref.theme;

  return {
    boxSizing: 'border-box',
    color: theme.color_text,
    fontFamily: theme.fontFamily ? theme.fontFamily + ', ' + theme.fontFamily_system : '' + theme.fontFamily_system,
    fontSize: theme.fontSize_base + 'px',
    lineHeight: theme.lineHeight,
    outline: 0,
    '& *,& *::before,& *::after': {
      boxSizing: 'inherit'
    }
  };
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getResponsiveStyles;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/*
 * Converts an array of breakpoints (numbers and theme variable keys) to an
 * array of CSS media query strings.
 *
 * Input: [100, 200]
 *
 * Ouput: [
 *   '@media (min-width: 100px) and (max-width: 199px)',
 *   '@media (min-width: 200px)'
 * ]
 */
var getMediaQueries = function getMediaQueries(breakpoints, theme) {
  var queries = [];

  var getQueryWidth = function getQueryWidth(value) {
    return typeof value === 'number' ? value : theme['breakpoint_' + value];
  };

  for (var i = 0; i <= breakpoints.length; i++) {
    if (i === breakpoints.length) {
      queries.push('@media (min-width: ' + getQueryWidth(breakpoints[i - 1]) + 'px)');
    } else if (i > 0) {
      queries.push('@media (min-width: ' + getQueryWidth(breakpoints[i - 1]) + 'px) and (max-width: ' + (getQueryWidth(breakpoints[i]) - 1) + 'px)');
    }
  }

  return queries;
};

/*
 * Given array that can contain null values and an index, checks if array[index]
 * is null. If it is, then it returns the next-most-previous non-null value in
 * the array until it gets to array[0], which it returns regardless.
 */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var getPrevNonNull = function getPrevNonNull(values, index) {
  var value = Array.isArray(values) && values[index];
  if (index > 0) {
    return value === null ? getPrevNonNull(values, index - 1) : value;
  } else {
    return value;
  }
};

/*
 * Returns an object of style properties and their values (as interpreted
 * through mapValueToProperty, if provided). If an index is provided, then each
 * style property is an array, and this will use array[index] as the value.
 */
var getStyles = function getStyles(styleKeys, styles, mapValueToProperty, index) {
  return styleKeys.reduce(function (acc, property) {
    var indexInUse = index || 0;
    var styleValue = styles[property];
    var actualValue = Array.isArray(styleValue) ? getPrevNonNull(styleValue, indexInUse) : styleValue;
    acc[property] = mapValueToProperty ? mapValueToProperty(property, actualValue) : actualValue;

    return acc;
  }, {});
};

/*
 * Helper to potentially disperse an object of style properties (whole values
 * can be an array) across a provided (optional) array of breakpoints, which is
 * converted to an object with CSS media query string keys.
 *
 * See tests for input/output.
 */
function getResponsiveStyles(_ref) {
  var breakpoints = _ref.breakpoints,
      mapValueToProperty = _ref.mapValueToProperty,
      styles = _ref.styles,
      theme = _ref.theme;

  var styleKeys = Object.keys(styles);

  if (breakpoints) {
    var breakpointsLength = breakpoints.length;
    var mediaQueries = getMediaQueries(breakpoints, theme);
    var responsiveStyleKeys = styleKeys.filter(function (key) {
      var value = styles[key];
      if (value && Array.isArray(value)) {
        /*
         * If a style property is an array, that array must be one longer than
         * the breakpoints array. The first value is the no-breakpoint case, the
         * second value corresponds to the first breakpoint, etc...
         */
        if (value.length === breakpointsLength + 1) {
          return true;
        } else {
          // prettier-ignore
          throw new Error(key + '.length (' + value.length + ') must equal breakpoints.length + 1 (' + (breakpointsLength + 1) + ')');
        }
      }
    });
    var nonResponsiveStyleKeys = styleKeys.filter(function (key) {
      return !Array.isArray(styles[key]);
    });

    // Start with the non-responsive style properties and the first value of the
    // responsive properties.
    var result = _extends({}, getStyles(nonResponsiveStyleKeys, styles, mapValueToProperty), getStyles(responsiveStyleKeys, styles, mapValueToProperty, 0));

    return mediaQueries.reduce(function (acc, query, index) {
      acc[query] = _extends({}, getStyles(responsiveStyleKeys, styles, mapValueToProperty, index + 1));
      return acc;
    }, result);
  } else {
    return getStyles(styleKeys, styles, mapValueToProperty);
  }
}

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createThemedComponent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamorous__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ThemeProvider__ = __webpack_require__(113);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function getComponentDisplayName(Component) {
  return typeof Component === 'string' ? Component : Component.displayName || Component.name || 'Component';
}

function createThemedComponent(ComponentToTheme, theme) {
  var ThemedComponent = function ThemedComponent(props, context) {
    var outTheme = typeof theme === 'function' ? theme(props, context) : theme;

    var ignore = props.theme,
        outProps = _objectWithoutProperties(props, ['theme']);

    return _jsx(__WEBPACK_IMPORTED_MODULE_2__ThemeProvider__["a" /* default */], {
      theme: outTheme
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ComponentToTheme, outProps));
  };

  ThemedComponent.displayName = 'Themed(' + getComponentDisplayName(ComponentToTheme) + ')';

  return Object(__WEBPACK_IMPORTED_MODULE_1_glamorous__["c" /* withTheme */])(ThemedComponent);
}

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapComponentThemes;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
  * Generates a new component theme based on the theme of another component.
  */
function mapComponentThemes(source, override, baseTheme) {
  var REGEXP_SOURCE_NAME = new RegExp("^" + source.name);
  var sourceThemeWithRenamedKeys = Object.keys(source.theme).reduce(function (acc, sourceKey) {
    if (REGEXP_SOURCE_NAME.test(sourceKey)) {
      var overrideKey = sourceKey.replace(REGEXP_SOURCE_NAME, override.name);
      acc[overrideKey] = source.theme[sourceKey];
    }
    return acc;
  }, {});

  return _extends({}, baseTheme, sourceThemeWithRenamedKeys, override.theme);
}

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('div', function (_ref) {
  var fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      offset = _ref.offset,
      theme = _ref.theme;

  var rowHeight = fontSize * lineHeight;

  return {
    backgroundImage: 'repeating-linear-gradient(\n        0deg,\n        rgba(0,255,255,0.07),\n        rgba(0,255,255,0.07) ' + rowHeight / 2 + 'px,\n        rgba(0,255,255,0.14) ' + rowHeight / 2 + 'px,\n        rgba(0,255,255,0.14) ' + rowHeight + 'px,\n        rgba(255,0,255,0.07) ' + rowHeight + 'px,\n        rgba(255,0,255,0.07) ' + rowHeight * 1.5 + 'px,\n        rgba(255,0,255,0.14) ' + rowHeight * 1.5 + 'px,\n        rgba(255,0,255,0.14) ' + rowHeight * 2 + 'px\n      )',
    backgroundPosition: '0 ' + offset + 'px',
    bottom: 0,
    left: 0,
    pointerEvents: 'none',
    position: 'fixed',
    right: 0,
    top: 0,
    zIndex: theme.zIndex_1600
  };
});

function BaselineGrid(_ref2) {
  var _ref2$fontSize = _ref2.fontSize,
      fontSize = _ref2$fontSize === undefined ? 16 : _ref2$fontSize,
      _ref2$lineHeight = _ref2.lineHeight,
      lineHeight = _ref2$lineHeight === undefined ? 1.5 : _ref2$lineHeight,
      location = _ref2.location,
      _ref2$offset = _ref2.offset,
      offset = _ref2$offset === undefined ? -8 : _ref2$offset;

  var rootProps = {
    fontSize: fontSize,
    lineHeight: lineHeight,
    offset: offset
  };

  return location && location.search === '?grid' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, rootProps) : null;
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router__["a" /* withRouter */])(BaselineGrid));

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Router;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_flatten__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_flatten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_flatten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_createKeyMap__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ComponentDocExample__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Page__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_ComponentDoc__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Loadable__ = __webpack_require__(148);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */











var AsyncHome = Object(__WEBPACK_IMPORTED_MODULE_8__Loadable__["a" /* default */])({
  loader: function loader() {
    return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 221));
  }
});

var getPageHeader = function getPageHeader(heading, title) {
  return heading + '\n\n# ' + title;
};

var _ref3 = _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], {
  path: '/',
  exact: true,
  component: AsyncHome
});

function Router(_ref) {
  var demoRoutes = _ref.demoRoutes;

  var flatDemoRoutes = Object(__WEBPACK_IMPORTED_MODULE_3__utils_createKeyMap__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_lodash_flatten___default()(demoRoutes), 'slug');

  var routes = __WEBPACK_IMPORTED_MODULE_6__pages__["a" /* default */].map(function (section, sectionIndex) {
    return section.pages.map(function (page, pageIndex) {
      var _ref2 = _jsx(page.component, {});

      return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], {
        path: page.path,
        render: function render() {
          var pageMeta = {
            canonicalLink: 'https://mineral-ui.com' + page.path,
            description: page.description,
            title: page.title + ' | Mineral UI'
          };
          var pageProps = {
            demoRoutes: demoRoutes,
            headerContent: getPageHeader(section.heading, page.title),
            pageMeta: pageMeta,
            type: sectionIndex
          };
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],
            pageProps,
            _ref2
          );
        }
      }, 'page-' + sectionIndex + '-' + pageIndex);
    });
  })
  // Flatten array of routes arrays
  .reduce(function (acc, routes) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(routes));
  }, []);

  return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */], {}, void 0, _ref3, routes, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], {
    path: '/components/:componentId/:exampleId',
    render: function render(route) {
      var _route$match$params = route.match.params,
          componentId = _route$match$params.componentId,
          exampleId = _route$match$params.exampleId;
      // $FlowFixMe

      var selectedDemo = flatDemoRoutes[componentId || 'button'];
      var chromeless = route.location.search === '?chromeless';
      var pageProps = {
        chromeless: chromeless,
        demoRoutes: demoRoutes,
        pageMeta: {
          description: selectedDemo.description,
          title: selectedDemo.title + ' | Mineral UI'
        },
        slug: selectedDemo.slug
      };

      var AsyncComponentDocExample = Object(__WEBPACK_IMPORTED_MODULE_8__Loadable__["a" /* default */])({
        loader: function loader() {
          return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 258));
        },
        render: function render(_ref4) {
          var fullDemos = _ref4.default;

          var selectedFullDemo = fullDemos[componentId];
          var selectedExample = selectedFullDemo.examples.find(function (example) {
            return example.id === exampleId;
          });

          var exampleProps = _extends({
            chromeless: chromeless,
            componentName: selectedFullDemo.title,
            standalone: true
          }, selectedExample);

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ComponentDocExample__["a" /* default */], exampleProps);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],
        pageProps,
        _jsx(AsyncComponentDocExample, {})
      );
    }
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */], {
    path: '/components/:componentId',
    render: function render(route) {
      var componentId = route.match.params.componentId || 'button';
      // $FlowFixMe
      var selectedDemo = flatDemoRoutes[componentId];

      if (selectedDemo.redirect) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */], {
          to: '/components/' + selectedDemo.redirect
        });
      }

      var pageMeta = {
        canonicalLink: 'https://mineral-ui.com/components/' + selectedDemo.title.toLowerCase(),
        description: selectedDemo.description,
        title: selectedDemo.title + ' | Mineral UI'
      };
      var pageProps = {
        demoRoutes: demoRoutes,
        headerContent: getPageHeader('Components', selectedDemo.title),
        pageMeta: pageMeta,
        slug: selectedDemo.slug
      };

      var AsyncComponentDoc = Object(__WEBPACK_IMPORTED_MODULE_8__Loadable__["a" /* default */])({
        loader: function loader() {
          return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 258));
        },
        render: function render(_ref5) {
          var fullDemos = _ref5.default;

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__pages_ComponentDoc__["a" /* default */], fullDemos[componentId]);
        }
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__Page__["a" /* default */],
        pageProps,
        _jsx(AsyncComponentDoc, {})
      );
    }
  }));
}

/***/ }),
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = generateId;
/* unused harmony export resetId */
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var currentId = 0;

function generateId() {
  currentId += 1;
  return currentId.toString();
}

function resetId() {
  currentId = 0;
}

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = composeEventHandlers;
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function composeEventHandlers() {
  for (var _len = arguments.length, handlers = Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  var fns = handlers.filter(function (fn) {
    return Boolean(fn);
  });

  if (fns.length === 0) {
    return undefined;
  } else if (fns.length === 1) {
    return fns[0];
  } else {
    return function (event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return fns.some(function (fn) {
        fn.apply(undefined, [event].concat(args));
        return event.defaultPrevented;
      });
    };
  }
}

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = composePropsWithGetter;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function composePropsWithGetter(props, getter, scope) {
  return _extends({}, props, getter && getter(props, scope));
}

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__colors__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Heading__ = __webpack_require__(146);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var ErrorBlock = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('div', function (_ref) {
  var theme = _ref.theme;
  return {
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1__colors__["d" /* red */].red_10,
    border: '1px solid ' + __WEBPACK_IMPORTED_MODULE_1__colors__["d" /* red */].red_20,
    color: theme.color_text_danger,
    lineHeight: theme.lineHeight_prose,
    padding: theme.space_inset_lg,
    textAlign: 'center'
  };
});

var Button = Object(__WEBPACK_IMPORTED_MODULE_3__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */], {
  borderColor_focus: __WEBPACK_IMPORTED_MODULE_1__colors__["d" /* red */].red_60
});

var ErrorBoundary = function (_Component) {
  _inherits(ErrorBoundary, _Component);

  function ErrorBoundary() {
    var _ref2;

    var _temp, _this, _ret;

    _classCallCheck(this, ErrorBoundary);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = ErrorBoundary.__proto__ || Object.getPrototypeOf(ErrorBoundary)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      hasError: false
    }, _this.reRender = function (action) {
      if (action) {
        action();
      }
      _this.setState({ hasError: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ErrorBoundary, [{
    key: 'componentDidCatch',
    value: function componentDidCatch(error, info) {
      this.setState({ hasError: true });
      console.error(info);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          buttonLabel = _props.buttonLabel,
          children = _props.children,
          errorMessage = _props.errorMessage,
          onReRender = _props.onReRender;

      if (this.state.hasError) {
        var headingProps = {
          as: 'h4',
          level: 5,
          css: { color: 'currentColor' }
        };
        var buttonProps = {
          'aria-label': errorMessage + ' ' + buttonLabel,
          autoFocus: true,
          size: 'small',
          onClick: function onClick() {
            _this2.reRender(onReRender);
          }
        };
        return _jsx(ErrorBlock, {}, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_5__Heading__["a" /* default */],
          headingProps,
          errorMessage
        ), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Button,
          buttonProps,
          buttonLabel
        ));
      }
      return children;
    }
  }]);

  return ErrorBoundary;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

ErrorBoundary.defaultProps = {
  errorMessage: 'Oops, something went wrong. Check your console for details.',
  buttonLabel: 'Reload component'
};
/* harmony default export */ __webpack_exports__["a"] = (ErrorBoundary);

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LiveProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dedent__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_dedent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_dedent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_live__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getCodeBlockStyles__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__siteColors__ = __webpack_require__(37);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var styles = {
  livePreview: function livePreview(_ref) {
    var backgroundColor = _ref.backgroundColor,
        chromeless = _ref.chromeless,
        theme = _ref.theme;

    return chromeless ? { padding: '1rem' } : {
      backgroundColor: backgroundColor,
      border: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(__WEBPACK_IMPORTED_MODULE_7__siteColors__["a" /* default */].slate, 0.3),
      fontFamily: 'comic sans ms',
      padding: theme.space_inset_md,

      '& ::selection': {
        backgroundColor: 'highlight'
      }
    };
  },
  liveEditor: function liveEditor(_ref2) {
    var theme = _ref2.theme;
    return _extends({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_getCodeBlockStyles__["a" /* default */])(theme), {

      '&:focus': {
        outline: '6px solid ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.color_text_primary, 0.3)
      }
    });
  },
  liveError: function liveError(_ref3) {
    var theme = _ref3.theme;
    return {
      backgroundColor: '#fce3e3', // color.red_10
      color: theme.color_text_danger,
      fontFamily: theme.fontFamily_monospace,
      fontSize: theme.fontSize_mouse,
      lineHeight: theme.lineHeight_prose,
      overflow: 'auto',
      padding: '0 0.5rem', // Match value of the live-editor from .prism-code
      whiteSpace: 'pre',

      '&:first-line': {
        fontFamily: theme.fontFamily_system,
        fontWeight: theme.fontWeight_semiBold,
        // Can't use margin/padding here, so this is to space off the heading
        // from the code
        lineHeight: 2 * theme.lineHeight_prose
      }
    };
  }
};

var MyLivePreview = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3_react_live__["c" /* LivePreview */], styles.livePreview, {
  rootEl: 'div'
});
var MyLiveEditor = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3_react_live__["a" /* LiveEditor */], styles.liveEditor);
var MyLiveError = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3_react_live__["b" /* LiveError */], styles.liveError);

var _ref5 = _jsx(MyLiveEditor, {
  ignoreTabKey: true
}, 0);

var _ref6 = _jsx(MyLiveError, {}, 1);

function LiveProvider(_ref4) {
  var backgroundColor = _ref4.backgroundColor,
      chromeless = _ref4.chromeless,
      hideSource = _ref4.hideSource,
      scope = _ref4.scope,
      source = _ref4.source,
      restProps = _objectWithoutProperties(_ref4, ['backgroundColor', 'chromeless', 'hideSource', 'scope', 'source']);

  var liveProviderProps = _extends({
    code: __WEBPACK_IMPORTED_MODULE_1_dedent___default()(source),
    scope: scope,
    mountStylesheet: false
  }, restProps);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3_react_live__["d" /* LiveProvider */],
    liveProviderProps,
    _jsx(__WEBPACK_IMPORTED_MODULE_5__themes__["a" /* ThemeProvider */], {}, void 0, _jsx(MyLivePreview, {
      backgroundColor: backgroundColor,
      chromeless: chromeless
    })),
    !hideSource && [_ref5, _ref6]
  );
}

/***/ }),
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MarkdownTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Table__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__ = __webpack_require__(463);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function MarkdownTable(_ref) {
  var children = _ref.children;

  // we're going to assume there's a table header here
  var _children = _slicedToArray(children, 2),
      head = _children[0],
      body = _children[1];

  // a bunch of the elements returned by marksy are null,
  // so there's a lot of filtering and finding with the identity


  var headNode = head.find(function (element) {
    return element;
  });
  var headRow = headNode && headNode.props.children.find(function (row) {
    return row;
  });
  var headCells = headRow && headRow.props.children.filter(function (cell) {
    return cell;
  }).map(function (cell, index) {
    return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["c" /* TableHeaderCell */], {}, index, cell.props.children);
  });
  var bodyNode = body.find(function (element) {
    return element;
  });
  var bodyRows = bodyNode && bodyNode.props.children.filter(function (row) {
    return row;
  }).map(function (row) {
    var rowCells = row.props.children.filter(function (cell) {
      return cell;
    }).map(function (cell) {
      var cellReactChildren = cell.props.children;

      if (cellReactChildren == null) {
        return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["b" /* TableCell */], {}, cell.key);
      }

      var transforms = [__WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["a" /* isAvailable */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["b" /* isExperimental */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["c" /* isInDevelopment */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["d" /* isNew */], __WEBPACK_IMPORTED_MODULE_2__tableCellTransforms__["e" /* isPlanned */]];

      var enhancedChildren = cellReactChildren.filter(function (child) {
        return child;
      })
      // all the transforms return a (possibly modified) node,
      // which is passed to the next transform
      .map(function (child) {
        return transforms.reduce(function (node, transform) {
          return transform(node);
        }, child);
      });

      return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["b" /* TableCell */], {}, cell.key, enhancedChildren);
    });

    // Sometimes marksy returns null if the cell actually contains empty string.
    // Pad out the length of the rowCells array so there are at least as many
    // columns as defined in the header
    while (headCells && rowCells.length < headCells.length) {
      rowCells.push(_jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["b" /* TableCell */], {}, 'emptyCell_' + rowCells.length));
    }

    return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["d" /* TableRow */], {}, row.key, rowCells);
  });

  return _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["a" /* Table */], {}, void 0, _jsx('thead', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1__Table__["d" /* TableRow */], {}, void 0, headCells)), _jsx('tbody', {}, void 0, bodyRows));
}

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isNew; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isExperimental; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAvailable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isInDevelopment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isPlanned; });
/* unused harmony export isDeprecated */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_mineral_ui_icons_src_IconCheck__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__packages_mineral_ui_icons_src_IconAssignment__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_mineral_ui_icons_src_IconSlowMotionVideo__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_mineral_ui_icons_src_IconWarning__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label__ = __webpack_require__(211);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










// a tilde surrounded by some spaces and "new"
var REGEX_LABEL_NEW = /^\s+?~\s+?(new)/;
// a tilde surrounded by some spaces and "experimental"
var REGEX_LABEL_EXPERIMENTAL = /^\s+?~\s+?(experimental)/;

var styles = {
  label: function label(_ref) {
    var theme = _ref.theme;
    return {
      marginLeft: theme.space_inline_sm
    };
  },
  icon: {
    '& svg': {
      verticalAlign: 'text-top'
    },
    '& span': {
      border: 0,
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      width: 1
    }
  }
};

var Label = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_7__Label__["a" /* default */], styles.label);
var Available = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.icon);
var InDevelopment = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.icon);
var Planned = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.icon);
var Deprecated = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.icon);

var isNew = function isNew(child, index) {
  if (typeof child !== 'string' || !child.match(REGEX_LABEL_NEW)) {
    return child;
  }

  return _jsx(Label, {
    variant: 'success'
  }, 'label-' + index, child.replace(REGEX_LABEL_NEW, '$1'));
};

var isExperimental = function isExperimental(child, index) {
  if (typeof child !== 'string' || !child.match(REGEX_LABEL_EXPERIMENTAL)) {
    return child;
  }

  return _jsx(Label, {
    variant: 'warning'
  }, 'label-' + index, child.replace(REGEX_LABEL_EXPERIMENTAL, '$1'));
};

var _ref2 = _jsx('span', {}, void 0, 'available');

var isAvailable = function isAvailable(child, index) {
  if (typeof child !== 'string' || !child.includes('[available]')) {
    return child;
  }

  return _jsx(Available, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_3__packages_mineral_ui_icons_src_IconCheck__["a" /* default */], {
    color: __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* default */].green_60,
    size: 'large',
    title: 'available'
  }), _ref2);
};

var _ref3 = _jsx('span', {}, void 0, 'in development');

var isInDevelopment = function isInDevelopment(child, index) {
  if (typeof child !== 'string' || !child.includes('[in development]')) {
    return child;
  }

  return _jsx(InDevelopment, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_5__packages_mineral_ui_icons_src_IconSlowMotionVideo__["a" /* default */], {
    color: __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* default */].yellow_60,
    size: 'large',
    title: 'in development'
  }), _ref3);
};

var _ref4 = _jsx('span', {}, void 0, 'planned');

var isPlanned = function isPlanned(child, index) {
  if (typeof child !== 'string' || !child.includes('[planned]')) {
    return child;
  }

  return _jsx(Planned, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_4__packages_mineral_ui_icons_src_IconAssignment__["a" /* default */], {
    size: 'large',
    color: __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* default */].blue_60,
    title: 'planned'
  }), _ref4);
};

var _ref5 = _jsx('span', {}, void 0, 'deprecated');

var isDeprecated = function isDeprecated(child, index) {
  if (typeof child !== 'string' || !child.includes('[deprecated]')) {
    return child;
  }

  return _jsx(Deprecated, {}, 'icon-' + index, _jsx(__WEBPACK_IMPORTED_MODULE_6__packages_mineral_ui_icons_src_IconWarning__["a" /* default */], {
    color: __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* default */].red_60,
    size: 'large',
    title: 'deprecated'
  }), _ref5);
};

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_bash__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_bash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismjs_components_prism_bash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_clike__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_clike___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismjs_components_prism_clike__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_javascript__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismjs_components_prism_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_markup__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_markup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prismjs_components_prism_markup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismjs_components_prism_jsx__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prismjs_components_prism_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prismjs_components_prism_jsx__);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






// Prism errors out if this is imported before prism-markup ???


var prism = function prism(code) {
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'jsx';
  return Object(__WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__["highlight"])(code, __WEBPACK_IMPORTED_MODULE_0_prismjs_components_prism_core__["languages"][language]);
};

/* harmony default export */ __webpack_exports__["a"] = (prism);

/***/ }),
/* 465 */,
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_no_scroll__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_no_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_no_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_darken__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_polished_lib_color_darken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_polished_lib_color_darken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__packages_mineral_ui_icons_src_IconClose__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__packages_mineral_ui_icons_src_IconMenu__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Canvas__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Footer__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Markdown__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Section__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Nav__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__siteColors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Home_index__ = __webpack_require__(221);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





















var pageThemes = [{
  borderColor_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry,
  color_text_primary: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry,

  navLink_color_active_narrow: __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default()(0.19, __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry),

  SiteButton_backgroundColor_primary: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry,
  SiteButton_backgroundColor_primary_active: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_active,
  SiteButton_backgroundColor_primary_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_focus,
  SiteButton_backgroundColor_primary_hover: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_hover,

  SiteHeading_color_3: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_focus,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].cranberry_hover
}, {
  borderColor_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape,
  color_text_primary: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape,

  navLink_color_active_narrow: __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default()(0.18, __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape),

  SiteButton_backgroundColor_primary: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape,
  SiteButton_backgroundColor_primary_active: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_active,
  SiteButton_backgroundColor_primary_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_focus,
  SiteButton_backgroundColor_primary_hover: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_hover,

  SiteHeading_color_3: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_focus,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].grape_hover
}, {
  borderColor_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch,
  color_text_primary: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch,

  navLink_color_active_narrow: __WEBPACK_IMPORTED_MODULE_4_polished_lib_color_lighten___default()(0.23, __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch),

  SiteButton_backgroundColor_primary: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch,
  SiteButton_backgroundColor_primary_active: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_active,
  SiteButton_backgroundColor_primary_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_focus,
  SiteButton_backgroundColor_primary_hover: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_hover,

  SiteHeading_color_3: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_focus,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].orangePunch_hover
}];

/*
 * [1] The left bleed of the Section needs adjusting due to the nav sidebar.
 *     Point is hardcoded to the Section padding, rather than being prop-driven.
 *     See the comment on Section's styles for more info.
 * [2] Need to target the first `p`s within the Markdown component, up until
 *     an `h2`. Some pages have a wrapping `div` between Content and Markdown
 * [3] These styles provide momentum scrolling on iOS. The overflow value must
 *     be `scroll`
 */
var magic = 18;

var styles = {
  canvas: function canvas(_ref) {
    var theme = _ref.theme;
    return _defineProperty({
      backgroundColor: theme.PageHeader_backgroundColor || theme.color_text_primary

    }, theme.bp_moreSpacious, {
      left: 'calc(-50vw + 50% - ' + parseFloat(theme.sidebarWidth) / 2 + 'em)', // [1]
      right: 'calc(-50vw + 50% - ' + magic + '%)'
    });
  },
  content: function content(_ref3) {
    var _p, _h2FirstOfType, _ref4;

    var theme = _ref3.theme;
    return _ref4 = {
      padding: '0 ' + theme.SectionPaddingHorizontal + ' ' + theme.baseline_3

    }, _defineProperty(_ref4, theme.bp_moreSpacious, {
      boxSizing: 'content-box',
      marginLeft: theme.sidebarWidth,
      maxWidth: theme.maxContentWidth,
      overflow: 'hidden', // Neccessary because the nav sidebar is floated
      padding: '0 ' + theme.SectionPaddingHorizontalWide + ' ' + theme.baseline_6,

      '& > *': {
        boxSizing: 'border-box',

        '& *': {
          boxSizing: 'inherit'
        }
      }
    }), _defineProperty(_ref4, '& > .markdown, & > div > .markdown', {
      '& > p': (_p = {
        color: theme.color_gray_70,
        fontSize: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(20),
        fontWeight: '300',
        maxWidth: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* getNormalizedValue */])(theme.maxTextWidth, Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(20))

      }, _defineProperty(_p, theme.bp_moreSpacious, {
        fontSize: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(24),
        maxWidth: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* getNormalizedValue */])(theme.maxTextWidth, Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(24))
      }), _defineProperty(_p, '& a > [role="img"]', {
        borderBottomWidth: 2,
        top: 4
      }), _p),

      // [2]
      '& > h2:first-of-type': (_h2FirstOfType = {
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(82), // to baseline
        theme.SiteHeading_fontSize_2)

      }, _defineProperty(_h2FirstOfType, theme.bp_moreSpacious, {
        marginTop: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(97), // to baseline
        theme.SiteHeading_fontSize_2_wide)
      }), _defineProperty(_h2FirstOfType, '& ~ p', {
        color: 'inherit',
        fontSize: theme.fontSize_prose,
        fontWeight: 'inherit',
        maxWidth: theme.maxTextWidth,

        '& a > [role="img"]': {
          borderBottomWidth: 1,
          top: 2
        }
      }), _h2FirstOfType)
    }), _ref4;
  },
  dialog: function dialog(_ref5) {
    var theme = _ref5.theme;
    return {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba___default()(__WEBPACK_IMPORTED_MODULE_5_polished_lib_color_darken___default()(0.3, __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].slate), 0.9),
      bottom: 0,
      left: 0,
      position: 'fixed',
      right: 0,
      top: 0,
      zIndex: theme.zIndex_1600
    };
  },
  footer: function footer(_ref6) {
    var theme = _ref6.theme;
    return _defineProperty({
      // Inner
      '& > div': {
        margin: 0
      }

    }, theme.bp_moreSpacious, {
      clear: 'both',
      paddingLeft: theme.sidebarWidth
    });
  },
  header: function header(_ref8) {
    var _ref9;

    var theme = _ref8.theme;
    return _ref9 = {
      marginBottom: theme.baseline_3

    }, _defineProperty(_ref9, theme.bp_moreSpacious, {
      marginBottom: theme.baseline_6
    }), _defineProperty(_ref9, '& > div', _defineProperty({
      paddingBottom: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(43), // roughly theme.baseline_4
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(29) }, theme.bp_moreSpacious, {
      marginLeft: theme.sidebarWidth,
      paddingBottom: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(74), // roughly theme.baseline_6
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(53), // roughly theme.baseline_5

      '&::before': {
        left: 'calc(-50vw + 50% - ' + theme.SectionPaddingHorizontalWide + ' -\n            ' + parseFloat(theme.sidebarWidth) / 2 + 'em)', // [1]
        width: 'calc(50vw - 50% + 2 * ' + theme.SectionPaddingHorizontalWide + ' +\n            ' + parseFloat(theme.sidebarWidth) / 2 + 'em)' // [1]
      },

      '&::after': {
        right: 'calc(-50vw + 50% - ' + (magic + 1) + '%)',
        width: 'calc(50vw - 50% + 100% -\n            ' + theme.SectionPaddingHorizontalWide + ' + ' + (magic + 1) + '%)' // [1]
      }
    })), _defineProperty(_ref9, '& p[class]', _defineProperty({
      fontFamily: theme.fontFamily_headline,
      fontWeight: '300',
      margin: 0,
      textShadow: theme.textShadow

    }, theme.bp_moreSpacious, {
      marginTop: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(5)
    })), _defineProperty(_ref9, '& h1', _defineProperty({
      fontSize: theme.SiteHeading_fontSize_2,
      margin: 0,
      textShadow: theme.textShadow

    }, theme.bp_moreSpacious, {
      fontSize: theme.SiteHeading_fontSize_2_wide
    })), _ref9;
  },
  menuButton: function menuButton(_ref10) {
    var theme = _ref10.theme;
    return {
      backgroundColor: theme.color_black,
      border: 0,
      position: 'absolute',
      right: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(30), // Matches Section padding
      top: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(38), // Matches Section padding + optical adjustment for logo alignment
      zIndex: theme.zIndex_100,

      '&:focus': {
        backgroundColor: theme.color_black,
        boxShadow: 'none'
      },

      '&:hover': {
        backgroundColor: theme.color_gray_100
      },

      '&:active': {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_17__siteColors__["a" /* default */].slateDarker_active
      },

      '& [role="img"]': {
        fill: theme.color_white
      }
    };
  },
  nav: function nav(_ref11) {
    var wide = _ref11.wide,
        theme = _ref11.theme;

    return wide ? {
      float: 'left',
      overflow: 'auto',
      paddingRight: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(20), // room for scrollbar
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(21), // Optical adjustment
      position: 'relative',
      textAlign: 'right',
      top: -1,
      width: theme.sidebarWidth,

      '@supports(position:sticky)': {
        maxHeight: '100vh',
        position: 'sticky'
      }
    } : {
      fontSize: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(20),
      height: '100vh',
      overflowY: 'scroll', // [3]
      WebkitOverflowScrolling: 'touch', // [3]
      // 30px to match Section padding, 80px to make room for close button
      padding: Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(30) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(80) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(30) + ' ' + Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(30)
    };
  },
  root: function root(_ref12) {
    var theme = _ref12.theme;
    return {
      fontFamily: theme.fontFamily_system,

      '& ::selection': {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_6_polished_lib_color_rgba___default()(theme.color_text_primary, 0.2)
      }
    };
  },
  wrap: function wrap(_ref13) {
    var isNavOpen = _ref13.isNavOpen,
        theme = _ref13.theme;

    return isNavOpen ? _defineProperty({
      filter: 'blur(5px)'

    }, theme.bp_moreSpacious, {
      filter: 'none'
    }) : null;
  },
  wrapInner: {
    minHeight: 'calc(100vh - ' + Object(__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* pxToEm */])(39) + ')' // Footer height
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])('div', styles.root, {
  includeStyleReset: true
});
var Canvas = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_12__Canvas__["a" /* default */], styles.canvas);
var Content = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])('main', styles.content);
var Dialog = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])('div', styles.dialog);
var Footer = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_13__Footer__["a" /* default */], styles.footer);
var Header = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_15__Section__["a" /* default */], styles.header).withProps({
  element: 'header'
});
var MenuButton = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_9__Button__["a" /* default */], styles.menuButton).withProps({
  circular: true
});
var Nav = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_16__Nav__["a" /* default */], styles.nav);
var Wrap = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])('div', styles.wrap);
var WrapInner = Object(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* createStyledComponent */])('div', styles.wrapInner);

var _ref16 = _jsx(__WEBPACK_IMPORTED_MODULE_10__packages_mineral_ui_icons_src_IconClose__["a" /* default */], {});

var _ref17 = _jsx(__WEBPACK_IMPORTED_MODULE_11__packages_mineral_ui_icons_src_IconMenu__["a" /* default */], {});

var _ref18 = _jsx(Canvas, {});

var _ref21 = _jsx(Footer, {});

var Page = function (_Component) {
  _inherits(Page, _Component);

  function Page() {
    var _ref15;

    var _temp, _this, _ret;

    _classCallCheck(this, Page);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref15 = Page.__proto__ || Object.getPrototypeOf(Page)).call.apply(_ref15, [this].concat(args))), _this), _this.state = {
      isNavOpen: false
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Page, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __WEBPACK_IMPORTED_MODULE_3_no_scroll___default.a.off();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          chromeless = _props.chromeless,
          demoRoutes = _props.demoRoutes,
          headerContent = _props.headerContent,
          pageMeta = _props.pageMeta,
          slug = _props.slug,
          type = _props.type,
          restProps = _objectWithoutProperties(_props, ['children', 'chromeless', 'demoRoutes', 'headerContent', 'pageMeta', 'slug', 'type']);

      var isNavOpen = this.state.isNavOpen;


      var rootProps = _extends({}, restProps);
      var wrapProps = {
        isNavOpen: isNavOpen,
        tabIndex: isNavOpen ? '-1' : undefined
      };
      var navProps = {
        currentDemo: slug,
        demoRoutes: demoRoutes
      };

      var helmetItems = pageMeta && _jsx(__WEBPACK_IMPORTED_MODULE_2_react_helmet___default.a, {}, void 0, pageMeta.canonicalLink && _jsx('link', {
        rel: 'canonical',
        href: pageMeta.canonicalLink
      }), _jsx('title', {}, void 0, pageMeta.title), pageMeta.description && _jsx('meta', {
        name: 'description',
        content: pageMeta.description
      }));

      var navNarrow = function navNarrow(moreSpacious) {
        if (moreSpacious) {
          __WEBPACK_IMPORTED_MODULE_3_no_scroll___default.a.off();
        } else {
          if (isNavOpen) {
            __WEBPACK_IMPORTED_MODULE_3_no_scroll___default.a.on();

            return _jsx('div', {}, void 0, _jsx(Dialog, {}, void 0, _jsx(MenuButton, {
              iconStart: _ref16,
              inDialog: true,
              onClick: _this2.close.bind(_this2)
            }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Nav, navProps)));
          } else {
            __WEBPACK_IMPORTED_MODULE_3_no_scroll___default.a.off();

            return _jsx('div', {}, void 0, _jsx(MenuButton, {
              iconStart: _ref17,
              onClick: _this2.open.bind(_this2)
            }));
          }
        }
      };

      var _ref19 = _jsx(__WEBPACK_IMPORTED_MODULE_14__Markdown__["a" /* default */], {}, void 0, headerContent);

      var _ref20 = _jsx(Content, {}, void 0, children);

      return chromeless ? _jsx('div', {}, void 0, helmetItems, children) : _jsx(__WEBPACK_IMPORTED_MODULE_8__themes__["a" /* ThemeProvider */], {
        theme: type !== undefined ? pageThemes[type] : {}
      }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
        query: '(min-width: 48em)'
      }, void 0, function (moreSpacious) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          Root,
          rootProps,
          helmetItems,
          navNarrow(moreSpacious),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Wrap,
            wrapProps,
            _jsx(WrapInner, {}, void 0, headerContent && _jsx(__WEBPACK_IMPORTED_MODULE_8__themes__["a" /* ThemeProvider */], {
              theme: __WEBPACK_IMPORTED_MODULE_18__pages_Home_index__["heroTheme"]
            }, void 0, _jsx(Header, {
              angles: moreSpacious ? [5, 6] : [4, 4],
              as: 'header',
              point: 1 / 1000
            }, void 0, _ref18, typeof headerContent === 'string' ? _ref19 : headerContent)), moreSpacious && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Nav, _extends({}, navProps, { wide: true })), _ref20),
            _ref21
          )
        );
      }));
    }
  }, {
    key: 'close',
    value: function close() {
      this.setState({ isNavOpen: false }, function () {
        __WEBPACK_IMPORTED_MODULE_3_no_scroll___default.a.off();
      });
    }
  }, {
    key: 'open',
    value: function open() {
      this.setState({ isNavOpen: true }, function () {
        __WEBPACK_IMPORTED_MODULE_3_no_scroll___default.a.on();
      });
    }
  }]);

  return Page;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Page);

/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Nav;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Logo__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SiteHeading__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SiteLink__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__siteColors__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages__ = __webpack_require__(217);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */












var navTheme = {
  Heading_color_4: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_gray_30,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_white,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_gray_30,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_white,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_white
};

var navThemeWide = {
  Heading_color_4: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slateDarker,

  SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slateDarker_focus,
  SiteLink_color: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slateDarker,
  SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slateDarker_active,
  SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slateDarker_focus,
  SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slateDarker_hover
};

var styles = {
  heading: function heading(_ref) {
    var theme = _ref.theme,
        wide = _ref.wide;
    return {
      margin: 0,
      paddingRight: wide ? Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(8), theme.fontSize_h4) : null
    };
  },
  link: function link(_ref2) {
    var theme = _ref2.theme,
        wide = _ref2.wide;

    var fontSize = theme.fontSize_ui;
    var styles = [{
      display: 'block',
      fontWeight: theme.fontWeight_regular,
      // top & bottom: results of `getNormalizedValue(pxToEm(5), fontSize)`
      // (6px for bottom), rounded down for baseline alignment
      padding: '0.35em 0 0.4em',
      textDecoration: 'none'
    }];

    styles.push(wide ? {
      paddingLeft: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(8), fontSize),
      paddingRight: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(8), fontSize),

      '&.active': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_2_polished__["c" /* rgba */])(theme.color_text_primary, 0.15),
        color: Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* darken */])(0.1, theme.color_text_primary),
        position: 'relative',

        '&::before': {
          backgroundColor: theme.color_text_primary,
          bottom: 0,
          content: '""',
          position: 'absolute',
          right: '-' + Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(3), fontSize),
          top: 0,
          width: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(3), fontSize)
        }
      }
    } : {
      '&.active': {
        color: theme.navLink_color_active_narrow,
        position: 'relative',

        '&::before': {
          backgroundColor: theme.navLink_color_active_narrow,
          bottom: 0,
          content: '""',
          left: '-' + Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(18), fontSize),
          position: 'absolute',
          top: 0,
          width: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(6), fontSize)
        }
      }
    });

    return styles;
  },
  list: {
    listStyle: 'none',
    margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(44), // to baseline
    paddingLeft: '0'
  },
  listItem: function listItem(_ref3) {
    var theme = _ref3.theme;
    return {
      fontSize: theme.fontSize_ui,

      '& > a:focus': {
        outlineOffset: 0
      }
    };
  },
  // [1] to align first SectionHeading with baseline of third intro line
  logoHeading: function logoHeading(_ref4) {
    var theme = _ref4.theme,
        wide = _ref4.wide;
    return {
      fontSize: '1em',
      margin: '0 0 ' + Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(9), // [1]
      paddingRight: wide ? Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(8), theme.fontSize_h4) : null,

      '& svg': {
        width: 29, // 36px tall is the important dimension

        '& .band-1': { fill: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].yellow },
        '& .band-2': { fill: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].orange },
        '& .band-3': { fill: __WEBPACK_IMPORTED_MODULE_8__siteColors__["a" /* default */].slate }
      }
    };
  },
  subList: function subList(_ref5) {
    var open = _ref5.open,
        theme = _ref5.theme,
        wide = _ref5.wide;

    var styles = [{
      listStyle: 'none',
      margin: 0,
      padding: 0,
      position: 'relative'
    }];

    if (open) {
      styles.push(wide ? {
        '&::before': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_2_polished__["c" /* rgba */])(theme.color_text_primary, 0.25),
          bottom: 0,
          content: '""',
          position: 'absolute',
          right: '-' + Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(3), theme.fontSize_ui),
          top: 0,
          width: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(3), theme.fontSize_ui)
        }
      } : {
        '&::before': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_2_polished__["c" /* rgba */])(theme.color_text_primary, 0.5),
          bottom: 0,
          content: '""',
          left: '-' + Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(18),
          position: 'absolute',
          top: 0,
          width: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(6)
        }
      });
    }

    return styles;
  }
};

var Link = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_7__SiteLink__["a" /* default */], styles.link, {
  filterProps: ['wide']
}).withProps({
  element: __WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */]
});
var List = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('ol', styles.list);
var ListItem = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('li', styles.listItem);
var SectionHeading = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_6__SiteHeading__["a" /* default */], styles.heading).withProps({
  as: 'h2',
  level: 4
});
var SubList = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('ol', styles.subList);
var LogoHeading = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_6__SiteHeading__["a" /* default */], styles.logoHeading).withProps({
  level: 1
});

var _ref6 = _jsx(Link, {
  exact: true,
  to: '/'
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__Logo__["a" /* default */], {}));

var Logo = function Logo(wide) {
  return _jsx(LogoHeading, {
    wide: wide
  }, void 0, _ref6);
};

var pages = function pages(wide) {
  return __WEBPACK_IMPORTED_MODULE_9__pages__["a" /* default */].map(function (section, index) {
    return _jsx('div', {}, index, _jsx(SectionHeading, {
      wide: wide
    }, void 0, section.heading), _jsx(List, {}, void 0, section.pages.map(function (page) {
      return !page.hiddenInNav && _jsx(ListItem, {}, page.title, _jsx(Link, {
        to: page.path,
        wide: wide
      }, void 0, page.title));
    })));
  });
};

var renderItem = function renderItem(slug, title, wide) {
  return _jsx(ListItem, {}, slug, _jsx(Link, {
    to: '/components/' + slug,
    wide: wide
  }, void 0, title));
};

function Nav(_ref7) {
  var currentDemo = _ref7.currentDemo,
      demoRoutes = _ref7.demoRoutes,
      wide = _ref7.wide,
      restProps = _objectWithoutProperties(_ref7, ['currentDemo', 'demoRoutes', 'wide']);

  var rootProps = _extends({}, restProps);

  var demoLinks = demoRoutes.map(function (route) {
    if (Array.isArray(route)) {
      var open = route.filter(function (subRoute) {
        return subRoute.slug === currentDemo;
      }).length;
      var subListProps = {
        key: route[0].slug,
        open: open,
        wide: wide
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        SubList,
        subListProps,
        route.map(function (subRoute, index) {
          var slug = subRoute.slug,
              title = subRoute.title;

          return index === 0 || open ? renderItem(slug, title, wide) : null;
        })
      );
    } else {
      var _slug = route.slug,
          _title = route.title;

      return renderItem(_slug, _title, wide);
    }
  });

  return _jsx(__WEBPACK_IMPORTED_MODULE_4__themes__["a" /* ThemeProvider */], {
    theme: wide ? navThemeWide : navTheme
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'nav',
    rootProps,
    _jsx(Logo, {
      wide: wide
    }),
    pages(wide),
    _jsx(SectionHeading, {
      wide: wide
    }, void 0, 'Components'),
    _jsx(List, {}, void 0, demoLinks)
  ));
}

/***/ }),
/* 478 */,
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Loading;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamor__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_glamor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_glamor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_lighten__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_lighten___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_lighten__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_darken__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_darken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_polished_lib_color_darken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(2);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var Message = Object(__WEBPACK_IMPORTED_MODULE_4__styles__["a" /* createStyledComponent */])('div', function (_ref) {
  var fancy = _ref.fancy,
      theme = _ref.theme;

  var loading = __WEBPACK_IMPORTED_MODULE_1_glamor__["css"].keyframes({
    '0%': { backgroundPosition: '0 0' },
    '100%': { backgroundPosition: '100% 0' }
  });

  var styles = {
    color: theme.color_text_primary,
    fontSize: '1.5em',
    margin: theme.baseline_2 + ' auto',
    width: 'min-content'
  };

  if (fancy) {
    styles = _extends({}, styles, {
      animation: loading + ' 2s',
      animationIterationCount: 'infinite',
      background: 'linear-gradient(90deg,\n        ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_lighten___default()(0.1, theme.color_text_primary) + ',\n        ' + __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_darken___default()(0.2, theme.color_text_primary) + ',\n        ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_lighten___default()(0.1, theme.color_text_primary) + ',\n        ' + __WEBPACK_IMPORTED_MODULE_3_polished_lib_color_darken___default()(0.2, theme.color_text_primary) + '\n      )',
      backgroundPosition: '0 0',
      backgroundSize: '300% 100%',
      color: 'white',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent'
    });
  }

  return styles;
});

var _ref3 = _jsx(Message, {
  fancy: true
}, void 0, 'Loading...');

var _ref4 = _jsx(Message, {}, void 0, 'Sorry, there was a problem loading the page.');

function Loading(_ref2) {
  var error = _ref2.error,
      pastDelay = _ref2.pastDelay,
      timedOut = _ref2.timedOut;

  if (pastDelay) {
    return _ref3;
  } else if (timedOut || error) {
    return _ref4;
  } else {
    return null;
  }
}

/***/ }),
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExpandLess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z'
}));

/* eslint-disable prettier/prettier */
function IconExpandLess(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconExpandLess.category = 'navigation';

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconExpandMore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z'
}));

/* eslint-disable prettier/prettier */
function IconExpandMore(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconExpandMore.category = 'navigation';

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardImage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Card__ = __webpack_require__(29);
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('img', function (props) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_2__Card__["a" /* componentTheme */])(props.theme);

  return {
    display: 'block',
    marginBottom: theme.CardRow_marginVertical,
    marginTop: theme.CardRow_marginVertical,
    maxWidth: '100%',

    '&:first-child': {
      borderRadius: theme.Card_borderRadius + ' ' + theme.Card_borderRadius + ' 0 0',
      marginTop: 0
    },

    '&:last-child': {
      borderRadius: '0 0 ' + theme.Card_borderRadius + ' ' + theme.Card_borderRadius,
      marginBottom: 0
    }
  };
}, {
  displayName: 'CardImage',
  rootEl: 'img'
});

/**
 * CardImage renders images full-bleed inside of a [Card](../card).
 * Use CardImage to display static media.
 */
function CardImage(props) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Root, props);
}

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconDangerSimple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M3.94 20.49h16.118a1 1 0 0 0 .866-1.498l-8.06-13.99a.996.996 0 0 0-1.732-.001L3.074 18.993a.998.998 0 0 0 .867 1.499l-.001-.002z'
}));

/* eslint-disable prettier/prettier */
function IconDangerSimple(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconDangerSimple.category = 'alert';

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconSuccessSimple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M12 3c4.968 0 9 4.032 9 9s-4.032 9-9 9-9-4.032-9-9 4.032-9 9-9z'
}));

/* eslint-disable prettier/prettier */
function IconSuccessSimple(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconSuccessSimple.category = 'alert';

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconWarningSimple;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M13.414 2.718l7.868 7.868c.78.78.78 2.047 0 2.828l-7.868 7.868c-.78.78-2.047.78-2.828 0l-7.868-7.868a2.001 2.001 0 0 1 0-2.828l7.868-7.868c.78-.78 2.047-.78 2.828 0z'
}));

/* eslint-disable prettier/prettier */
function IconWarningSimple(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconWarningSimple.category = 'alert';

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardTitleMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dropdown__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_IconMoreHoriz__ = __webpack_require__(505);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var babelPluginFlowReactPropTypes_proptype_ItemGroups = __webpack_require__(27).babelPluginFlowReactPropTypes_proptype_ItemGroups || __webpack_require__(3).any;

var babelPluginFlowReactPropTypes_proptype_Items = __webpack_require__(27).babelPluginFlowReactPropTypes_proptype_Items || __webpack_require__(3).any;

/*
 * A large Button, even with zero'd padding, is still a bit too large in this
 * context. These styles allow the Button to shrink, but the Icon remains the
 * same size.
 */
var MenuButton = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    height: 'auto',
    minWidth: 0,
    overflow: 'hidden',
    padding: 0,

    // Inner
    '& > span': {
      display: 'block',
      margin: '-' + Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(2)
    },

    '& [role="img"]': {
      fill: theme.color_text
    }
  };
});

/**
 * CardTitleMenu
 */
function CardTitleMenu(_ref2) {
  var data = _ref2.data,
      _ref2$triggerTitle = _ref2.triggerTitle,
      triggerTitle = _ref2$triggerTitle === undefined ? 'Card actions' : _ref2$triggerTitle,
      restProps = _objectWithoutProperties(_ref2, ['data', 'triggerTitle']);

  var rootProps = _extends({
    data: data,
    placement: 'bottom-end'
  }, restProps);
  var buttonProps = {
    iconStart: _jsx(__WEBPACK_IMPORTED_MODULE_4__Icon_IconMoreHoriz__["a" /* default */], {
      title: triggerTitle
    }),
    minimal: true
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_3__Dropdown__["a" /* default */],
    rootProps,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuButton, buttonProps)
  );
}

/***/ }),
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventListener__ = __webpack_require__(502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__EventListener__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exenv__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exenv__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/** Declarative event listener component */
var EventListener = function (_Component) {
  _inherits(EventListener, _Component);

  function EventListener() {
    _classCallCheck(this, EventListener);

    return _possibleConstructorReturn(this, (EventListener.__proto__ || Object.getPrototypeOf(EventListener)).apply(this, arguments));
  }

  _createClass(EventListener, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.addEventListeners();
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.removeEventListeners();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.addEventListeners();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeEventListeners();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'getTargetNode',
    value: function getTargetNode(target) {
      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseDOM"]) {
        return global[target] || global.document.querySelector(target);
      }
    }
  }, {
    key: 'addEventListeners',
    value: function addEventListeners() {
      var _this2 = this;

      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseEventListeners"]) {
        this.props.listeners.forEach(function (_ref) {
          var target = _ref.target,
              event = _ref.event,
              handler = _ref.handler,
              options = _ref.options;

          var node = _this2.getTargetNode(target);
          node && node.addEventListener(event, handler, options);
        });
      }
    }
  }, {
    key: 'removeEventListeners',
    value: function removeEventListeners() {
      var _this3 = this;

      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseEventListeners"]) {
        this.props.listeners.forEach(function (_ref2) {
          var target = _ref2.target,
              event = _ref2.event,
              handler = _ref2.handler,
              options = _ref2.options;

          var node = _this3.getTargetNode(target);
          node && node.removeEventListener(event, handler, options);
        });
      }
    }
  }]);

  return EventListener;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (EventListener);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exenv__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var Portal = function (_Component) {
  _inherits(Portal, _Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPortal();
      this.renderIntoPortal();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.renderIntoPortal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.closePortal();
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }, {
    key: 'renderIntoPortal',
    value: function renderIntoPortal() {
      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseDOM"]) {
        var _props = this.props,
            _children = _props.children,
            _callback = _props.callback;

        var content = __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(_children);

        this.content = Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_renderSubtreeIntoContainer"])(this, content, this.node, _callback);
      }
    }
  }, {
    key: 'createPortal',
    value: function createPortal() {
      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseDOM"]) {
        this.node = global.document.createElement('div');
        global.document.body.appendChild(this.node);
      }
    }
  }, {
    key: 'closePortal',
    value: function closePortal() {
      if (__WEBPACK_IMPORTED_MODULE_1_exenv__["canUseDOM"]) {
        Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["unmountComponentAtNode"])(this.node);
        if (global.document.body.contains && global.document.body.contains(this.node)) {
          global.document.body.removeChild(this.node);
        }
      }
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Portal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(11)))

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = IconMoreHoriz;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var _ref = _jsx('g', {}, void 0, _jsx('path', {
  d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z'
}));

/* eslint-disable prettier/prettier */
function IconMoreHoriz(props) {
  var iconProps = _extends({
    rtl: false
  }, props);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1____["a" /* default */],
    iconProps,
    _ref
  );
}

IconMoreHoriz.category = 'navigation';

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_media__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__colors__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_mineral_ui_icons_src_IconArrowDropDown__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popover__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SiteHeading__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SiteLink__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LogotypeHorizontal__ = __webpack_require__(507);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */













var menuButtonTheme = function menuButtonTheme(_ref) {
  var theme = _ref.theme;
  return {
    fontFamily: theme.fontFamily_headline,
    Button_color_text_minimal: theme.color_white,
    Button_backgroundColor_minimal_hover: 'transparent',
    Button_backgroundColor_minimal_active: 'transparent',
    Button_fontWeight: theme.fontWeight_regular,
    Button_height_large: null,
    Button_paddingHorizontal: 0,
    ButtonContent_fontSize: '1em',
    ButtonIcon_margin: null
  };
};
var popoverTheme = {
  PopoverContent_backgroundColor: null,
  PopoverContent_borderColor: 'transparent',
  PopoverContent_borderRadius: null,
  PopoverContent_boxShadow: null,
  PopoverContent_paddingVertical: null
};

var styles = {
  root: function root(_ref2) {
    var isMenuOpen = _ref2.isMenuOpen,
        theme = _ref2.theme;

    var transitionProperties = '350ms cubic-bezier(0.175, 0.885, 0.32, 1.275)';

    return _defineProperty({
      alignItems: 'flex-end',
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: isMenuOpen ? Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(250) // Dependent on menu height
      : theme.baseline_7,
      paddingTop: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(30), // matches horizontal padding
      transition: 'margin ' + transitionProperties,

      '& div[id$="content"]': {
        // Matches nav link padding + menuButton optical adjustment
        marginTop: parseFloat(theme.space_stack_sm) + 0.45 + 'em',
        opacity: isMenuOpen ? 1 : 0,
        transition: 'opacity 500ms linear',

        // CardBlock (tried doing this via theme variables, and it didn't work)
        '& > div': {
          margin: 0,
          padding: 0
        }
      }

    }, theme.bp_home_navExpanded, {
      marginBottom: theme.baseline_9,
      paddingTop: theme.baseline_2
    });
  },
  link: function link(_ref4) {
    var theme = _ref4.theme;
    return {
      fontFamily: theme.fontFamily_headline,
      fontWeight: theme.fontWeight_regular,
      fontSize: '1em',
      textDecoration: 'none',
      textShadow: theme.textShadow,

      '& > [role="img"]': {
        borderBottom: 0
      }
    };
  },
  logotype: function logotype(_ref5) {
    var _ref6;

    var theme = _ref5.theme;
    return _ref6 = {
      lineHeight: 1,
      margin: 0

    }, _defineProperty(_ref6, theme.bp_moreSpacious, {
      margin: '0 0 0 -33px' // Optical adjustment
    }), _defineProperty(_ref6, '& svg', _defineProperty({
      display: 'block',
      width: 128 }, theme.bp_home_navExpanded, {
      width: 157
    })), _ref6;
  },
  menuButton: function menuButton(_ref7) {
    var theme = _ref7.theme;
    return {
      border: 0,
      position: 'relative',
      textShadow: theme.textShadow,
      top: '0.45em', // Optical adjustment for baseline alignment with Logotype

      '&:focus': {
        color: __WEBPACK_IMPORTED_MODULE_2__colors__["a" /* default */].orange_50,
        boxShadow: 'none'
      }
    };
  },
  nav: function nav(_ref8) {
    var _ref9;

    var theme = _ref8.theme;
    return _ref9 = {}, _defineProperty(_ref9, theme.bp_home_navCollapsedAndDown, {
      width: '100vw',

      '& > a': {
        display: 'block',
        paddingBottom: theme.space_inset_sm,
        paddingRight: '3.5em', // Optical adjument to align with MenuButton text
        paddingTop: theme.space_inset_sm,
        textAlign: 'right',
        textShadow: 'none',

        '&:nth-child(1)': { backgroundColor: 'rgba(0,0,0,0.5)' },
        '&:nth-child(2)': { backgroundColor: 'rgba(0,0,0,0.44)' },
        '&:nth-child(3)': { backgroundColor: 'rgba(0,0,0,0.38)' },
        '&:nth-child(4)': { backgroundColor: 'rgba(0,0,0,0.32)' },
        '&:nth-child(5)': { backgroundColor: 'rgba(0,0,0,0.26)' }
      }
    }), _defineProperty(_ref9, theme.bp_home_navExpanded, {
      position: 'relative',
      top: '0.3em', // Optical adjustment for baseline alignment with Logotype

      '& > a + a': {
        marginLeft: theme.space_inline_lg
      }
    }), _ref9;
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('div', styles.root);
var Link = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_9__SiteLink__["a" /* default */], styles.link);
var Logotype = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_8__SiteHeading__["a" /* default */], styles.logotype);
var ThemedMenuButton = Object(__WEBPACK_IMPORTED_MODULE_4__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], menuButtonTheme);
var MenuButton = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])(ThemedMenuButton, styles.menuButton);
var Popover = Object(__WEBPACK_IMPORTED_MODULE_4__themes__["d" /* createThemedComponent */])(__WEBPACK_IMPORTED_MODULE_7__Popover__["a" /* default */], popoverTheme);
var StyledNav = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('nav', styles.nav);

var _ref11 = _jsx(Link, {
  to: '/color'
}, void 0, 'Guidelines');

var _ref12 = _jsx(Link, {
  to: '/roadmap'
}, void 0, 'What\u2019s New');

var _ref13 = _jsx(Link, {
  to: '/component-status'
}, void 0, 'Components');

var _ref14 = _jsx(Link, {
  href: 'https://github.com/mineral-ui/mineral-ui'
}, void 0, 'View on GitHub');

var Nav = function Nav(_ref10) {
  var latestPost = _ref10.latestPost;

  return _jsx(StyledNav, {}, void 0, _ref11, _ref12, _ref13, _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
    query: '(max-width: 38.999em)',
    render: function render() {
      return latestPost && _jsx(Link, {
        href: latestPost.url
      }, void 0, 'Latest Blog Post');
    }
  }), _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
    query: '(max-width: 38.999em)',
    render: function render() {
      return _ref14;
    }
  }));
};

var _ref16 = _jsx(Logotype, {
  level: 1
}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_10__LogotypeHorizontal__["a" /* default */], {}));

var _ref17 = _jsx(Nav, {});

var _ref18 = _jsx(MenuButton, {
  iconEnd: _jsx(__WEBPACK_IMPORTED_MODULE_6__packages_mineral_ui_icons_src_IconArrowDropDown__["a" /* default */], {
    size: 'large'
  }),
  minimal: true
}, void 0, 'Menu');

var Header = function (_Component) {
  _inherits(Header, _Component);

  function Header() {
    var _ref15;

    var _temp, _this, _ret;

    _classCallCheck(this, Header);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref15 = Header.__proto__ || Object.getPrototypeOf(Header)).call.apply(_ref15, [this].concat(args))), _this), _this.state = {
      isMenuOpen: false
    }, _this.onMenuClose = function () {
      _this.setState({ isMenuOpen: false });
    }, _this.onMenuOpen = function () {
      _this.setState({ isMenuOpen: true });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          latestPost = _props.latestPost,
          restProps = _objectWithoutProperties(_props, ['latestPost']);

      var rootProps = _extends({
        isMenuOpen: this.state.isMenuOpen
      }, restProps);
      var popoverProps = {
        content: _jsx(Nav, {
          latestPost: latestPost
        }),
        hasArrow: false,
        isOpen: this.state.isMenuOpen,
        modifiers: {
          preventOverflow: {
            padding: 0
          }
        },
        onClose: this.onMenuClose,
        onOpen: this.onMenuOpen,
        placement: 'bottom-end'
      };

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Root,
        rootProps,
        _ref16,
        _jsx(__WEBPACK_IMPORTED_MODULE_1_react_media___default.a, {
          query: '(min-width: 39em)'
        }, void 0, function (matches) {
          return matches ? _ref17 : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            Popover,
            popoverProps,
            _ref18
          );
        })
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LogotypeHorizontal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



function LogotypeHorizontal(_ref) {
  var fill = _ref.fill,
      _ref$title = _ref.title,
      title = _ref$title === undefined ? 'Mineral' : _ref$title,
      restProps = _objectWithoutProperties(_ref, ['fill', 'title']);

  var fillColor = fill || 'currentColor';
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    _extends({
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 384.06 89.18'
    }, restProps),
    _jsx('title', {}, void 0, title),
    _jsx('polygon', {
      className: 'band-1 shape-1',
      fill: fillColor,
      points: '15.45 62.37 0.44 62.37 8.63 73.81 15.45 62.37'
    }),
    _jsx('path', {
      className: 'band-1 shape-2',
      fill: fillColor,
      d: 'M47.35,8.85l-4-8.51A0.58,0.58,0,0,0,43,0a0.57,0.57,0,0,0-.49.08L25.6,11.56a0.56,0.56,0,0,0-.19.21L0,59.1H17.39Z'
    }),
    _jsx('path', {
      className: 'band-2 shape-3',
      fill: fillColor,
      d: 'M58.88,33.55L49,12.42,10.7,76.7l8,11.25a0.59,0.59,0,0,0,.48.24H26.3Z'
    }),
    _jsx('path', {
      className: 'band-3 shape-4',
      fill: fillColor,
      d: 'M30.09,88.2H51.42A0.59,0.59,0,0,0,51.89,88l18.3-25.59H45.5Z'
    }),
    _jsx('polygon', {
      className: 'band-3 shape-5',
      fill: fillColor,
      points: '47.44 59.1 70.8 59.1 60.55 37.12 47.44 59.1'
    }),
    _jsx('path', {
      className: 'text-1',
      fill: fillColor,
      d: 'M175,88.13h8.41v-43H175v43Zm41.17-44c-5.07,0-10.23,2.1-13.19,5.93l-0.48-5h-7.74v43h8.41V63.56c0-4.21.76-6.5,2-8.41,1.72-2.58,4.78-4.3,9.08-4.3s6.79,1.91,8.22,4.87c1,2,1.34,4.31,1.34,8.22V88.13h8.41v-25c0-5.45-.77-8.61-2.2-11.38C227.14,46.64,221.69,44.15,216.14,44.15Zm85.35,7.17-0.38-6.22h-7.84v43h8.41V64.42c0-6.31,2.2-11.76,11.37-11.76a12.9,12.9,0,0,1,1.72.1V44.44h-1A14.81,14.81,0,0,0,301.5,51.32Zm37.36-7.17c-13.19,0-17.69,8.41-17.69,13.67h8c0.77-4.11,3.25-7.07,10.13-7.07,5.35,0,8,2.2,9,4.78,0.48,1.25.77,2.77,0.77,6.31V63h-5.45c-17.69,0-23.23,5.26-23.23,13.48,0,7,5.45,12.71,14,12.71a18.69,18.69,0,0,0,14.82-7l0.09,5.93h8.22V61.93a27.47,27.47,0,0,0-1-7.94C354.25,47.12,348,44.15,338.86,44.15Zm10.23,26a13.42,13.42,0,0,1-1.34,6.5c-2,3.92-6.21,6.12-11.38,6.12-5.35,0-7.55-3.44-7.55-6.59,0-5.64,4.11-7.36,15.39-7.36h4.88v1.34Zm32.39,11.38c-3.73,0-4.3-1.05-4.3-4.59V19.58h-8.41V77.8c0,7.74,2.77,10.52,10.42,10.52,0.57,0,2.58-.1,4.88-0.29v-6.6A23.5,23.5,0,0,1,381.48,81.53ZM181.35,27.43a4.25,4.25,0,1,0,2.13,3.68A4.26,4.26,0,0,0,181.35,27.43Zm81.31,16.72c-13.29,0-21.89,10.32-21.89,22.47,0,13.19,9.18,22.56,21.89,22.56,11.57,0,18.93-7.45,20.75-14.72H274.8a12,12,0,0,1-11.66,8,14.45,14.45,0,0,1-14.26-13.25c0-.06,0-0.11,0-0.17,0-.21,0-0.42-0.06-0.63h35.28V67.1C284.07,51.9,274.13,44.15,262.66,44.15ZM249.18,62.51c0-.2.11-0.39,0.15-0.58v0a13.75,13.75,0,0,1,13.31-11c6.69,0,12.14,4.2,12.72,11.66H249.18ZM130.4,75.13L108.88,25.64H96.06V88.13h9V38.07a0.32,0.32,0,0,0,.18-0.1l22,50.16H133c7.39-18.74,14.6-31.42,22-50.16,0.09,0,.19.1,0.28,0.1V88.13h9.28V25.64H152.2Z'
    })
  );
}

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ThemePlaygound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__packages_mineral_ui_icons_src_IconCheck__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(9);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var styles = {
  root: function root(_ref) {
    var theme = _ref.theme,
        themes = _ref.themes,
        index = _ref.index;
    return _defineProperty({
      marginTop: theme.space_stack_xl,
      position: 'relative', // for z-index
      zIndex: 2,

      '& ::selection': {
        backgroundColor: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_rgba___default()(themes[index].color_text_primary, 0.2)
      },

      '@media(min-width: 23em)': {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',

        '@supports(display: grid)': {
          display: 'grid',
          gridGap: theme.space_inline_sm,
          gridTemplateColumns: 'repeat(3, auto)',
          gridTemplateRows: 'min-content auto'
        }
      }

    }, theme.bp_moreSpacious, {
      '@supports(display: grid)': {
        gridGap: theme.space_inline_md,
        gridTemplateColumns: 'min-content auto',
        gridTemplateRows: 'repeat(3, auto)'
      }
    });
  },
  optionRoot: function optionRoot(_ref3) {
    var isActive = _ref3.isActive,
        theme = _ref3.theme,
        themes = _ref3.themes,
        thisIndex = _ref3.thisIndex;
    return {
      alignItems: 'center',
      backgroundColor: isActive ? themes[thisIndex].color_theme_10 : theme.color_white,
      border: '1px solid ' + (isActive ? theme.color_white : 'transparent'),
      borderRadius: theme.borderRadius_1,
      boxShadow: isActive ? '0 0 0 1px ' + theme['borderColor_focus'] : null,
      cursor: 'pointer',
      display: 'flex',
      marginBottom: theme.space_stack_sm,
      padding: theme.space_inset_sm + ' ' + theme.space_inset_lg,
      position: 'relative',
      width: '100%',
      '&::-moz-focus-inner': { border: 0 },

      '&:focus,&:hover': {
        backgroundColor: themes[thisIndex].color_theme_10
      },

      '@media(min-width: 23em)': {
        flex: '0 0 calc(33.333% - 2 * ' + theme.space_inline_sm + ' / 3)',
        padding: theme.space_inset_sm,
        justifyContent: 'center',

        '@supports(display: grid)': {
          marginBottom: 0
        }
      },

      '@media(min-width: 29em)': {
        alignItems: 'flex-start',
        flexDirection: 'column',
        padding: '\n        ' + theme.space_inset_md + '\n        ' + theme.space_inset_md + '\n        ' + theme.space_inset_md + '\n        ' + (parseFloat(theme.space_inset_md) + 1.25 + // Large icon size
        parseFloat(theme.space_inset_sm) + // padding left & right
        parseFloat(theme.space_inline_sm)) + 'em\n      '
      }
    };
  },
  optionHex: function optionHex(_ref4) {
    var theme = _ref4.theme;
    return {
      display: 'block',
      fontSize: theme.fontSize_mouse,
      marginTop: theme.space_stack_xxs,

      '@media(max-width: 28.999em)': {
        display: 'none'
      }
    };
  },
  optionIcon: function optionIcon(_ref5) {
    var isActive = _ref5.isActive,
        theme = _ref5.theme,
        themes = _ref5.themes,
        thisIndex = _ref5.thisIndex;
    return {
      backgroundColor: themes[thisIndex].color_theme_60,
      borderRadius: theme.borderRadius_1,
      boxSizing: 'content-box !important', // This needs to win over `.class *` from componentStyleReset
      flex: '0 0 auto',
      fill: isActive ? theme.color_white : 'transparent',
      marginRight: theme.space_inline_xs,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em',

      '@media(min-width: 29em)': {
        height: '1.25em', // Large size
        left: theme.space_inset_md,
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '1.25em' // Large size
      }
    };
  },
  optionName: function optionName(_ref6) {
    var theme = _ref6.theme;
    return {
      color: theme.color_gray_100,
      display: 'block',
      fontSize: theme.fontSize_ui,
      fontWeight: theme.fontWeight_bold
    };
  },
  sandbox: function sandbox(_ref7) {
    var _ref8;

    var theme = _ref7.theme;
    return _ref8 = {
      backgroundColor: theme.color_white,
      borderRadius: theme.borderRadius_1,
      gridColumn: '1 / span 3',
      padding: theme.space_inset_lg + ' ' + Object(__WEBPACK_IMPORTED_MODULE_2__styles__["d" /* pxToEm */])(28)

    }, _defineProperty(_ref8, theme.bp_moreSpacious, {
      gridColumn: 2,
      gridRow: '1 / span 4'
    }), _defineProperty(_ref8, '& h3', {
      color: theme.color_theme_80
    }), _defineProperty(_ref8, '& p > a', {
      color: theme.color_text_primary,
      fontWeight: theme.fontWeight_semiBold,

      '&:hover': {
        color: theme.color_text_primary_hover
      },
      '&:focus': {
        color: theme.color_text_primary_focus,
        outlineColor: theme.borderColor_focus
      },
      // `:active` must be last, to follow LVHFA order:
      // https://developer.mozilla.org/en-US/docs/Web/CSS/:active
      '&:active': {
        color: theme.color_text_primary_active
      }
    }), _defineProperty(_ref8, '& button', {
      '@media(max-width: 22.999em)': {
        padding: '0 ' + theme.space_inline_xxs,
        width: '100%',

        // Content, with a specificity hack
        '& > span > span[class]': {
          paddingLeft: theme.space_inline_xxs,
          paddingRight: theme.space_inline_xxs
        }
      }
    }), _ref8;
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('div', styles.root, {
  includeStyleReset: true
});
var OptionRoot = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('button', styles.optionRoot, {
  includeStyleReset: true
});
var OptionHex = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('span', styles.optionHex);
var OptionIcon = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__packages_mineral_ui_icons_src_IconCheck__["a" /* default */], styles.optionIcon);
var OptionName = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('span', styles.optionName);
var Sandbox = Object(__WEBPACK_IMPORTED_MODULE_2__styles__["a" /* createStyledComponent */])('div', styles.sandbox);

var Option = function Option(_ref9) {
  var children = _ref9.children,
      thisIndex = _ref9.thisIndex,
      isActive = _ref9.isActive,
      onClick = _ref9.onClick,
      themes = _ref9.themes,
      restProps = _objectWithoutProperties(_ref9, ['children', 'thisIndex', 'isActive', 'onClick', 'themes']);

  var rootProps = _extends({
    onClick: onClick,
    isActive: isActive,
    themes: themes,
    thisIndex: thisIndex
  }, restProps);
  var iconProps = {
    isActive: isActive,
    size: 'small',
    themes: themes,
    thisIndex: thisIndex
  };
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    OptionRoot,
    rootProps,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionIcon, iconProps),
    _jsx(OptionName, {}, void 0, children),
    _jsx(OptionHex, {}, void 0, themes[thisIndex].color_theme_60)
  );
};

function ThemePlaygound(_ref10) {
  var children = _ref10.children,
      index = _ref10.index,
      setIndex = _ref10.setIndex,
      themes = _ref10.themes,
      restProps = _objectWithoutProperties(_ref10, ['children', 'index', 'setIndex', 'themes']);

  var rootProps = _extends({
    index: index,
    themes: themes
  }, restProps);
  return _jsx(__WEBPACK_IMPORTED_MODULE_4__themes__["a" /* ThemeProvider */], {
    theme: themes[index]
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    rootProps,
    themes.map(function (theme, i) {
      var optionProps = {
        isActive: index === i,
        key: i,
        onClick: function onClick() {
          return setIndex(i);
        },
        themes: themes,
        thisIndex: i
      };
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        Option,
        optionProps,
        theme.name
      ); // eslint-disable-line react/jsx-key
    }),
    _jsx(Sandbox, {}, void 0, children)
  ));
}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = "### Accessibility Built-in\n\nMineral has been designed and built to be accessible to all from the very\nbeginning. The components do the hard work for you, through the consistent\napplication of color contrast ratios, standards compliant markup, and thoughtful\ndesign, informed by researching best practices and testing with assistive\ntechnology.\n"

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = "### Drop-in Ready\n\nMineral components are fully encapsulated, designed for composability, and ready\nto be dropped in your React project. Each will appear and behave correctly\nwithout requiring additional styles nor adversely affecting styles already\nwritten. They do what you need them to, and nothing else.\n"

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = "### Let’s Get Started\n\n1. **Install the [Mineral UI package](https://www.npmjs.com/package/mineral-ui) using `npm` or `yarn`**\n\n    ```bash\n    npm install --save mineral-ui glamor glamorous react react-dom\n    ```\n\n1. **Wrap your app in a [ThemeProvider](/components/theme-provider) at its root for styling**\n\n    ```jsx\n    import React from 'react';\n    import { render } from 'react-dom';\n    import Button from 'mineral-ui/Button';\n    import { ThemeProvider } from 'mineral-ui/themes';\n\n    function App() {\n      return (\n        <ThemeProvider>\n          <Button>\n            Hello World\n          </Button>\n        </ThemeProvider>\n      );\n    }\n\n    render(<App />, document.getElementById('app'));\n    ```\n\n1. **Mineral is open-source. [Contribute!](https://github.com/mineral-ui/mineral-ui)**\n"

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = "### Simplicity, Quality, Speed — Pick Three\n\nPeople expect modern, engaging experiences that work.\nMineral makes this easier by providing common patterns, reusable components and\ndesign guidelines that are visually appealing, consistent and easy to use.\n\nBy using individually consumable React components, teams can build, launch, and\nmaintain high quality experiences with greater speed and efficiency.\n\n<CTALink to=\"/color\">\n  Discover how our guidelines can help your next project\n  <IconChevronRight size=\"large\" />\n</CTALink>\n"

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = "## Build Modern Products Faster\n\nMineral UI is an open-source design system created to simplify building\nappealing, modern software experiences. It is the culmination of designers and\ndevelopers working together to give teams the ability to ship high-quality\nproducts faster.\n\n<CallsToAction />\n"

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = "### Switch It Up With Themes\n\nIt’s easy to match Mineral components to a product experience with themes.\nWith just a few lines of code, change the theme for every component or constrain\nthe change to only affect a portion of them. Themes are simple enough to quickly\nchange the color palette and powerful enough to adjust a\n[whole host of other properties](/theming/#common-scenarios-theme-structure).\n\n<PlaygroundButton to=\"/theming\">\n  Learn About Themes\n</PlaygroundButton>\n"

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -225 412.12 432\"><defs><style>.p2{fill:#cececd} .p3{fill:#c9a168} .p4{fill:#d4b587} .p5{fill:#b7b6b6} .p6{fill:#575757} .p7{fill:#f5e5cd} .p8{fill:#ddd7d7} .p9{fill:#1b1c1c} .p10{fill:#6b6b6b} .p11{fill:#938980} .p12{fill:#f8eee4} .p13{fill:#f4f4f4} .p14{fill:#684a38} .p15{fill:#f6f7f7} .p16{fill:#343434} .p17{fill:#d3b08a} .p18{fill:#f8efe2} .p19{fill:#2f2f2f} .p20{fill:#c6882f} .p21{fill:#efeeed} .p22{fill:#ece5e5} .p23{fill:#3a2913} .g2{fill:#d7a350} .g3{fill:#efb140} .g4{fill:#9e7634} .g5{fill:#7f5629} .g6{fill:#d3b08a} .g7{fill:#f4cb88} .r1{fill:#eb774c} .r2{fill:#c1522e} .r3{fill:#d36542} .r4{fill:#bb4e2a} .r5{fill:#a23823} .r6{fill:#f3a188} .r7{fill:#f1b9ac} .r8{fill:#ecc3b7} .r9{fill:#6c110f} .t1{fill:#59718d} .t2{fill:#4f6278} .t3{fill:#598195} .t4{fill:#3b4953}</style></defs><g class=\"pile\"><path class=\"p2\" d=\"M39.6 109.4L57.3 135l25.5 2.7 22.2 11.7 29-20.6 9.6-29L118 72l-35.4 1.5-36 13.5-7 22.6z\"/><path class=\"p3\" d=\"M51.3 155l6-20h-8.8L38 143l13.3 12z\"/><path class=\"p4\" d=\"M39.6 109.4l-4.2 17 2.4 16.6 9.2-1.8 10.3-6.3-17.7-25.6z\"/><path class=\"p5\" d=\"M108.2 166l-3.2-16.7-22.3-11.6-25.4-2.8-6 20 38.2 11.3 18.7-.3z\"/><path class=\"p6\" d=\"M146.7 128L135 152.6 108.3 166l-2.8-14.7-.4-2 18.4-23.6 20-26 2.4 21z\"/><path class=\"p7\" d=\"M82.8 137.7l7-39-50.2 10.7L57.3 135l25.5 2.7z\"/><path class=\"p2\" d=\"M118 72L90 98.5s-23.7 10-26.3 10l-24 .8 7.2-22.6 36-13.5z\"/><path class=\"p8\" d=\"M62 78.3c6.7-2.7 21-7.8 25.7-7.3 2 .2 14.3-1.2 19.8-1 8.5 0 10.6 2 10.6 2s-25 3.5-30 3.7-25 6.6-27 7.6-14.3 3.5-14.3 3.5 12.6-7.3 15.4-8.5z\"/><path class=\"p2\" d=\"M91.3 142.2c3.6 1.3 11.2 4.4 12.4 4.4s3.6-3.4 5.6-5.2 14-16.5 16-18.5c0 0-7.8 11.4-9.7 14.4s-5 8-6.3 9.8c-1.3 1.5-3 5.3-5 3.7s-11.7-7-13-8.8z\"/><path class=\"p9\" d=\"M146 128l-11.7 24.5-27 13.5c4.6-3.6 21.2-13.4 22-14.6s9.3-12.8 10.2-15.7 4.8-8 5-10.7l.5-4zm-51 61.3c.3.4 1.3 3.4 1.3 3.4a21.2 21.2 0 0 1-.2 3.8 12.6 12.6 0 0 1-2.4 3.7 2.3 2.3 0 0 1-1.7.5c-1 0 .6-2.2.6-2.2l1.6-7z\"/><path class=\"p10\" d=\"M94 193.6a13.2 13.2 0 0 1 .6 2 4.8 4.8 0 0 1-.8 2.7c-.2.4-1 1.7-1.3 1.8a39.6 39.6 0 0 1-4.2.8 33.2 33.2 0 0 1-4.2-2c-.2-.2-5-.4-5.3-.7s-2.8-1.5-2.8-2a6.5 6.5 0 0 1 .5-2.3 1.3 1.3 0 0 1 .6-.3l2-2z\"/><path class=\"p11\" d=\"M94.4 194.3c0 .5-2.3 4-2.3 4a45.2 45.2 0 0 1-4.8-1c-.7-.3-5-2.4-5.3-2.8a19.8 19.8 0 0 0-3.6-1.7 4.3 4.3 0 0 0-1.3.6v-.5a6.7 6.7 0 0 1 1-.6 10.5 10.5 0 0 1 3 .8l1.3 1.4 3.7 2 3 .8a25.8 25.8 0 0 0 2.5.4 5.8 5.8 0 0 0 1-.7l1-2 1-.7z\"/><path class=\"p2\" d=\"M95 189.7a7.5 7.5 0 0 1 .2 2.4 2.4 2.4 0 0 0-.3.7l-.6 1.6c-.2.6-2.2 4-2.2 4a45.2 45.2 0 0 1-5-1c-.7-.4-5-2.4-5.3-2.8a19.8 19.8 0 0 0-3.5-1.7 1.2 1.2 0 0 0-.6 0 8.6 8.6 0 0 0-1 .5v-1.1l1-2.5 5-1.6h2.7a35.3 35.3 0 0 1 3.8-.7l4.7.5a5.4 5.4 0 0 1 1 1.6z\"/><path class=\"p6\" d=\"M84 199a33.2 33.2 0 0 0 4.3 1.8 39.6 39.6 0 0 0 4.2-.7c.2 0 1-1.3 1.3-1.7a4.8 4.8 0 0 0 .8-2.6l-.2-1.3a8.8 8.8 0 0 1-.4 2.7 5 5 0 0 1-1.7 2c-.4.3-4-.6-4.6-.7A56.4 56.4 0 0 1 82 196a27.7 27.7 0 0 0-5-1 1.2 1.2 0 0 0-1 1c0 .6 2.3 2 2.7 2.2s5 .4 5.4.7z\"/><path class=\"p12\" d=\"M83 188.2c-1.5.7-4 1.8-4 2s-.4.5-.7 1a4.2 4.2 0 0 0-.5 1.8 8.6 8.6 0 0 0-.8.4v-1.2l1-2.5 5-1.6z\"/><path class=\"p6\" d=\"M94.4 194.3c0 .5-2.3 4-2.3 4a45.2 45.2 0 0 1-4.8-1c-.7-.3-5-2.4-5.3-2.8a19.8 19.8 0 0 0-3.6-1.7 4.3 4.3 0 0 0-1.3.6v-.5a6.7 6.7 0 0 1 1-.6 10.5 10.5 0 0 1 3 .8l1.3 1.4 3.7 2 3 .8a25.8 25.8 0 0 0 2.5.4 5.8 5.8 0 0 0 1-.7l1-2 1-.7z\"/><path class=\"p10\" d=\"M92.4 199.8a.6.6 0 0 1-.5 1 7 7 0 0 1-2 .2c-.8 0-1.6 0-1.6-.4a.8.8 0 0 1 .7-.5 23 23 0 0 1 3.4-.2z\"/><path class=\"p13\" d=\"M91 191.6c-.4.2-1.3 1.2-1.8 1.2H88l-2.5-.3a2.3 2.3 0 0 0-.6.2h.6a2.7 2.7 0 0 1 1 .3 12.6 12.6 0 0 0 2.4.3l.7-.4a13.6 13.6 0 0 0 1.3-1c.3-.3.4 0 .6 0a31.6 31.6 0 0 1 3.3.7 2.4 2.4 0 0 1 .2-.6 28 28 0 0 0-4.3-.4zm-6.4-2.7c0-.6 1 0 1 0l1-.5a3.4 3.4 0 0 1 1 .3 1 1 0 0 1-.5.5 4.5 4.5 0 0 1-1 0c-.3 0-1.4 0-1.4-.4z\"/><path class=\"p10\" d=\"M95 189.7a7.5 7.5 0 0 1 .2 2.4 4.5 4.5 0 0 1-.5-1.3 3 3 0 0 0-.5-1 5 5 0 0 0-.6-1.3c-.3-.4-3-.4-3.4-.5a3.5 3.5 0 0 0-1.5 0l-3 .2a35.3 35.3 0 0 1 3.7-.8l4.8.6a5.4 5.4 0 0 1 1 1.7z\"/><path class=\"p5\" d=\"M228 64.6v2.6a31.8 31.8 0 0 1-.4 3.7v.3c-1 5.4-10.2 36.4-18.3 39s-39.7 9.8-45 10.2h-1.4a24.4 24.4 0 0 1-7-1 39.3 39.3 0 0 1-10-4.8c-5.3-4.7-21-25-13-37 1.7-2.3 7.3-12.2 12.2-20.3 2.4-4 4.6-7.5 6-9.5a15.7 15.7 0 0 1 1-1.4 3 3 0 0 1 .7-.5 15 15 0 0 0 3.4-1 4.7 4.7 0 0 0 1.2-1l.3-.4c5.2-6 15-9 18.3-11.3a1.8 1.8 0 0 1 1-.3c2.6 0 18.4 2.7 21.8 3.7s25 9.7 27.3 13a1.4 1.4 0 0 1 .2.3v.2c.7 2.2 1.3 8.5 1.4 14v1.4z\"/><path class=\"p10\" d=\"M228 64.6v2.6a31.8 31.8 0 0 1-.4 3.7v.3c-1 5.4-10.2 36.4-18.3 39s-39.7 9.8-45 10.2h-1.4a24.4 24.4 0 0 1-7-1 39.3 39.3 0 0 1-10-4.8s14-21.3 15.8-25.7 28-13.2 28-13.2l38-12.5v1.3z\"/><path class=\"p2\" d=\"M228 68.8l-.5 1.5c-.7 3.5-20.4 25.3-23 25.7s-16.4 4.8-23 1.3c-2-1.2-14.8-5-18.7-8.2a3 3 0 0 1-1.2-1.3l-5-20.8c-1-4.7-2-9.3-3-13.2l-1.2-7.2c.2-.6 14.8-15.2 18.2-17.5.4-.2 6.4-1 6.6-1 2.7 0 18 2.5 21.7 3.5 3.4 1 25 13.6 27.3 17.2a1.4 1.4 0 0 1 0 .3l.3.5c1 3.3 1.6 18.2 1.5 19.3z\"/><path class=\"p2\" d=\"M170.2 88c3.3 1 9.2 5.5 10.2 5.7s13 2.3 16.3 1.3a43 43 0 0 0 11-6c1.2-1.4 9.7-14.4 10.7-15s3-6.5 3.3-13.4-.3-11.2-2.8-14-8.8-4.8-10.6-3-2.8 9.6-2.8 9.6l4 4s0 7-3 10-2.5 16.4-6.3 17.4-12.5-7.4-14-7.7-5-.6-7 1.7-9 9.2-9 9.2z\"/><path class=\"p10\" d=\"M155.5 64c1.2 3 3.3 13 3.3 15.8s1.6 6.8 1.3 8.5-3.7 10-5.2 12.7c0 0 6.2-7.5 7-9.2s1-2 1-3.2-2.5-11-3-13-4.3-11.5-4.3-11.5z\"/><path class=\"p2\" d=\"M199 31.5C195 31 180.3 29 178.5 29c-1.8 0-7.8 2-9.4 3-1.5.7-9.6 9.5-12.8 13l-1.3 1.3c-1 1.2-1 5.6-1 8.6l-.3-1.2-2.4-6a15.7 15.7 0 0 1 1-1.3c.2-.5 15-15 18.3-17.5.4-.2 6.4-1.2 6.6-1.2 2.7 0 18 2.6 21.8 3.7z\"/><path class=\"p8\" d=\"M146 114.8c-5.3-4.8-21-25-13-37 1.7-2.4 7.3-12.3 12.2-20.4h.2L136 77s-3.6 6-3.3 8.4 4.6 18 13.2 29.3z\"/><path class=\"p9\" d=\"M227.7 69.8v1c0 .2 0 .3-.2.5-1 5.4-10 36.4-18.2 39s-39.8 9.8-45.2 10.2h-1a24.4 24.4 0 0 1-7-1 20 20 0 0 1 2.3-.2c20.6-.3 42.3-7.4 46.8-9s8.6-10 11.7-15c2-3.5 5-12.8 7-19.3l.6-.8.7-1 .3-.3.7-1a18.6 18.6 0 0 0 1-1.8 5.4 5.4 0 0 0 .3-.5 3 3 0 0 0 .2-.4s0-.3.2-.5z\"/><path class=\"p14\" d=\"M225.3 74l.8-1z\"/><path class=\"p10\" d=\"M332 192.4v.7a8.7 8.7 0 0 1 0 1v.2c-.4 1.5-3 10-5 10.7a113.4 113.4 0 0 1-12.5 2.7h-.3a6.7 6.7 0 0 1-2-.3 10.7 10.7 0 0 1-2.6-1.3c-1.4-1.2-5.7-6.7-3.5-10 .5-.6 2-3.3 3.4-5.6l1.7-2.6a4.3 4.3 0 0 1 .3-.3.8.8 0 0 1 .2 0 4 4 0 0 0 1-.4 1.3 1.3 0 0 0 .2-.2c1.6-1.7 4.2-2.5 5-3.2a.5.5 0 0 1 .4 0 50.8 50.8 0 0 1 6 1c1 .2 7 2.6 7.5 3.5v.2a20.5 20.5 0 0 1 .4 4v.2z\"/><path class=\"p6\" d=\"M332 192.4v.7a8.7 8.7 0 0 1 0 1v.2c-.4 1.5-3 10-5 10.7a113.4 113.4 0 0 1-12.5 2.7h-.3a6.7 6.7 0 0 1-2-.3 10.7 10.7 0 0 1-2.6-1.3s3.8-5.7 4.3-7 7.5-3.5 7.5-3.5L332 192v.4z\"/><path class=\"p2\" d=\"M332 193.6l-.2.4c-.2 1-5.5 7-6.3 7s-4.4 1.3-6.2.4c-.6-.4-4-1.5-5-2.3a.8.8 0 0 1-.4-.3c-.2-.4-1-3-1.5-5.6l-.8-3.5-.4-2a60.2 60.2 0 0 1 5-4.8l1.8-.3a52 52 0 0 1 6 1c1 .2 7 3.7 7.5 4.7v.2a32.6 32.6 0 0 1 .5 5.4z\"/><path class=\"p15\" d=\"M316.2 198.8a25.6 25.6 0 0 1 2.8 1.5c.2 0 3.5.7 4.4.4a11.7 11.7 0 0 0 3-1.7c.4-.3 2.7-4 3-4s.8-1.8.8-3.6 0-3-.7-4-2.4-1.2-3-.7a7.5 7.5 0 0 0-.6 2.6l1 1a4.6 4.6 0 0 1-1 3c-.7.7-.5 4.3-1.6 4.6s-3.4-2-3.8-2.2a2 2 0 0 0-2 .5l-2.4 2.4z\"/><path class=\"p12\" d=\"M312.2 192.3a20 20 0 0 1 1 4.2l.3 2.4a23.5 23.5 0 0 1-1.5 3.3 28.2 28.2 0 0 0 2-2.5 1.7 1.7 0 0 0 .2-.8l-.8-3.6-1.2-3zm11.8-9c-1 0-5-.6-5.5-.6a8.8 8.8 0 0 0-2.6.8c-.5.2-2.7 2.6-3.6 3.5l-.4.4c-.3.3-.2 1.5-.2 2.4l-.2-.3c0-.4-.4-1.2-.6-1.7a4.3 4.3 0 0 1 .3-.3 60.2 60.2 0 0 1 5-4.8l1.8-.3a52 52 0 0 1 6 1z\"/><path class=\"p2\" d=\"M309.6 206c-1.5-1.2-5.7-6.7-3.5-10 .5-.6 2-3.3 3.4-5.6l-2.5 5.3a6.8 6.8 0 0 0-1 2.4 22.5 22.5 0 0 0 3.6 8z\"/><path class=\"p9\" d=\"M332 193.8v.4c-.4 1.5-3 10-5 10.7a113.4 113.4 0 0 1-12.4 2.7h-.4a6.7 6.7 0 0 1-2-.3 5.5 5.5 0 0 1 .8 0 44 44 0 0 0 12.7-2.5c1.3-.6 2.3-2.8 3.2-4.2a32.6 32.6 0 0 0 1.8-5.2l.2-.2.2-.3.3-.3a5 5 0 0 0 .2-.4v-.2z\"/><path class=\"p14\" d=\"M331.2 195l.2-.3z\"/><path class=\"p10\" d=\"M106 153.5c-2.8 2-19 5-21.3 5.8s-11 4.6-14.4 4.7-30.4 1.7-32.5.8-6-3.8-7.3-4.3-13 2.8-17.5-.8c-6-5-13-18.2-13-18.2l32.8-22.3L73 96.7s44 17 45 29.7a24.2 24.2 0 0 1-.7 8c-2.2 9.4-9 17.5-11.2 19z\"/><path class=\"p5\" d=\"M116 138.7c-9.8-9.3-23.8-16.8-27.6-14.7-5.4 2.8-10.7 1.6-14.5 2.7s-27-1.7-29.4 1C46 126 53.8 116 59 112a28.4 28.4 0 0 1 6.7-3.8c2-.3 9.8-1.6 12.2-2.7h1.7a7.2 7.2 0 0 1 1.3 0c3 1.5 8.4 3.6 10.4 4.7s6.6 4.6 13.3 8.5 12 9.4 11.7 11.3a13 13 0 0 0 1 4 39 39 0 0 1-1.4 4.4z\"/><path class=\"p10\" d=\"M84.8 124.7c-1.6.6-8.6.8-10 1l-6.8 1-11.4-1.2a42.5 42.5 0 0 0-9.6-.3c-1.3.3-9 6.7-10.6 7s-2 1-8 5.6c2 0 6.5-3 7.4-3.4s10.2-6 12.6-7 5-.3 7 0c2.8.4 4.7 0 6.6.6 1.3.5 11.8-.7 13.8-1a42 42 0 0 1 5.4-.5 16.5 16.5 0 0 0 7.6-2.7c-1 .4-2.5.2-4 1z\"/><path class=\"p6\" d=\"M30.5 160.5c-1.2-.4-13 2.8-17.5-.8-6-5-13-18.2-13-18.2s12.4-4 14.4-1.2c.3.5 1 1.2 1.6 2.2 4 5 12.2 15.7 14.5 18z\"/><path class=\"p16\" d=\"M30.5 160.5s-4-1-5-2.3-3-3.8-4-4.6-5-4.5-5.3-5.2a12.2 12.2 0 0 0-4.2-2.8l4-3c4 5 12.2 15.6 14.5 18z\"/><path class=\"p17\" d=\"M118 126.4c-9.7-6-28.6-19-37-20.6a7 7 0 0 0-1.2 0h-2a36.7 36.7 0 0 0-12 2.6 28.6 28.6 0 0 0-6.8 3.8c-4 3-9.6 9.7-12.5 13.3l-1.8 2c-1.5 1.7-14 9.7-16 10.3h-.2c-1 .3-6 4-10.8 7a38 38 0 0 1-3.7 2 7.5 7.5 0 0 1-4.2 1c-4.2-1-9.8-6.2-9.8-6.2.2-1.3 2.6-16.3 6.2-18.6l7-5L40 97.7a43.5 43.5 0 0 1 4-2.6c5.8-3.3 15.8-8.6 20-9l3.3-.2c7.3 0 20.5 1.6 25 6.3 5 5.7 25.4 26.7 25.7 34.4z\"/><path class=\"p2\" d=\"M117.3 134.3a13 13 0 0 1-1-4c.3-2-4.8-7.6-11.5-11.4s-11.5-7.5-13.4-8.6S84 107 81 105.8c1.4-1 7 0 9.8 2.3s7 4.6 10.2 6.7 12 6.8 13.3 8 3.4 1.2 3.7 3.7a24.3 24.3 0 0 1-.7 8z\"/><path class=\"p2\" d=\"M118 126.4c-9.7-6-28.6-19-37-20.6a7 7 0 0 0-1.2 0h-2a36.7 36.7 0 0 0-12 2.6 28.6 28.6 0 0 0-6.8 3.8c-4 3-9.6 9.7-12.5 13.3l-1.8 2c-1.5 1.7-14 9.7-16 10.3h-.2c-1 .3-6 4-10.8 7h-.2a36.3 36.3 0 0 1-3.5 2 7.5 7.5 0 0 1-4.2 1c-4.3-1-9.8-6.2-9.8-6.2 0-1.2 2-13 5-17.4a4.5 4.5 0 0 1 1-1.2l7-5c9.6-7 25-19 27-20.4a43.5 43.5 0 0 1 4-2.5c5.8-3.3 15.8-8.6 20-9l3.3-.2c7.3 0 20.5 1.6 25 6.3 5 5.7 25.4 26.7 25.7 34.4z\"/><path class=\"p5\" d=\"M14.4 121c1.5 0 4.4 3.5 5 5.5s-1.5 9-1.6 10.3 1 3-.2 4.4-4.2 3.7-5.5 3.8-9-3.6-9-4.3 2.6-13 3.5-14 5.3-5.5 8-5.7z\"/><path class=\"p2\" d=\"M78.4 105.3a1.7 1.7 0 0 1-.5.4c-2.5 1-10.2 2.4-12.3 2.7h-.5c5.4-2.7 10-6.5 10-10a2 2 0 0 0-.2-1c-1.2-2.8-7-5-9.8-7.2-3-2.5-13 2.2-21.2 5 5.7-3.6 15.8-8.8 20-9.3l3.2-.2c1.5 1.4 2.5 3 3.3 3.3 1.7.6 5.8 4 8.8 7a4.8 4.8 0 0 1 1.5 4 9 9 0 0 1-2.4 5.3z\"/><path class=\"p6\" d=\"M284.5 197.8a26 26 0 0 1-3.5 1 11.7 11.7 0 0 1-2.3.7c-.5 0-5 .3-5.2 0s-1-.5-1.2-.6-2 .4-3-.2a12.4 12.4 0 0 1-2-3l5.4-3.5 6.5-3.7s7 2.8 7.2 4.8a4 4 0 0 1 0 1.3 6.4 6.4 0 0 1-2 3z\"/><path class=\"p10\" d=\"M286 195.4c-1.5-1.5-3.8-2.7-4.4-2.4a8.3 8.3 0 0 1-2.3.5c-.7.2-4.4-.3-4.8 0a21.4 21.4 0 0 1 2.3-2.4 4.6 4.6 0 0 1 1-.5 12.4 12.4 0 0 0 2-.4h.6l1.7.8 2.2 1.4a3.8 3.8 0 0 1 2 2 2 2 0 0 0 0 .5 6.3 6.3 0 0 1 0 .7z\"/><path class=\"p2\" d=\"M281 193.2a14 14 0 0 1-1.6 0l-1 .3c-.7 0-1.7 0-2-.2a6.8 6.8 0 0 0-1.5 0c-.3 0-1.5 1-1.8 1a3.7 3.7 0 0 0-1.3 1 4.2 4.2 0 0 0 1-.6c.3 0 1.8-1 2-1a2.2 2.2 0 0 1 1.2 0 8.3 8.3 0 0 1 1 0 14.8 14.8 0 0 0 2.3-.2 6.8 6.8 0 0 1 1 0 2.7 2.7 0 0 0 1-.5l-.5.2z\"/><path class=\"p6\" d=\"M272.3 199c-.2 0-2.2.5-3 0a12.4 12.4 0 0 1-2-3s2-.7 2.4-.3l.2.4c.5 1 2 2.6 2.3 3z\"/><path class=\"p16\" d=\"M272.3 199a2.7 2.7 0 0 1-.8-.4l-.7-.7-.8-1a2 2 0 0 0-.7-.5l.7-.5 2.3 3z\"/><path class=\"p17\" d=\"M286.4 193.4c-1.6-1-4.6-3-6-3.3h-.5a6 6 0 0 0-2 .6 4.6 4.6 0 0 0-1.2.6 16.5 16.5 0 0 0-2 2l-.3.5a16.7 16.7 0 0 1-2.6 1.6c-.2 0-1 .7-1.8 1a6.2 6.2 0 0 1-.6.4 1.2 1.2 0 0 1-.7.2 4.8 4.8 0 0 1-1.7-1c0-.3.4-2.7 1-3l1-1c1.7-1 4-3 4.5-3.2a7 7 0 0 1 .6-.4 12.4 12.4 0 0 1 3.3-1.5h.5c1.2 0 3.3.2 4 1s4 4.2 4.2 5.4z\"/><path class=\"p18\" d=\"M286.3 194.7a2 2 0 0 1 0-.6 3.8 3.8 0 0 0-2-1.8l-2.2-1.4-1.5-.7a2 2 0 0 1 1.5.5l1.7 1 2 1.3a1 1 0 0 1 .7.6 4 4 0 0 1 0 1.3z\"/><path class=\"p2\" d=\"M286.4 193.4c-1.6-1-4.6-3-6-3.3h-.5a6 6 0 0 0-2 .6 4.6 4.6 0 0 0-1.2.6 16.5 16.5 0 0 0-2 2l-.3.5a16.7 16.7 0 0 1-2.6 1.6c-.2 0-1 .7-1.8 1a6 6 0 0 1-.6.4 1.2 1.2 0 0 1-.7.2 4.8 4.8 0 0 1-1.6-1 9.7 9.7 0 0 1 .8-3 .7.7 0 0 1 .2 0c0-.2.5-.5 1-1 1.6-1 4-3 4.4-3.2a7 7 0 0 1 .7-.4 12.4 12.4 0 0 1 3.2-1.5h.5c1.2 0 3.3.2 4 1s4 4.2 4.2 5.4z\"/><path class=\"p10\" d=\"M269.7 192.6a1.5 1.5 0 0 1 .8 1 7.4 7.4 0 0 1-.3 1.5 1 1 0 0 1 0 .8 2 2 0 0 1-1 .6 4.7 4.7 0 0 1-1.3-.7 12 12 0 0 1 .4-2.2 3.2 3.2 0 0 1 1.3-1z\"/><path class=\"p12\" d=\"M280 190a12.4 12.4 0 0 1-2 .5h-.2a2.6 2.6 0 0 0 1.7-1.6.3.3 0 0 0 0-.3 5.3 5.3 0 0 0-1.6-1.2c-.6-.4-2.2.4-3.6.8a12.3 12.3 0 0 1 3.3-1.5h.5a3 3 0 0 0 .5.6 6.5 6.5 0 0 1 1.5 1 .8.8 0 0 1 .2.7 1.4 1.4 0 0 1-.4 1z\"/><path class=\"p10\" d=\"M412 144L391 160.5c-3 2.3-16.8 2.8-16.8 2.8l-35.7 9s-4.8.3-9.8.2h-.6c-4.3 0-8.6-.2-10.2-1-3.7-1.7-18-35.2-18-35.2l-4.3-21.4-.3-1.7 93.7 8 3 3z\"/><path class=\"p19\" d=\"M412 144s-19.8-7.8-22.7-12S379 99 379 99l11.3-8.2 6 10.2 1.2 12 10.8 13z\"/><path class=\"p6\" d=\"M321.4 155.5c-.5 2.6 4.7 12 7 17.2h-.5c-1.7-1.5-6.3-10.2-6.8-11.7a89.5 89.5 0 0 0-5.5-10.3h.3c1.4.3 6.2 1.4 5.4 4.8z\"/><path class=\"p6\" d=\"M328 172.6c-4.3 0-8.6-.3-10.3-1-3.6-1.7-18-35.2-18-35.2l-4-21.4c2.4 7.7 18.2 32.5 19 33.8a11.4 11.4 0 0 0 1.3 1.8h-.3a83.5 83.5 0 0 1 5.5 10.4c.5 1.5 5 10.2 6.7 11.6z\"/><path class=\"p5\" d=\"M295.2 113.2c.3-3 17-21.6 18-22.5S326 88 326 88s41-.3 42.3-.7l15.8-4 6.3 7.6-1.5 18 6.4 6-6 17-8 4.3s-54.3 20.4-58 19.5-8-5.6-8.7-7-19.7-31.4-19.3-35.6z\"/><path class=\"p20\" d=\"M330.2 177.6l.4 1.7a4.7 4.7 0 0 1-.4-1.7z\"/><path class=\"p10\" d=\"M388.8 109s-5 9.5-6 11-1.8 9-1.8 9 .8-5.4 2.6-7.6 7-11 7-11z\"/><path class=\"p5\" d=\"M295.2 113.2s2 7.2 2.4 8 10 18.7 11.4 21a72 72 0 0 0 7 9.3c2 1.8 5.7 5.3 9.2 5.3s44.8-15.5 47.2-17 7.2-1.7 9-3.6a132.5 132.5 0 0 0-14.6 4.5c-8.2 3-35.6 12.2-37.2 12.6s-7.3 1.3-8.6.2-5-4.6-6-6.6-13.8-20.7-14.4-22.8-5.4-11-5.4-11z\"/><path class=\"p10\" d=\"M300 117.4c-2.8-5 10.3-16.8 13-19.5s14.8-5 16.2-5.6 4 1.6 4 3.5-4.8 13-6 14.8.6 8.7 1 11 6.5 8 8.8 7.8 13.7 1.6 13.7 1.6 3.6 4.3 10.8 2.7a108.8 108.8 0 0 0 15.5-5l-12.8 10c-2 1.5-19 5.6-22.3 5.7s-11 6.8-16.6 4-24-28.4-25.5-31.3z\"/><path class=\"p6\" d=\"M403.8 144.6l-15 14.4s-9-.7-12.3 0-11 3.7-15 4c0 0 7-4.2 9.4-8 4.2-.3 12.7 1.5 14.7.6s12.5-10.4 14.5-11.3a3.7 3.7 0 0 1 3.6.3z\"/><path class=\"p10\" d=\"M73.2 184.3l-2.7 2a6.5 6.5 0 0 1-2 .4l-4.5 1h-1.3a4.2 4.2 0 0 1-1.2 0c-.5-.2-2.2-4.4-2.2-4.4l-.5-2.6v-.2l11.5 1 .4.3z\"/><path class=\"p9\" d=\"M73.2 184.3a11 11 0 0 1-3-1.5 33.2 33.2 0 0 1-1-4l1.3-1 .7 1.2.2 1.5 1.3 1.6z\"/><path class=\"p2\" d=\"M62 185.7a8 8 0 0 0 1 2h-.3a8 8 0 0 1-.8-1.3 11 11 0 0 0-.8-1.3c.3 0 .8.3.8.7z\"/><path class=\"p6\" d=\"M62.8 187.8a4.2 4.2 0 0 1-1.3 0c-.5-.3-2.2-4.5-2.2-4.5l-.5-2.6A40.2 40.2 0 0 0 61 185a1.4 1.4 0 0 0 .3 0 10.3 10.3 0 0 1 .7 1.4 7.4 7.4 0 0 0 .8 1.4z\"/><path class=\"p2\" d=\"M58.7 180.5a16.7 16.7 0 0 1 2.2-2.8 10.8 10.8 0 0 1 1.5-.3h5.2l2-.6.8 1-.2 2 .8 1-.7 2-1 .5s-6.7 2.5-7.2 2.4a2.3 2.3 0 0 1-1-.8c0-.3-2.3-4-2.3-4.5z\"/><path class=\"p20\" d=\"M63 188.4v.2a.6.6 0 0 1 0-.2z\"/><path class=\"p10\" d=\"M70.3 180l-.8 1.3a5.6 5.6 0 0 0-.2 1 2.5 2.5 0 0 1 .3-.8l1-1.4z\"/><path class=\"p21\" d=\"M58.7 180.5l.3 1 1.4 2.6a9 9 0 0 0 1 1.2 2 2 0 0 0 1 .7 58 58 0 0 0 5.8-2.2 6.7 6.7 0 0 0 1.2-.5 16.4 16.4 0 0 0-1.8.6l-4.6 1.4a2 2 0 0 1-1 0 4.6 4.6 0 0 1-1-.8l-1.6-2.8-.7-1.3z\"/><path class=\"p10\" d=\"M59.3 181c-.3-.6 1.3-2 1.6-2.4a7.7 7.7 0 0 1 2-.7.5.5 0 0 1 .4.3 8.8 8.8 0 0 1-.7 2 3.5 3.5 0 0 0 0 1.2 2 2 0 0 0 1.2 1 12.7 12.7 0 0 1 1.6.2 1.4 1.4 0 0 0 1.3.4 13.4 13.4 0 0 0 1.8-.5l-1.5 1.2a12 12 0 0 1-2.8.7c-.4 0-1.3 1-2 .5s-3-3.6-3.2-4z\"/><path class=\"p6\" d=\"M72 184.3l-1.7 1.8a9.7 9.7 0 0 0-1.5 0 18.6 18.6 0 0 1-2 .6 4.5 4.5 0 0 0 1.3-1 14.2 14.2 0 0 0 2 0c.2 0 1.4-1.2 1.7-1.3a.5.5 0 0 1 .4 0zm-34.6-3.7a11 11 0 0 1 2.3 1.6l.4 5 .6 6-1 2.3L38 197l-11.6-1.3-4.6.7-1-1-1.8.4-1.5-1.8a9 9 0 0 1 1.2-2.7l6.2-5.6c.6-.8 4.7-.4 5-.6.6.2 2 .2 2 .2l.5-.6s4.7-4 5-4z\"/><path class=\"p2\" d=\"M37.4 180.6a11 11 0 0 1 2.3 1.6 41.4 41.4 0 0 1-2 4.2c-.4.4-3 1-3.8 1.6l-5.4 4.6-7.8 2.8-1.8.4-1.5-1.7a9 9 0 0 1 1.2-2.7l6.2-5.6c.6-.8 4.6-2 5-2.2h2.3l.5-1c0-.3 1.5-1 3-1.4.8 0 1.5-.4 1.6-.4z\"/><path class=\"p10\" d=\"M30 183.5h2.3l-.7 1.5a5 5 0 0 1-.6 1c-.3.2-1.2 1.4-1.3 1.6s-1.8 1-2 1l1.3-1 1-2.3z\"/><path class=\"p22\" d=\"M35.7 181.2l-2.6 1.4a5.4 5.4 0 0 0-.3 1.2 16 16 0 0 1-1 1.3l.7-1.3.4-1.2c0-.2 1.5-1 3-1.3z\"/><path class=\"p10\" d=\"M40 187.2l.6 6-1 2.3L38 197l-11.5-1.3 7.7-1.3 3.8-2 2-5.3z\"/><path class=\"p9\" d=\"M39.6 195.5a28 28 0 0 0 .2-3 4.5 4.5 0 0 0-1-2l-1-4 2-4.2.8 11z\"/><path class=\"p10\" d=\"M18.2 193.7l-.7.4L19 196l3 .5-.5-1-3.3-1.6z\"/><path class=\"p22\" d=\"M25 185.7L24 187l-4 3.3-1 1.4a10.2 10.2 0 0 0-1 2l-.7.4a9 9 0 0 1 1.2-2.7l6.2-5.6z\"/><path class=\"p10\" d=\"M21.5 195.2l.4 1-3-.4a17 17 0 0 1-.8-2c0-.2 3.3 1.4 3.3 1.4z\"/><path class=\"p6\" d=\"M192.6 147c-.6 2 13.5 15.7 13.5 15.7l39.3 2 49 2.3 17-7.5 11.7-11.8-13.2-83.2 4-33.3L306 24l3-13.7L294.8 0C286.2 2.8 277 6 273 9.3s-36.7 40.4-43 46c-6.4 5.4-2 34.6-3.6 37.4.8 3.5 1.5 13.6 1.5 13.6s-2 2-4.3 4-30.6 34.7-31 36.7z\"/><path class=\"p5\" d=\"M192.6 147c-.6 2 13.5 15.7 13.5 15.7 1.6-.3 30.4-13.2 33-15.4s7.5-22 11.7-27.3S281 85.5 286 80.4 306 24 306 24l3-13.7L294.8 0C286.2 2.8 277 6 273 9.3s-36.7 40.4-43 46c-6.4 5.4-14.8 34.6-16.3 37.4v.6c.2.4.2.8.3 1.3l.2 1.2c0 1.2.3 2.6.5 4l.6 4.2.2 2 .5 3.4s-7.5 2.5-9.7 3.6c-1.7-.5-6.2 11.3-9.6 21.2l-4.2 12.8z\"/><path class=\"p10\" d=\"M213.7 92.7v.6l.3 1.3.2 1.2.5 4 .6 4.2.2 2 .5 3.4s5.6-2.7 10.5-5.4c3.2-1.7 6-3.5 7-4.5 2.4-2.6 12-9 13-10s7.6-13 8-13.7l-9 8.8L228 92z\"/><path class=\"p10\" d=\"M196.7 134.2c3.2-5.3 9.4-17.6 10.4-19 1.3-1.5 7.2-2 10-3.4s5.3-5 9.5-7.8c-5 2.7-10.5 5.4-10.5 5.4s-7.6 2.5-9.8 3.6c-1.6-.6-6 11.3-9.5 21.2z\"/><path class=\"p19\" d=\"M245.3 164.6l49 2.4 17-7.5 11.7-11.8-13.2-83.2-8.2 56.2-15 28-41.3 16z\"/><path class=\"p23\" d=\"M311.3 159.5c-9.6.6-17.8 2.5-23.2 2s-9.5-2.7-16.4-7l-32.6-7.2-33 15.4 88.3 4.3z\"/><path class=\"p6\" d=\"M292 5l2.8-5L309 10.3l5 21-9.5-2.6S291.5 5.4 292 5z\"/><path class=\"p2\" d=\"M230 55.3l11.2-5 24.5-29.8 11-7S289.4 5 292 5l2.8-5c-8.6 2.8-17.6 5.8-21.7 9.3s-36.7 40.4-43 46z\"/><path class=\"p10\" d=\"M304.4 28.7l9.5 2.5-5-21c-1-.3-14.8-5-17-5-.6.2 12.4 23.5 12.4 23.5z\"/><path class=\"p5\" d=\"M265 83.2l14.8-17.8L291 42l1.7 2.8-3 14-12.4 20.7-12.4 3.7z\"/><path class=\"p5\" d=\"M295 22l4 6.3-2 9-3.3 8-5 7-1-6.6 5.7-11.4L295 22zM183 182l-45.2-8a2 2 0 0 1-.5-.7c-.7-2.6-6.3-10.7-6.4-13a3 3 0 0 1 0-.7c.2 0 1 0 2.5-.4 9.3-1.6 40.6-7.7 42-6.6a19.5 19.5 0 0 1 2 4.4c1 2 1.7 4 2.5 6.5 2.4 7 4.5 15.4 3 18.5z\"/><path class=\"p2\" d=\"M199.4 94l6 5.5L232 123s5.7 17 3.8 20.4-19.8 3-19.8 3l-3.2.5c-1.2 0-2.7.3-4.3.6-6.7 1-15.7 2.5-17 3.6-2.2 1.7-6.6 10.5-10.6 12.2a24 24 0 0 1-5.2.7c-11.6.8-36.6.4-36.6.4l-8-4.7 4-25 9.8-21S160 99 168.4 96.3C177 93.6 194 90 194 90s3.4 2.4 5.4 4z\"/><path class=\"p6\" d=\"M231.6 179.4l-12.2 2.6c-1.8-2-15-18-14.4-23a46.8 46.8 0 0 1 3.3-11.5 18.4 18.4 0 0 1 3-5c2.2-2.3 13-11 13-11 4.3 3.8 11 9.2 11.3 12 .3 2.5-2.8 34.6-4 36z\"/><path class=\"p2\" d=\"M145 113.6l4.6 10.4-10.7 14-7.4 20-.7 1.7.2-2 3.2-22 10.5-22z\"/><path class=\"p2\" d=\"M175 164h-1a8.6 8.6 0 0 0-1 0l-4 .2h-1.4c-10 .4-26 1-28.7 0a36 36 0 0 1-8-4 3 3 0 0 1 0-.7l.2-2 .3.2 2 1.4 5.5 4 11.6.6c2 .3 21.5.4 24.5.5z\"/><path class=\"p5\" d=\"M189.8 141l-8-22 6.3-4.6 2-3.6 4-2.7 5.3-3.8 3.7-3 21 26 .3 4.4-13 10.8L195 144l-5-3z\"/><path class=\"p2\" d=\"M202 101c-3.6 3.3-11.7 8.4-13 11-.8 1.7-4.4 4.3-8.3 6.7-2 1.3-29.5 4.3-31 5.3 0 0 28.8-3.4 32.2-5 3-1.6 6.2-3.3 6.4-3.8l1.4-2.8a2.8 2.8 0 0 1 1.4-1.8c1-.3 11.6-8.4 11.6-8.4z\"/><path class=\"p6\" d=\"M194 90c15.6 7.6 37.8 33 37.8 33s5.7 16.8 3.8 20.4l-11.3-12z\"/><path class=\"p10\" d=\"M219.4 182H183c-3-2.5-6.6-12.7-7.5-18-.3-1.6 11.4-22.2 14.3-23 4-1.3 21.4 1.4 21.4 1.4a24.7 24.7 0 0 1 1.4 4.4c2.6 10.3 7.7 34.2 6.8 35.2z\"/><path class=\"p5\" d=\"M238.5 123.8c-6.4 7-7 46.5.5 53 11.4 2.2 41.8-15.3 41.8-15.3l-7.4-26.6z\"/><path class=\"p10\" d=\"M333.7 144c.4 5-5.4 19.6-13.3 25.4a66.4 66.4 0 0 1-7.6 4.6c-8.5 4.6-19.8 9-28.5 10.7-5.3 1-41.6-5.4-45.3-8-1-3 15.7-8 15.7-8s5.5-17.5 7.8-18 52.4-30 60-27.6c3.7 2.7 10.8 16 11.2 21z\"/><path class=\"p2\" d=\"M322.5 123.2s-5 10.5-7.3 12.4c-9.2 7-46 13-52 15l-.7.2-24-27s20.7-18.7 24.5-21.2a4 4 0 0 1 2-.4c11.5-.3 57.5 21 57.5 21z\"/><path class=\"p10\" d=\"M244 121.5c1.2-1.4 13-10.7 15-13.2s5.2-5 6-6a4 4 0 0 0-2 .3c-4 2.5-24.6 21.2-24.6 21.2s15.7 21.5 24 27c.4 0 .6-1 .3-1.4-.6-1.4-3.6-4.4-5-5.5-1.8-1.6-13.4-16-14.7-18s-.2-3 1-4.5z\"/><path class=\"p6\" d=\"M312.8 174c-8.5 4.5-19.8 9-28.5 10.7-5.3 1-41.6-5.4-45.3-8-1-3 15.7-8 15.7-8s39.7 7.8 44.3 8c4 .3 10.5-2 13.8-2.7z\"/><path class=\"p10\" d=\"M351 178c-1.5 1.7-1.6 11 0 12.5 2.8.5 9.8-3.6 9.8-3.6l-1.7-6.3z\"/><path class=\"p6\" d=\"M373.2 182.8a9.4 9.4 0 0 1-3 6 15.5 15.5 0 0 1-2 1 26.3 26.3 0 0 1-6.5 2.5c-1.3.2-9.7-1.3-10.6-1.8 0-.8 3.8-2 3.8-2s1.3-4 1.8-4 12.2-7 14-6.5a10.7 10.7 0 0 1 2.6 4.8z\"/><path class=\"p2\" d=\"M370.6 178a14 14 0 0 1-1.7 3c-2.3 1.5-11 3-12.3 3.4L351 178s4.8-4.3 5.7-4.8a1 1 0 0 1 .5 0c2.6-.2 13.4 4.8 13.4 4.8z\"/><path class=\"p12\" d=\"M352.3 177.6l3.5-3 1.4-1.5a1 1 0 0 0-.5.2c-1 .5-5.7 5-5.7 5s3.7 5 5.6 6.2v-.3a6 6 0 0 0-1-1.2c-.5-.4-3.2-3.7-3.5-4.2a.8.8 0 0 1 .3-1z\"/><path class=\"p9\" d=\"M368.3 189.8a26.3 26.3 0 0 1-6.6 2.5c-1.3.2-9.7-1.3-10.6-2 0-.6 3.8-1.7 3.8-1.7s9.2 1.8 10.3 2a16.8 16.8 0 0 0 3.3-.8z\"/><path class=\"p6\" d=\"M100.6 186l2.4 4.4 2.3 1.6 5.7 2 5.4.8-3.7-9.8-12 1z\"/><path class=\"p2\" d=\"M107.5 171.5s-3 4-3.2 5-3.6 4-3.6 4l8.8 3.4v-3.7l3-2.4-.4-4 1.4-3.2z\"/><path class=\"p10\" d=\"M130 179.8l-11.4-1.5-6-.5-.5-4 1.5-3 2.4-1 5 .8 5 2.6 4 6.6z\"/><path class=\"p10\" d=\"M130 179.8l-.2 1-1 6a2.8 2.8 0 0 1-.8 1.6l-4.8 4.7-6.7 1.8-5.6-.7-1.3-5.6v-.5l-.5-2.3v-.3l-.3-1.8-.5-1.6 1-1.8 3.2-2.4 6 .5 5 .7zm-29.3.6L99 184l6.7 1.5h8l-1.4-1.7-3.3-.8-.5-1-7.8-1.6z\"/><path class=\"p6\" d=\"M113.8 185.4l-.3 2.2v.3l-8 1-5-3-1-1.5-.5-.6 6.6 1.5h8.2zm-1.5-1.6l12.7.3 5-4.2-7.2-4.3-10 2.3-3.3 2.4-1 1.8.5 1 3.3.8z\"/><path class=\"p9\" d=\"M130 179.8l-.2 1-1 6a2.8 2.8 0 0 1-.8 1.6l-4.8 4.7 2-9z\"/><path class=\"p12\" d=\"M113.8 185.4h-1l-5.3.3-2 .2-.8-.3-4.8-1.2a2 2 0 0 0-.6 0l-.4-.6 6.7 1.5h8z\"/><path class=\"p6\" d=\"M121 170.6l1.8 5 2.2 8.4 5-4.2-4-6.6-5-2.6z\"/><path class=\"p12\" d=\"M122.6 175a9.2 9.2 0 0 1-1.5 1l-3.7.6-4.6 1.2a20.4 20.4 0 0 0 2.2-.2c.3-.2 2.5-.7 2.7-.7l3-.5a12.8 12.8 0 0 0 2-.6.5.5 0 0 0 0-.5z\"/></g><g class=\"ruby\" transform=\"translate(10-200)\"><animateTransform attributeName=\"transform\" type=\"translate\" values=\"10-200;10-180;10-200\" dur=\"7s\" repeatCount=\"indefinite\" keyTimes=\"0;.5;1\" keySplines=\".5 0 .5 1;.5 0 .5 1\" calcMode=\"spline\"/><g><animateTransform attributeName=\"transform\" type=\"rotate\" values=\"2.5 62.675 54.295;-2.5 62.675 54.295;2.5 62.675 54.295\" dur=\"4s\" repeatCount=\"indefinite\" keyTimes=\"0;.5;1\" keySplines=\".5 0 .5 1;.5 0 .5 1\" calcMode=\"spline\"/><path class=\"r4\" d=\"M82 108.2l-2.6-18.7-26-13.2L22.6 72 18 96l43 12.8 21-.4z\"/><path class=\"r1\" d=\"M4.8 44.5l20 28.7 28.6 3 25 13.3 32.7-23L122 33.6 93.2 2.3 53.2 4 12.7 19l-8 25.5z\"/><path class=\"r2\" d=\"M18 95.8L24.6 73h-10l-12 9.3L18 96z\"/><path class=\"r3\" d=\"M4.8 44.5L0 63.5l2.8 18.8 10.3-2 11.7-7-20-28.8z\"/><path class=\"r5\" d=\"M125.3 65.6l-13 27.5L82 108.3l-3-16.6-.6-2 20.8-26.8 22.6-29 2.6 23.6z\"/><path class=\"r6\" d=\"M53.4 76.3l8-44L4.7 44.5l20 28.7 28.6 3z\"/><path class=\"r7\" d=\"M93.2 2.3l-32 30S34.7 43.7 31.8 43.7l-27 .8 8-25.5L53.3 4z\"/><path class=\"r8\" d=\"M30 9.5c7.6-3 23.6-8.8 29-8.2C61 1.5 75 0 81.2 0c9.6.3 12 2.3 12 2.3s-28.3 4-34 4.2S31 14 29 15s-16 4-16 4S27 10.8 30 9.5z\"/><path class=\"r2\" d=\"M63 81.4c4 1.5 12.7 5 14 5s4-4 6.3-6S99 62 101.3 59.7L90.4 76s-5.4 9-7 11c-1.6 1.8-3.6 6-5.6 4.2S64.5 83.4 63 81.4z\"/><path class=\"r9\" d=\"M124.4 65.6l-13 27.5L81 108.3c5.2-4 24-15 25-16.5s10.3-14.4 11.3-17.6 5.4-9 5.7-12c0-1.3.3-3 .5-4.6z\"/></g></g><g class=\"gold\" transform=\"translate(140-120)\"><animateTransform attributeName=\"transform\" type=\"translate\" values=\"140-120;140-130;140-120\" dur=\"5s\" repeatCount=\"indefinite\" keyTimes=\"0;.5;1\" keySplines=\".5 0 .5 1;.5 0 .5 1\" calcMode=\"spline\"/><g><animateTransform attributeName=\"transform\" type=\"rotate\" values=\"0 64.475 54.96;-2.5 64.475 54.96;2.5 64.475 54.96;0 64.475 54.96\" dur=\"3s\" repeatCount=\"indefinite\" keyTimes=\"0;.25;.75;1\" keySplines=\"0 0 .5 1;.5 0 .5 1;.5 0 1 1\" calcMode=\"spline\"/><path class=\"g2\" d=\"M124.5 63c-2.4 3.6-19 13.5-21.3 15.6s-10 9.8-13.7 11.3-33 14.7-35.6 14.6-8.5-1.6-10-1.6-13.3 8.7-19.7 6.6c-8.7-3-22-14.5-22-14.5L29 56.6l34.6-42s55.8 0 62.4 13.5a28.6 28.6 0 0 1 2.6 9.2c1.6 11.3-2.3 23-4 25.8z\"/><path class=\"g3\" d=\"M129 42.5c-14.8-6-33.4-8.3-36.7-4.5-4.8 5.5-11.2 6.4-15 9.2S47 56.7 45.5 60.7c1-2.3 5.2-16.5 9.2-23a33.5 33.5 0 0 1 5.8-7c2.2-1.4 10.2-6 12.3-8.3l2-1a8.6 8.6 0 0 1 1.5-.3c4 .3 10.7.4 13.4.8S99 24 108 25.4s17.2 5.4 17.8 7.7a15.2 15.2 0 0 0 2.7 4 46.2 46.2 0 0 1 .4 5.5z\"/><path class=\"g2\" d=\"M88.6 40.4c-1.5 1.3-9 4.6-10.4 5.4l-7.2 4c-4 1-11.3 3.2-13 3.4A50.2 50.2 0 0 0 47 57c-1 1-6.8 11.3-8.5 12.4s-1.8 1.8-6.4 9.4c2.4-1 6-6 6.7-6.8s8.7-11 11-13 5.3-2.6 7.7-3c3.3-1 5-2 7.5-2.3 1.5 0 12.7-5.8 14.8-7a49.7 49.7 0 0 1 5.7-3 19.5 19.5 0 0 0 7-6c-.7.7-2.5 1.3-4 2.7z\"/><path class=\"g4\" d=\"M44 103c-1.5 0-13.3 8.7-19.7 6.6-8.8-3-22-14.5-22-14.5s12-9.5 15.4-7.4l2.7 1.7c6.4 4 20 12.2 23.6 13.8z\"/><path class=\"g5\" d=\"M44 103s-4.8.4-6.5-.4-5-2.8-6.4-3.4-7.2-3-8-3.4a14.5 14.5 0 0 0-5.8-1.3l3.2-5.2c6.3 4 20 12.2 23.6 13.7z\"/><path class=\"g6\" d=\"M126 28c-13.3-2.5-39.7-8.7-49.5-7a8.2 8.2 0 0 0-1.5.5c-.3 0-.7.2-1 .4l-1 .3a43.4 43.4 0 0 0-12.3 8.2 34 34 0 0 0-5.8 7c-3.2 5.2-6.5 15-8.2 20-.5 1.6-1 2.7-1 3.2-1 2.3-11.4 16.5-13.5 18-1 .8-5 7-9 12.2a45 45 0 0 1-3 3.7c-1.7 1.6-3 2.7-4.4 3-5.2.6-13.5-2.7-13.5-2.7-.3-1.5-4-19-1-23.2.4-1 2.5-4.2 5-8.4 7.6-11.8 19.7-31.4 21-34a51.5 51.5 0 0 1 3.4-4.3C35.7 19 44.5 9 49 6.6c1-.5 2-1 3.4-1.5C60.6 1.8 76-2 83 1.3c8 4 39.4 18.4 43 26.7z\"/><path class=\"g7\" d=\"M128.6 37a15.2 15.2 0 0 1-2.7-4c-.7-2.2-8.8-6.2-18-7.6s-15.6-3.2-18.3-3.6-9.4-.5-13.3-.7c1.2-1.4 7.6-3 11.7-1.5s9.7 2 14.2 3 16.2 2.3 18 3 4.3 0 5.7 2.5a28.7 28.7 0 0 1 2.6 9z\"/><path class=\"g7\" d=\"M126 28c-13.3-2.5-39.7-8.7-49.5-7a8.2 8.2 0 0 0-1.5.5c-.3 0-.7.2-1 .4l-1 .3a43.4 43.4 0 0 0-12.3 8.2 34 34 0 0 0-5.8 7c-3.2 5.2-6.5 15-8.2 20-.5 1.6-1 2.7-1 3.2-1 2.3-11.4 16.5-13.5 18-1 .8-5 7-9 12.2l-.3.3a43 43 0 0 1-3 3.5c-1.6 1.6-3 2.7-4.3 3-5 .6-13.4-2.7-13.4-2.7C2 93.7-1 79.8.3 73.8a5.3 5.3 0 0 1 .8-1.8c1-1.2 3-4.4 5.6-8.6 7.5-11.8 19.6-31.4 21-34a51.5 51.5 0 0 1 3.3-4.3C35.7 19 44.5 9 49 6.6c1-.5 2-1 3.4-1.5C60.6 1.8 76-2 83 1.3c8 4 39.4 18.4 43 26.7z\"/><path class=\"g3\" d=\"M9.4 66.3c1.6-.8 6.4 2 7.8 4s2.2 10.5 2.6 12 2.5 3 1.7 5-3 5.8-4.5 6.4-11.4 0-12-.8-2.5-15.5-2-17 3.6-8.4 6.4-9.7z\"/><path class=\"g7\" d=\"M73.3 21.7a2 2 0 0 1-.5.6c-2 2.2-10 7-12.2 8.2l-.6.3c4.8-5.3 8-11.5 6.8-15.2a2.5 2.5 0 0 0-.7-1c-2.3-2.7-9.6-2.7-13.7-4C47.8 9.2 39 18.6 31 25 35.7 19 44.5 9 49 6.6c1-.5 2-1 3.4-1.5 2.3 1 4 2.3 5 2.2 2.2-.2 8 2 12.7 4a5.7 5.7 0 0 1 3.3 3.6 10.6 10.6 0 0 1-.3 7z\"/></g></g><g class=\"tourmaline\" transform=\"translate(275-225)\"><animateTransform attributeName=\"transform\" type=\"translate\" values=\"275-225;275-205;275-225\" dur=\"11s\" repeatCount=\"indefinite\" keyTimes=\"0;.5;1\" keySplines=\".5 0 .5 1;.5 0 .5 1\" calcMode=\"spline\"/><g><animateTransform attributeName=\"transform\" type=\"rotate\" values=\"-2.5 61.925 51.855;2.5 61.925 51.855;-2.5 61.925 51.855\" dur=\"5s\" repeatCount=\"indefinite\" keyTimes=\"0;.5;1\" keySplines=\".5 0 .5 1;.5 0 .5 1\" calcMode=\"spline\"/><path class=\"t1\" d=\"M19.5 16.3c-10 5.7-24.4 52-18 62C14.2 85 55.8 75 55.8 75l.6-33.6z\"/><path class=\"t2\" d=\"M123.6 73c-1.3 6-13.2 21-24.4 25a81 81 0 0 1-10.6 2.8c-11.5 2.3-26.2 3.5-37 2.5-6.5-.7-46.6-20.8-50-25 0-4 21-4 21-4S35.3 56 38.2 56s71.7-16.6 79.8-11c3.4 4 7 22 5.8 28z\"/><path class=\"t3\" d=\"M117.8 45s-9.4 10.4-13 11.8c-13 5-58.2-1-66-.7h-.6L19.4 16.4S50.2 1.6 55.5 0a5 5 0 0 1 2.5.3C71.5 4 117.8 45 117.8 45z\"/><path class=\"t3\" d=\"M26.8 15.5c2-1.2 18.7-8 22-10.2s7.8-3.8 9.2-5a5 5 0 0 0-2.4-.2c-5.4 1.6-36 16.3-36 16.3S30.3 46.8 38 56c.6.3 1-.7 1-1.3-.3-2-2.8-6.4-4-8.2-1.5-2.5-10-23.3-11-26s.8-3.8 2.8-5z\"/><path class=\"t4\" d=\"M88.6 100.8c-11.5 2.4-26.2 3.6-37 2.5-6.5-.6-46.6-20.8-50-25 0-4 21-4 21-4s43.7 23 49 25c4.5 1.6 13 1 17 1.5z\"/></g></g></svg>\n"

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ComponentDoc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SiteHeading__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Intro__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocBestPractices__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DocExamples__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DocProps__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__DocSection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocSubNav__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DocThemeVariables__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DocWhenHowToUse__ = __webpack_require__(524);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */














var StyledDocHeading = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__SiteHeading__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return _defineProperty({
    marginBottom: 0,
    paddingTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(62), theme.SiteHeading_fontSize_2)

  }, theme.bp_moreSpacious, {
    fontSize: theme.SiteHeading_fontSize_2_wide,
    paddingTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["b" /* getNormalizedValue */])(Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(80), theme.SiteHeading_fontSize_2_wide)
  });
}).withProps({ level: 2 });

var DocHeading = function DocHeading(_ref3) {
  var children = _ref3.children,
      id = _ref3.id,
      restProps = _objectWithoutProperties(_ref3, ['children', 'id']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_8__DocSection__["a" /* default */],
    _extends({ element: 'div' }, restProps),
    _jsx(StyledDocHeading, {
      id: id
    }, void 0, children)
  );
};

var DocIntro = function DocIntro(_ref4) {
  var children = _ref4.children;
  return _jsx(__WEBPACK_IMPORTED_MODULE_8__DocSection__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__Intro__["a" /* default */], {}, void 0, children));
};

var _ref6 = _jsx(DocHeading, {
  id: 'examples'
}, void 0, 'Examples');

var _ref7 = _jsx(DocHeading, {
  id: 'api-and-theme'
}, void 0, 'API & Theme');

var _ref8 = _jsx(DocHeading, {
  id: 'usage'
}, void 0, 'Usage');

function ComponentDoc(_ref5) {
  var bestPractices = _ref5.bestPractices,
      componentTheme = _ref5.componentTheme,
      doc = _ref5.doc,
      examples = _ref5.examples,
      propsComment = _ref5.propsComment,
      title = _ref5.title,
      whenHowToUse = _ref5.whenHowToUse,
      restProps = _objectWithoutProperties(_ref5, ['bestPractices', 'componentTheme', 'doc', 'examples', 'propsComment', 'title', 'whenHowToUse']);

  var propDoc = doc.props;

  var subNavProps = {
    bestPractices: bestPractices,
    componentTheme: componentTheme,
    examples: examples,
    whenHowToUse: whenHowToUse
  };
  var rootProps = _extends({}, restProps);
  delete rootProps.subcomponent;
  delete rootProps.slug;
  var propProps = { propDoc: propDoc, propsComment: propsComment, title: title };
  var themeVariablesProps = {
    baseTheme: __WEBPACK_IMPORTED_MODULE_2__themes__["f" /* mineralTheme */],
    componentTheme: componentTheme,
    title: title
  };

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'div',
    rootProps,
    doc.description && _jsx(DocIntro, {}, void 0, doc.description),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__DocSubNav__["a" /* default */], subNavProps),
    examples && _ref6,
    examples && _jsx(__WEBPACK_IMPORTED_MODULE_6__DocExamples__["a" /* default */], {
      examples: examples
    }),
    _ref7,
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DocProps__["a" /* default */], propProps),
    componentTheme && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__DocThemeVariables__["a" /* default */], themeVariablesProps),
    (whenHowToUse || bestPractices) && _ref8,
    whenHowToUse && _jsx(__WEBPACK_IMPORTED_MODULE_11__DocWhenHowToUse__["a" /* default */], {
      content: whenHowToUse
    }),
    bestPractices && _jsx(__WEBPACK_IMPORTED_MODULE_5__DocBestPractices__["a" /* default */], {
      practices: bestPractices
    })
  );
}

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocBestPractices;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocPractice__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocSection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocSectionTitle__ = __webpack_require__(82);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var styles = {
  grid: function grid(_ref) {
    var theme = _ref.theme;
    return {
      marginTop: theme.baseline_3
    };
  },
  practice: function practice(_ref2) {
    var theme = _ref2.theme;
    return {
      marginBottom: theme.baseline_4
    };
  }
};

var Grid = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.grid);
var Practice = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__DocPractice__["a" /* default */], styles.practice);

var _ref4 = _jsx(__WEBPACK_IMPORTED_MODULE_4__DocSectionTitle__["a" /* default */], {
  id: 'best-practices'
}, void 0, 'Best Practices');

function DocBestPractices(_ref3) {
  var practices = _ref3.practices;

  return _jsx(__WEBPACK_IMPORTED_MODULE_3__DocSection__["a" /* default */], {}, void 0, _ref4, _jsx(Grid, {}, void 0, practices.map(function (practice, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
      Practice,
      _extends({ key: index }, practice),
      practice.description
    );
  })));
}

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocPractice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__packages_mineral_ui_icons_src_IconCheck__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__packages_mineral_ui_icons_src_IconClose__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Markdown__ = __webpack_require__(21);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */










var themes = {
  do: {
    borderColor: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].borderColor_success),
    color_text_primary: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_success,

    SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_success,
    SiteLink_color: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_success,
    SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_success,
    SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_success,
    SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_success
  },
  dont: {
    borderColor: __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].borderColor_danger,
    color_text_primary: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_danger),

    SiteLink_borderColor_focus: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_danger),
    SiteLink_color: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_danger),
    SiteLink_color_active: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_danger),
    SiteLink_color_hover: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_danger),
    SiteLink_color_focus: __WEBPACK_IMPORTED_MODULE_1_polished_lib_color_darken___default()(0.1, __WEBPACK_IMPORTED_MODULE_4__themes__["f" /* mineralTheme */].color_text_danger)
  }
};

var styles = {
  root: function root(_ref) {
    var theme = _ref.theme;
    return _defineProperty({}, theme.bp_interior_bestPracticesMultiColumn, {
      display: 'flex',
      alignItems: 'stretch',
      justifyContent: 'space-between'
    });
  },
  example: function example(_ref3) {
    var _ref4;

    var backgroundColor = _ref3.backgroundColor,
        theme = _ref3.theme;
    return _ref4 = {
      backgroundColor: backgroundColor,
      border: '1px solid ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.borderColor, 0.3),
      padding: theme.space_inset_md

    }, _defineProperty(_ref4, theme.bp_interior_bestPracticesMultiColumn, {
      width: 7 / 12 * 100 + '%'
    }), _defineProperty(_ref4, '& pre[class]', {
      margin: 0
    }), _ref4;
  },
  header: function header(_ref5) {
    var _ref6;

    var theme = _ref5.theme;
    return _ref6 = {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.borderColor, 0.1),
      borderTop: '3px solid ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.borderColor, 0.6),
      padding: theme.baseline_1 + ' ' + theme.baseline_2

    }, _defineProperty(_ref6, theme.bp_interior_bestPracticesMultiColumn, {
      borderLeft: '3px solid ' + __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.borderColor, 0.6),
      borderTop: 0,
      width: 5 / 12 * 100 + '%'
    }), _defineProperty(_ref6, '& ::selection', {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.color_text_primary, 0.2)
    }), _defineProperty(_ref6, '& > [role="img"]', {
      backgroundColor: __WEBPACK_IMPORTED_MODULE_2_polished_lib_color_rgba___default()(theme.borderColor, 0.2),
      borderRadius: theme.baseline_3,
      fill: theme.borderColor,
      float: 'left',
      height: theme.baseline_3,
      marginRight: theme.baseline_2,
      padding: parseFloat(theme.baseline_1) / 2 + 'em',
      position: 'relative',
      top: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(4), // Optical alignment
      width: theme.baseline_3
    }), _defineProperty(_ref6, '& > div', {
      overflow: 'hidden',

      '& > p:last-child': {
        marginBottom: 0
      }
    }), _ref6;
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('div', styles.root);
var Example = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('div', styles.example);
var Header = Object(__WEBPACK_IMPORTED_MODULE_3__styles__["a" /* createStyledComponent */])('div', styles.header);

function DocPractice(_ref7) {
  var backgroundColor = _ref7.backgroundColor,
      children = _ref7.children,
      className = _ref7.className,
      example = _ref7.example,
      type = _ref7.type;

  var iconProps = {
    size: Object(__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* pxToEm */])(50)
  };
  var icon = type === 'do' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__packages_mineral_ui_icons_src_IconCheck__["a" /* default */], iconProps) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__packages_mineral_ui_icons_src_IconClose__["a" /* default */], iconProps);

  return _jsx(Root, {
    className: className
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__themes__["a" /* ThemeProvider */], {
    theme: themes[type]
  }, void 0, _jsx(Header, {}, void 0, icon, _jsx(__WEBPACK_IMPORTED_MODULE_7__Markdown__["a" /* default */], {}, void 0, children))), _jsx(Example, {
    backgroundColor: backgroundColor
  }, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_4__themes__["a" /* ThemeProvider */], {}, void 0, typeof example === 'string' ? _jsx(__WEBPACK_IMPORTED_MODULE_7__Markdown__["a" /* default */], {}, void 0, example) : example)));
}

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocExamples;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ComponentDocExample__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocSection__ = __webpack_require__(38);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





function DocExamples(_ref) {
  var examples = _ref.examples;

  if (true) {
    examples = examples.filter(function (example) {
      return !example.hideFromProd;
    });
  }
  return _jsx(__WEBPACK_IMPORTED_MODULE_2__DocSection__["a" /* default */], {}, void 0, examples.map(function (example, index) {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__ComponentDocExample__["a" /* default */], _extends({ key: index }, example));
  }));
}

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Callout__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PropTable__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocSection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocSectionTitle__ = __webpack_require__(82);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */








var Callout = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__Callout__["a" /* default */], function (_ref) {
  var theme = _ref.theme;
  return {
    marginTop: theme.baseline_2
  };
});
var PropsComment = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('p', {
  fontStyle: 'italic'
});

var _ref3 = _jsx(PropsComment, {}, void 0, 'Undocumented properties will be applied to the root element.');

function DocProps(_ref2) {
  var propDoc = _ref2.propDoc,
      propsComment = _ref2.propsComment,
      title = _ref2.title;

  return _jsx(__WEBPACK_IMPORTED_MODULE_4__DocSection__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_5__DocSectionTitle__["a" /* default */], {
    id: 'props'
  }, void 0, title + ' Props'), _jsx('p', {}, void 0, 'The ', title, ' component takes the following React props.'), propDoc ? _jsx('div', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__PropTable__["a" /* default */], {
    propDoc: propDoc
  }), propsComment ? _jsx(Callout, {
    title: 'Note'
  }, void 0, propsComment) : _ref3) : _jsx(Callout, {
    title: 'Note'
  }, void 0, title + ' does not have properties of its own. Undocumented properties will be applied to the root element.'));
}

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PropTable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__packages_mineral_ui_icons_src_IconInfo__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popover__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Markdown__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table__ = __webpack_require__(87);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var styles = {
  codeValue: function codeValue(_ref) {
    var theme = _ref.theme;
    return {
      fontFamily: theme.fontFamily_monospace
    };
  },
  propName: function propName(_ref2) {
    var theme = _ref2.theme;
    return {
      fontWeight: theme.fontWeight_semiBold
    };
  },
  propP: {
    '& p': {
      margin: 0
    }
  },
  propRequired: function propRequired(_ref3) {
    var theme = _ref3.theme;
    return {
      backgroundColor: theme.backgroundColor_danger,
      borderRadius: theme.borderRadius_1,
      color: theme.color_white,
      display: 'inline-block',
      fontFamily: theme.fontFamily_monospace,
      padding: parseFloat(theme.space_inset_sm) / 2 + 'em ' + theme.space_inset_sm
    };
  },
  propType: function propType(_ref4) {
    var theme = _ref4.theme;
    return {
      color: theme.color_theme_90,
      fontFamily: theme.fontFamily_monospace
    };
  },
  propTypeButton: function propTypeButton(_ref5) {
    var theme = _ref5.theme;
    return {
      fontFamily: 'inherit',
      height: 'auto',
      padding: 0,

      '& > span > span': {
        lineHeight: theme.lineHeight,
        paddingLeft: theme.direction === 'ltr' ? 0 : null,
        paddingRight: theme.direction === 'rtl' ? 0 : null
      }
    };
  },
  propTypePopoverContent: function propTypePopoverContent(_ref6) {
    var theme = _ref6.theme;
    return {
      fontFamily: theme.fontFamily_monospace,
      fontSize: theme.fontSize_ui,
      maxWidth: '80vw',
      overflowX: 'auto',
      whiteSpace: 'pre'
    };
  },
  propValue: function propValue(_ref7) {
    var theme = _ref7.theme;
    return {
      border: '1px solid ' + theme.borderColor,
      height: '100%',
      resize: 'vertical',
      width: '100%'
    };
  },
  root: function root(_ref8) {
    var theme = _ref8.theme;
    return {
      margin: theme.space_stack_xl + ' 0 0',
      overflowX: 'auto'
    };
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.root);
var CodeValue = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.codeValue);
var PropName = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.propName);
var PropP = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_5__Markdown__["a" /* default */], styles.propP);
var PropRequired = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.propRequired);
var PropType = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('span', styles.propType);
var PropTypeButton = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */], styles.propTypeButton);
var PropTypePopoverContent = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])('div', styles.propTypePopoverContent);

var _ref10 = _jsx(PropRequired, {}, void 0, 'required');

function DefaultValue(_ref9) {
  var defaultValue = _ref9.defaultValue,
      required = _ref9.required;

  return required ? _ref10 : _jsx(CodeValue, {}, void 0, defaultValue);
}

function getDefaultValue(propDescription) {
  var _propDescription$defa = propDescription.defaultValue;
  _propDescription$defa = _propDescription$defa === undefined ? {} : _propDescription$defa;
  var value = _propDescription$defa.value;

  return value;
}

var _ref11 = _jsx(__WEBPACK_IMPORTED_MODULE_2__packages_mineral_ui_icons_src_IconInfo__["a" /* default */], {});

function getFlowType(propDescription) {
  var flowType = propDescription.flowType;
  var name = flowType.name,
      raw = flowType.raw,
      type = flowType.type;

  var usePopover = raw && raw.length > 25;

  if (name === 'Array') {
    type = 'Array';
  } else if (name === 'signature' && type === 'function') {
    type = 'Function';
  } else if (name === 'signature' && type === 'object') {
    type = 'Object';
  } else if (name === 'union') {
    type = 'Union';
    usePopover = flowType.elements.length > 4 || raw.startsWith('|');
    raw = raw.startsWith('|') ? raw.split('\n| ').join(',\n').replace('| ', '') : raw.split(' | ').join(',\n');
  } else if (name === 'undefined') {
    return 'unknown';
  } else {
    raw = name;
  }

  return usePopover ? _jsx(__WEBPACK_IMPORTED_MODULE_4__Popover__["a" /* default */], {
    content: _jsx(PropTypePopoverContent, {}, void 0, raw)
  }, void 0, _jsx(PropTypeButton, {
    iconEnd: _ref11,
    minimal: true,
    size: 'medium'
  }, void 0, type)) : raw;
}

function getPropTableRows(propDoc) {
  return Object.keys(propDoc).sort().map(function (name) {
    var propDescription = propDoc[name];

    // Filter out private props
    if (propDescription.description.startsWith('@Private')) {
      return null;
    }

    return _jsx(PropTableRow, {
      defaultValue: getDefaultValue(propDescription),
      description: propDescription.description,
      name: name,
      required: propDescription.required,
      type: getFlowType(propDescription)
    }, name);
  });
}

function PropTableRow(_ref12) {
  var defaultValue = _ref12.defaultValue,
      description = _ref12.description,
      name = _ref12.name,
      required = _ref12.required,
      type = _ref12.type;

  return _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["d" /* TableRow */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(PropName, {}, void 0, name)), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(PropType, {}, void 0, type)), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(DefaultValue, {
    defaultValue: defaultValue,
    required: required
  })), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["b" /* TableCell */], {}, void 0, _jsx(PropP, {}, void 0, description)));
}

var _ref14 = _jsx('thead', {}, void 0, _jsx('tr', {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {
  width: 10
}, 'prop', 'Name'), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {
  width: 15
}, 'type', 'Type'), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {
  width: 10
}, 'default', 'Default'), _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["c" /* TableHeaderCell */], {}, 'description', 'Description')));

function PropTable(_ref13) {
  var _ref13$propDoc = _ref13.propDoc,
      propDoc = _ref13$propDoc === undefined ? {} : _ref13$propDoc;

  return _jsx(Root, {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_6__Table__["a" /* Table */], {}, void 0, _ref14, _jsx('tbody', {}, void 0, getPropTableRows(propDoc))));
}

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocSubNav;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SiteLink__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocSection__ = __webpack_require__(38);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var styles = {
  navElement: function navElement(_ref) {
    var theme = _ref.theme;
    return _defineProperty({
      display: 'inline-block',
      fontFamily: theme.fontFamily_headline,
      fontWeight: theme.fontWeight_regular,
      marginRight: theme.space_inline_lg,
      textDecoration: 'none'

    }, theme.bp_moreSpacious, {
      fontSize: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(22)
    });
  },
  subnav: function subnav(_ref3) {
    var _ref4;

    var theme = _ref3.theme;
    return _ref4 = {
      marginTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(89), // to baseline
      position: 'sticky',
      top: -1,
      zIndex: theme.zIndex_800

    }, _defineProperty(_ref4, theme.bp_moreSpacious, {
      marginTop: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(108) // to baseline
    }), _defineProperty(_ref4, '& > div', {
      backgroundColor: theme.color_white,
      borderBottom: '2px solid ' + theme.borderColor,
      padding: Object(__WEBPACK_IMPORTED_MODULE_1__styles__["d" /* pxToEm */])(6) + ' 0'
    }), _ref4;
  }
};

var Root = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_3__DocSection__["a" /* default */], styles.subnav).withProps({
  element: 'nav'
});
var NavElement = Object(__WEBPACK_IMPORTED_MODULE_1__styles__["a" /* createStyledComponent */])(__WEBPACK_IMPORTED_MODULE_2__SiteLink__["a" /* default */], styles.navElement);

var _ref6 = _jsx(NavElement, {
  href: '#api-and-theme'
}, 'api-and-theme', 'API & Theme');

var _ref7 = _jsx(NavElement, {
  href: '#usage'
}, 'usage', 'Usage');

function DocSubNav(_ref5) {
  var bestPractices = _ref5.bestPractices,
      examples = _ref5.examples,
      whenHowToUse = _ref5.whenHowToUse,
      restProps = _objectWithoutProperties(_ref5, ['bestPractices', 'examples', 'whenHowToUse']);

  // there is no Examples h2, so we just link to the first example.
  var firstExampleId = 'examples';
  if (examples && examples.length > 0) {
    firstExampleId = examples[0].id;
  }

  var navElements = []; // only show the tabs menu if there is more than one tab
  if (examples && examples.length > 0) {
    navElements.push(_jsx(NavElement, {
      href: '#' + firstExampleId
    }, 'examples', 'Examples'));
  }

  navElements.push(_ref6);

  if (whenHowToUse || bestPractices) {
    navElements.push(_ref7);
  }

  return navElements.length > 1 && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    Root,
    restProps,
    navElements
  );
}

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocThemeVariables;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Markdown__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocSection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocSectionTitle__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VariableTable__ = __webpack_require__(243);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







var createKeyMirror = function createKeyMirror(obj) {
  var mirror = {};
  Object.keys(obj).forEach(function (key) {
    mirror[key] = '' + key;
  });
  return mirror;
};

var REGEX_IS_COLOR = /color|fill/i;

var getColor = function getColor(theme, variable, baseTheme) {
  return REGEX_IS_COLOR.test(variable) && baseTheme && baseTheme[theme[variable]];
};

var getValue = function getValue(theme, variable, baseTheme) {
  var baseThemeKeys = baseTheme && createKeyMirror(baseTheme);
  if (baseThemeKeys && baseThemeKeys[theme[variable]]) {
    return 'theme.' + theme[variable];
  } else if (typeof theme[variable] === 'number' && !RegExp(/lineHeight/i).test(variable)) {
    return theme[variable] + 'px';
  } else {
    return theme[variable];
  }
};

function DocThemeVariables(_ref) {
  var baseTheme = _ref.baseTheme,
      componentTheme = _ref.componentTheme,
      title = _ref.title;

  var baseThemeKeys = createKeyMirror(baseTheme);

  var theme = void 0;
  if (Array.isArray(componentTheme)) {
    theme = componentTheme.reduce(function (acc, themeFn) {
      return _extends({}, acc, themeFn(baseThemeKeys));
    }, {});
  } else {
    theme = componentTheme(baseThemeKeys);
  }

  return _jsx(__WEBPACK_IMPORTED_MODULE_2__DocSection__["a" /* default */], {}, void 0, _jsx(__WEBPACK_IMPORTED_MODULE_3__DocSectionTitle__["a" /* default */], {
    id: 'theme-variables'
  }, void 0, title + ' Theme Variables'), _jsx(__WEBPACK_IMPORTED_MODULE_1__Markdown__["a" /* default */], {}, void 0, 'These variables can be used as hooks to override this component\'s\n          style at either a\n          [local](/theming/#common-scenarios-theme-your-entire-app-theme-a-component)\n          or [global](/theming/#theming-common-scenarios-theme-your-entire-app)\n          level. The `theme` referenced below is whatever theme is available\n          from props to the instance of this component.'), _jsx(__WEBPACK_IMPORTED_MODULE_4__VariableTable__["a" /* default */], {
    baseTheme: baseTheme,
    theme: theme,
    value: getValue,
    valueColor: getColor
  }));
}

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DocWhenHowToUse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Markdown__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DocSection__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DocSectionTitle__ = __webpack_require__(82);
var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var _ref2 = _jsx(__WEBPACK_IMPORTED_MODULE_3__DocSectionTitle__["a" /* default */], {
  id: 'when-how-to-use'
}, void 0, 'When/How to Use');

function DocWhenHowToUse(_ref) {
  var content = _ref.content;

  return _jsx(__WEBPACK_IMPORTED_MODULE_2__DocSection__["a" /* default */], {}, void 0, _ref2, _jsx(__WEBPACK_IMPORTED_MODULE_1__Markdown__["a" /* default */], {}, void 0, content));
}

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ([{
  description: 'Avatar provides a graphic representation of an identity. It can display an image, text, or an icon.',
  slug: 'avatar',
  title: 'Avatar'
}, {
  description: 'Buttons trigger actions or state changes in your app. Choose a button color to match the intent of the action.',
  slug: 'button',
  title: 'Button'
}, [{
  description: 'Cards group related elements and actions. Use a Card to display content that doesn’t fit neatly into a table row or grid cell.',
  slug: 'card',
  title: 'Card'
}, {
  description: 'CardActions lays out actions like Buttons or Links in the body of the Card.',
  slug: 'card-actions',
  title: 'CardActions'
}, {
  description: 'CardBlock lays out content that’s not a title or an image in the body of the Card.',
  slug: 'card-block',
  title: 'CardBlock'
}, {
  description: 'CardDivider visually seperates sections of content in Card.',
  slug: 'card-divider',
  title: 'CardDivider'
}, {
  description: 'CardFooter provides a stateful extension to Card.',
  slug: 'card-footer',
  title: 'CardFooter'
}, {
  description: 'CardImages reinforce the intent of the Card. Images shouldn’t be used alone in a Card, but should be paired with a call to action and/or a CardTitle.',
  slug: 'card-image',
  title: 'CardImage'
}, {
  description: "CardStatus provides a standard way of displaying a Card's current status.",
  slug: 'card-status',
  title: 'CardStatus'
}, {
  description: 'CardTitles provide a consistently styled heading for your Card. Use a subtitle to provide supporting information for the data displayed in the Card.',
  slug: 'card-title',
  title: 'CardTitle'
}], [{
  description: 'Checkboxes allows users to select one or more options from a list. Use Checkboxes to accept multiple choice input from a user.',
  slug: 'checkbox',
  title: 'Checkbox'
}, {
  description: 'CheckboxGroup allows users to construct a group of Checkboxes and provides a simpler API than working with Checkbox directly',
  slug: 'checkbox-group',
  title: 'CheckboxGroup'
}], {
  description: 'Dropdowns display a hidden Menu, available upon user interaction. Use Dropdowns for non-primary actions only.',
  slug: 'dropdown',
  title: 'Dropdown'
}, [{
  description: 'FormFields wrap an input with a label and other features.  Wrap each input in your app with a FormField for appropriate accessibilty and styling.',
  slug: 'form-field',
  title: 'FormField'
}, {
  description: 'FormFieldsets wrap related FormFields and provide a legend.  Wrap related FormFields in a FormFieldset with a useful legend to help communicate relationships.',
  slug: 'form-fieldset',
  title: 'FormFieldset'
}, {
  description: 'FormFieldDividers separate FormFields.  FormFieldDividers are best used to call attention to a subtle difference between fields.',
  slug: 'form-field-divider',
  title: 'FormFieldDivider'
}], {
  description: 'Icons symbolize actions and objects in your interface. Use icons in combination with labels to help users more quickly process your UI.',
  slug: 'icon',
  title: 'Icon'
}, [{
  redirect: 'box',
  slug: 'layout',
  title: 'Layout'
}, {
  description: 'Box component provides an easy way to apply standardized size & space to your layout.',
  slug: 'box',
  title: 'Box'
}, {
  description: 'Flex component is used together with FlexItem to lay out other components in a flexible, and optionally responsive, manner.',
  slug: 'flex',
  title: 'Flex'
}, {
  description: 'FlexItem is used within Flex to lay out other components in your app.',
  slug: 'flex-item',
  title: 'FlexItem'
}, {
  description: 'StartEnd provides a simple way to align components to the start or end of a container.',
  slug: 'start-end',
  title: 'StartEnd'
}], {
  description: 'Links change the users’ browser location, and clearly express the intended destination.',
  slug: 'link',
  title: 'Link'
}, [{
  description: 'Menus group related actions or links for your user. Use Menus to toggle features or to group navigation options.',
  slug: 'menu',
  title: 'Menu'
}, {
  description: 'MenuDividers visually separate MenuGroups or individual MenuItems to increase usability in your Menu.',
  slug: 'menu-divider',
  title: 'MenuDivider'
}, {
  description: 'MenuGroups classify similar actions and provide labels.',
  slug: 'menu-group',
  title: 'MenuGroup'
}, {
  description: 'MenuItems represent an option in a Menu. Use MenuItems to trigger actions or navigate to a new location.',
  slug: 'menu-item',
  title: 'MenuItem'
}], {
  description: 'Popovers display supporting content when your user interacts with an associated trigger. Use Popovers to implement other custom behaviors or widgets.',
  slug: 'popover',
  title: 'Popover'
}, [{
  description: 'Radios allows users to select a single option from a list. Use Radios to accept limited choice input from a user.',
  slug: 'radio',
  title: 'Radio'
}, {
  description: 'RadioGroup allows users to construct a group of Radios and provides a simpler API than working with Radio directly',
  slug: 'radio-group',
  title: 'RadioGroup'
}], {
  description: 'Select is a form control that provides a list of options.',
  slug: 'select',
  title: 'Select'
}, {
  description: 'TextAreas accept data from the user.  Use a TextArea to accept potentially lengthy, free-form input from a user',
  slug: 'text-area',
  title: 'TextArea'
}, {
  description: 'TextInputs accept data from the user.  Use a TextInput to accept brief, free-form input from a user',
  slug: 'text-input',
  title: 'TextInput'
}, {
  description: 'ThemeProvider applies styles to a section of your app. Nesting enables multiple themes.',
  slug: 'theme-provider',
  title: 'ThemeProvider'
}, {
  description: 'Tooltips display supporting content when your user interacts with an associated trigger. Use Tooltips to implement other custom behaviors or widgets.',
  slug: 'tooltip',
  title: 'Tooltip'
}]);

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(527);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(529)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js!./index.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(528)(undefined);
// imports


// module
exports.push([module.i, "body{margin:0}main{display:block}", ""]);

// exports


/***/ })
],[259]);


// WEBPACK FOOTER //
// index.js